const section = new URLSearchParams(window.location.search).get("section") || "dashboard-home";

const tabMap = ["dashboard-home", "my-latest", "order-history", "my-account", "manage-subscriptions"];
tabMap.forEach(id => {
const el = document.getElementById(`${id}-tab`);
if (section === id && el) {
    el.classList.add("active");
}
// Also check for alternative button IDs for manage-subscriptions
if (section === id && id === "manage-subscriptions") {
    const serverBtn = document.getElementById(`${id}-tab-server`);
    const dynamicBtn = document.getElementById(`${id}-tab-dynamic`);
    const groupsBtn = document.getElementById(`${id}-tab-groups`);
    if (serverBtn) serverBtn.classList.add("active");
    if (dynamicBtn) dynamicBtn.classList.add("active");
    if (groupsBtn) groupsBtn.classList.add("active");
}
});

// Bundle configuration constants (hardcoded values used on storefront)
const BUNDLE_CONFIG = {
    bundleProductId: '7609867042879',
    bundleProductHandle: 'buld-a-box',
    bundleVariantId: '41218899902527',
    bundleCollectionId: '275143491647'  // Updated to match expected collection from error
};

const { createApp } = Vue
const app = createApp({
// Use different delimiters to avoid conflicts with Shopify Liquid
delimiters: ['${', '}'],
data() {
    return {
    // Customer information - will be loaded via API
    customerId: null,
    customerEmail: null,
    customerTags: [],
    defaultAddress: null,
    
    // Existing profile form - will be populated via API
    form: {
        firstName: '',
        lastName: '',
        email: '',
        acceptsMarketing: false
    },

    // New data for address management
    view: (section === 'dashboard-home' || section === 'my-latest') ? 'latest' : (section === 'order-history' ? 'history' : (section === 'manage-subscriptions' ? 'subscriptions' : (section === 'my-account' ? 'account' : 'latest'))),
    section: section, // URL section parameter for debugging
    currentUrl: window.location.href, // Current URL for debugging
    urlParams: window.location.search, // URL parameters for debugging
    addresses: [], // list of customer addresses
    editingAddress: null, // active address object being edited
    showPasswordForm: false,
    password: {
        new: '',
        confirm: ''
    },
    passwordError: '',
    passwordSuccess: false,
    lastOrder: null,
    orderHistory: [],
    orderPagination: {
        hasNextPage: false,
        isLoading: false,
        endCursor: null,
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        totalPages: 0
    },
    lastOrderLoading: false,
    unfulfilledOrders: [],
    unfulfilledOrdersLoading: false,
    upcomingDelivery: null, // Legacy - kept for backwards compatibility
    upcomingDeliveries: [], // Array of delivery groups (can have multiple on same date with different addresses)
    upcomingDeliveryLoading: false,
    dashboardHomeLoading: true, // Master loading state for Dashboard Home - start as true
    isDeveloper: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.search.includes('debug=1'),
    useFPR: true, // Failed Payment Recovery - when enabled, uses Recharge customer portal for payment updates
    reorderData: {
        isReordering: false,
        originalOrder: null,
        items: []
    },
    trackingData: {
        showTracking: {},  // Track which orders have tracking visible
        showEvents: {},    // Track which tracking info has events popup visible
    },
    orderDetailsExpanded: {}, // Track which order details are expanded on mobile
    orderCache: {}, // Cache for order data to improve performance
    lastCacheTime: null,
    
    // Loading states for better UX
    loadingStates: {
        updatingCustomer: false,
        savingAddress: false,
        removingAddress: false,
        settingDefault: false,
        changingPassword: false,
        addingToCart: false,
        skippingDelivery: false,
        editingDelivery: false,
        skippingSubscription: false,
        editingSubscription: false,
        shippingNow: false,
        savingBundleProducts: false,
        removingDiscount: false,
        applyingDiscount: false
    },
    
    // Error handling
    errors: {
        customer: '',
        address: '',
        password: '',
        cart: '',
        delivery: '',
        subscriptions: '',
        paymentMethods: ''
    },
    
    // Success messages
    successMessages: {
        customer: '',
        address: '',
        password: '',
        delivery: '',
        subscriptions: ''
    },
    
    // Recharge session management
    rechargeSession: null,
    rechargeSessionTimestamp: null,
    rechargeSessionTimeout: 55 * 60 * 1000, // 55 minutes (5 min buffer before 1 hour expiry)
    rechargeAuthInProgress: false,
    
    // Subscription management
    subscriptions: [],
    subscriptionsLoading: (section === 'manage-subscriptions'), // Start as true if we're on subscriptions page
    subscriptionGroups: [], // Grouped by address_id, next_charge_scheduled_at, charge_interval_frequency
    
    // One-time orders
    onetimes: [],
    onetimesLoading: false,
    
    // Charges data for Ship Now functionality
    charges: [],
    chargesLoading: false,
    
    // Payment methods management
    paymentMethods: [],
    paymentMethodsLoading: false,
    
    // Product data for image resolution
    products: [], // All products from Recharge API with image data
    inventoryData: [], // Inventory data for products from Shopify Admin API
    bundleSelections: [], // All bundle selections for matching with subscriptions
    
    // Customer address data
    customerAddresses: [], // All customer addresses from recharge.address.listAddresses API (source of truth)
    addressesWithPaymentMethods: [], // Addresses with payment methods included from listAddresses
    addressUpdateCounter: 0, // Counter to trigger Vue reactivity when addresses change
    
    // Update payment modal
    showUpdatePaymentModal: false,
    sendingUpdateLink: false,
    updatePaymentSuccess: false,
    updatePaymentError: '',
    currentPaymentGroup: null, // Store the group for which we're updating payment
    
    // Update address modal
    showUpdateAddressModal: false,
    savingAddress: false,
    updateAddressSuccess: false,
    updateAddressError: '',
    currentAddressGroup: null, // Store the group for which we're updating address
    editingAddressData: null, // Store the address data being edited
    addressMode: 'select', // 'select' = dropdown of saved addresses, 'custom' = enter new address
    selectedAddressId: null, // The Shopify address ID selected from dropdown
    isCurrentAddressSelected: true, // Whether the selected dropdown address matches the current Recharge address
    saveCustomAddressToBook: true, // Whether to save custom address to address book
    
    
    // Reschedule delivery modal
    showRescheduleModal: false,
    updatingDeliveryDate: false,
    updateDeliveryDateSuccess: false,
    updateDeliveryDateError: '',
    currentRescheduleGroup: null, // Store the group for which we're rescheduling
    selectedDeliveryDate: '', // Store the selected delivery date (YYYY-MM-DD format)
    
    // Cancel subscription confirmation modal
    showCancelConfirmationModal: false,
    cancellingSubscription: false,
    subscriptionToCancel: null, // Store the subscription group to be cancelled
    
    // Reactivate subscription modal for cancelled subscriptions
    showReactivateModal: false,
    reactivatingSubscription: false,
    reactivateSubscriptionSuccess: false,
    reactivateSubscriptionError: '',
    currentReactivateGroup: null, // Store the group for which we're reactivating
    selectedReactivateDate: '', // Store the selected next ship date (YYYY-MM-DD format)
    selectedReactivateFrequency: null, // Store the selected frequency
    
    // Delete subscription confirmation modal for cancelled subscriptions  
    showDeleteConfirmationModal: false,
    deletingSubscription: false,
    subscriptionToDelete: null, // Store the subscription group to be deleted
    
    // Ship Now confirmation modal
    showShipNowModal: false,
    subscriptionToShip: null,
    shippingNow: false,
    shipNowError: null,
    
    // Ship Now success modal
    showShipNowSuccessModal: false,
    shippedOrderDetails: null,
    
    // Bundle Products Modal
    showBundleProductsModal: false,
    loadingBundleProductsModal: false, // Loading state for bundle products modal
    showSelectedOnly: false, // Toggle for showing only selected products in bundle modal
    productSearchQuery: '', // Search query for filtering products
    bundleCollectionProducts: [], // Products available for bundle selection
    babCollectionProducts: [], // Products from "bab" collection for labeling
    selectedBundleProducts: [], // Products selected for the bundle
    
    // Temporary cart for Edit Products process
    temporaryCart: [], // Products with quantities for the current editing session
    originalCart: [], // Original state of the cart when edit modal opened (for change tracking)
    currentEditingGroup: null, // The subscription group currently being edited
    
    // Change tracking for edit products
    changeTracking: {
        enabled: false,
        originalState: [],
        currentState: [],
        changes: {
            added: [],
            removed: [],
            modified: []
        }
    },
    
    // General success modal for operations (cancel, delete, reactivate, etc.)
    showSuccessModal: false,
    successModalTitle: '',
    successModalMessage: '',
    successModalDetails: null,
    redirectToCartAfterModal: false,
    
    // General error modal for operations
    showErrorModal: false,
    errorModalTitle: '',
    errorModalMessage: '',
    errorModalDetails: null,
    
    // Add discount modal
    showAddDiscountModal: false,
    discountCodeInput: '',
    discountCodeError: '',
    currentDiscountGroup: null, // Track which group we're adding discount to
    
    // Available subscription frequencies
    availableFrequencies: [
        { unit: 'month', count: 1, text: 'Every Month' },
        { unit: 'week', count: 6, text: 'Every 6 weeks' },
        { unit: 'month', count: 2, text: 'Every 2 Months' },
        { unit: 'week', count: 10, text: 'Every 10 weeks' },
        { unit: 'month', count: 3, text: 'Every 3 Months' },
        { unit: 'month', count: 4, text: 'Every 4 Months' },
    ],
    }
},
computed: {
    hasValidItems() {
    return this.reorderData.items.some(item => item.quantity > 0);
    },
    isAddressFormValid() {
    if (!this.editingAddressData) return false;
    
    return !!(
        this.editingAddressData.address1 &&
        this.editingAddressData.city &&
        this.editingAddressData.province &&
        this.editingAddressData.zip
    );
    },
    showingText() {
    const currentlyLoaded = this.orderHistory.length;
    const totalCount = this.orderPagination.totalCount;
    
    // While loading initial data, don't show anything
    if (currentlyLoaded === 0 && this.orderPagination.isLoading) {
        return '';
    }
    
    // If no orders at all
    if (currentlyLoaded === 0 && totalCount === 0) {
        return 'No orders found';
    }
    
    // If we have orders but totalCount not yet available
    if (currentlyLoaded > 0 && totalCount === 0) {
        return `Showing ${currentlyLoaded} orders`;
    }
    
    // Full count available
    return `Showing ${currentlyLoaded} of ${totalCount} orders`;
    },
    // Sidebar active states
    isHomeActive() {
        return this.view === 'latest';
    },
    isHistoryActive() {
        return this.view === 'history';
    },
    isAccountActive() {
        return this.view === 'account';
    },
    isSubscriptionsActive() {
        return this.view === 'subscriptions';
    },
    // Check if user has any subscriptions (active or inactive)
    hasAnySubscriptions() {
        return (this.subscriptions && this.subscriptions.length > 0) || 
               (this.subscriptionGroups && this.subscriptionGroups.length > 0);
    },
    // Computed property for getting error charge details
    errorChargeDetails() {
        try {
            // First, check charges directly for any error status
            if (this.charges && this.charges.length > 0) {
                const errorCharge = this.charges.find(charge => 
                    charge.status && charge.status.toLowerCase() === 'error'
                );
                
                if (errorCharge) {
                    return {
                        error: errorCharge.error || 'Payment processing failed',
                        errorType: errorCharge.error_type || 'UNKNOWN',
                        chargeId: errorCharge.id,
                        retryDate: errorCharge.retry_date
                    };
                }
            }
            
            // Fallback to checking subscription groups
            if (this.subscriptionGroups && this.subscriptionGroups.length > 0) {
                const activeGroup = this.subscriptionGroups.find(group => {
                    const isCancelled = group.status === 'CANCELLED' || 
                                      group.status === 'cancelled' || 
                                      this.isGroupCancelled(group);
                    const hasFutureDate = group.next_charge_scheduled_at && 
                                         new Date(group.next_charge_scheduled_at) > new Date();
                    return !isCancelled && hasFutureDate;
                });
                
                if (activeGroup && activeGroup.matchingCharge && 
                    activeGroup.matchingCharge.status && 
                    activeGroup.matchingCharge.status.toLowerCase() === 'error') {
                    return {
                        error: activeGroup.matchingCharge.error || 'Payment processing failed',
                        errorType: activeGroup.matchingCharge.error_type || 'UNKNOWN',
                        chargeId: activeGroup.matchingCharge.id,
                        retryDate: activeGroup.matchingCharge.retry_date
                    };
                }
            }
            
            return null;
        } catch (error) {
            console.error('Error getting error charge details:', error);
            return null;
        }
    },
    // Computed property for next subscription charge status
    nextSubscriptionChargeStatus() {
        try {
            console.log('🔍 Computing nextSubscriptionChargeStatus');
            console.log('Charges:', this.charges ? this.charges.length : 0);
            console.log('Subscriptions:', this.subscriptions ? this.subscriptions.length : 0);
            console.log('Groups:', this.subscriptionGroups ? this.subscriptionGroups.length : 0);
            
            // First, check charges directly for any error status
            if (this.charges && this.charges.length > 0) {
                const errorCharge = this.charges.find(charge => 
                    charge.status && charge.status.toLowerCase() === 'error'
                );
                
                if (errorCharge) {
                    console.log('🔴 ERROR charge found!');
                    return 'error';
                }
            }
            
            // Fallback to checking subscription groups if they're loaded
            if (this.subscriptionGroups && this.subscriptionGroups.length > 0) {
                const activeGroup = this.subscriptionGroups.find(group => {
                    const isCancelled = group.status === 'CANCELLED' || 
                                      group.status === 'cancelled' || 
                                      this.isGroupCancelled(group);
                    const hasFutureDate = group.next_charge_scheduled_at && 
                                         new Date(group.next_charge_scheduled_at) > new Date();
                    return !isCancelled && hasFutureDate;
                });
                
                if (activeGroup && activeGroup.matchingCharge && 
                    activeGroup.matchingCharge.status && 
                    activeGroup.matchingCharge.status.toLowerCase() === 'error') {
                    console.log('🔴 ERROR in active group!');
                    return 'error';
                }
                
                if (activeGroup && activeGroup.matchingCharge && activeGroup.matchingCharge.status) {
                    return activeGroup.matchingCharge.status.toLowerCase();
                }
            }
            
            console.log('📊 Defaulting to scheduled');
            return 'scheduled';
        } catch (error) {
            console.error('Error computing next subscription charge status:', error);
            return 'scheduled';
        }
    }
},
watch: {
    // Prevent body scrolling when modal is open
    showBundleProductsModal(isOpen) {
        if (isOpen) {
            // Store current scroll position
            this.scrollY = window.scrollY;
            // Prevent body scroll
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this.scrollY}px`;
            document.body.style.width = '100%';
        } else {
            // Restore body scroll
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            // Restore scroll position
            window.scrollTo(0, this.scrollY || 0);
        }
    }
},
mounted() {
    this.loadCustomer().then(() => {
    if (this.view === 'latest') {
        // Master loading state is already true from initialization
        // Load all data in parallel and wait for everything to complete
        Promise.all([
            this.fetchLastOrder().catch(err => console.error('Last order load failed:', err)),
            this.fetchUnfulfilledOrders().catch(err => console.error('Unfulfilled orders load failed:', err)),
            this.loadAllSubscriptions().catch(err => console.error('Subscriptions load failed:', err)),
            this.loadProductsForImageResolution().catch(err => console.error('Products load failed:', err)),
            this.loadAddressesWithPaymentMethods().catch(err => console.error('Payment methods load failed:', err)),
            this.loadPaymentMethods().catch(err => console.error('Payment methods list load failed:', err))
        ]).then(() => {
            // After subscriptions and products are loaded, fetch upcoming delivery
            return this.fetchUpcomingDelivery().catch(err => console.error('Upcoming delivery load failed:', err));
        }).finally(() => {
            // Clear loading state when everything is done
            this.dashboardHomeLoading = false;
            console.log('✅ Dashboard Home fully loaded');
        });
    } else {
        // Not on Dashboard Home, set loading to false immediately
        this.dashboardHomeLoading = false;
    }
    
    if (this.view === 'history') {
        this.fetchOrderHistory();
    }
    if (this.view === 'subscriptions') {
        this.loadAllSubscriptions();
        this.loadCustomerAddresses();
        this.loadAddressesWithPaymentMethods();
        this.loadPaymentMethods();
        this.fetchLastOrder().catch(err => console.error('Last order load failed on subscriptions page:', err));
        this.fetchUnfulfilledOrders().catch(err => console.error('Unfulfilled orders load failed on subscriptions page:', err));
    }
    if (this.view === 'account') {
        // Load subscriptions on account page to check if user has subscriptions for address save warning
        this.loadAllSubscriptions().catch(err => console.error('Subscriptions load failed on account page:', err));
        this.loadAddressesWithPaymentMethods();
    }
    
    this.initializeRecharge();
    }).catch(error => {
    this.initializeRecharge();
    });
},
methods: {
    // API Route Helper
    apiUrl(endpoint) {
    return `/a/angelinos/api${endpoint}`;
    },
    
    // Filter products based on search query and showSelectedOnly toggle
    getFilteredProducts() {
        // Start with a copy to avoid mutating the original array
        let filtered = [...this.bundleCollectionProducts];
        
        // Filter out "Not Available" products (products with type "other")
        filtered = filtered.filter(p => this.getItemType(p) !== 'other');
        
        // Apply search filter if search query exists (check product title, variant title, and tags)
        const searchQuery = (this.productSearchQuery || '').trim();
        if (searchQuery.length > 0) {
            const searchLower = searchQuery.toLowerCase();
            filtered = filtered.filter(product => {
                // Match against product title (case-insensitive)
                const titleMatch = product.title && product.title.toLowerCase().includes(searchLower);
                
                // Match against variant title (case-insensitive)
                const variantMatch = product.variant_title && 
                                   product.variant_title !== 'Default Title' && 
                                   product.variant_title.toLowerCase().includes(searchLower);
                
                // Match against tags (case-insensitive)
                let tagsMatch = false;
                if (product.tags) {
                    // Tags could be a string (comma-separated) or an array
                    if (typeof product.tags === 'string') {
                        tagsMatch = product.tags.toLowerCase().includes(searchLower);
                    } else if (Array.isArray(product.tags)) {
                        tagsMatch = product.tags.some(tag => 
                            tag && tag.toLowerCase().includes(searchLower)
                        );
                    }
                }
                
                // Return true if title, variant, or tags match
                return titleMatch || variantMatch || tagsMatch;
            });
        }
        
        // Apply showSelectedOnly filter
        if (this.showSelectedOnly) {
            filtered = filtered.filter(p => this.getProductQuantityInCart(p) > 0);
        }
        
        return filtered;
    },
    
    /**
     * Load customer data from server
     */
    async loadCustomer() {
    try {
        const response = await fetch(this.apiUrl('/get-customer'), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
        });
        
        if (!response.ok) {
        // Redirect to login if unauthorized
        if (response.status === 401 || response.status === 403) {
            window.location.href = '/account/login';
            return;
        }
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        
        const data = await response.json();
        
        if (!data.success) {
        throw new Error(data.error || 'Failed to load customer data');
        }
        
        // Check if customer data exists
        if (!data.customer || !data.customer.id) {
        console.error('No customer data returned');
        window.location.href = '/account/login';
        return;
        }
        
        this.customerId = data.customer.id;
        this.customerEmail = data.customer.email;
        this.customerTags = data.customer.tags || [];
        this.defaultAddress = data.customer.defaultAddress || null;
        
        this.form.firstName = data.customer.firstName || '';
        this.form.lastName = data.customer.lastName || '';
        this.form.email = data.customer.email || '';
        this.form.acceptsMarketing = data.customer.acceptsMarketing || false;
        
    } catch (error) {
        console.error('Error loading customer:', error);
        // Redirect to login on any error
        window.location.href = '/account/login';
        throw error;
    }
    },
    
    // ========================================
    // RECHARGE SESSION MANAGEMENT
    // ========================================
    
    /**
     * Initialize Recharge authentication on page load
     */
    async initializeRecharge() {
    try {
        await this.ensureRechargeAuth();
    } catch (error) {
        // Handle error silently or with minimal logging
    }
    },
    
    /**
     * Ensure we have a valid Recharge session
     * This method handles session validation, refresh, and creation
     */
    async ensureRechargeAuth() {
    // Check if we already have a valid session
    if (this.isRechargeSessionValid()) {
        return this.rechargeSession;
    }
    
    // Prevent multiple simultaneous auth attempts
    if (this.rechargeAuthInProgress) {
        // Wait for ongoing authentication to complete
        while (this.rechargeAuthInProgress) {
        await new Promise(resolve => setTimeout(resolve, 100));
        }
        
        // Check again if session is now valid
        if (this.isRechargeSessionValid()) {
        return this.rechargeSession;
        }
    }
    
    // Perform authentication
    return await this.authenticateRecharge();
    },
    
    /**
     * Check if current Recharge session is valid
     */
    isRechargeSessionValid() {
    if (!this.rechargeSession || !this.rechargeSessionTimestamp) {
        return false;
    }
    
    const now = Date.now();
    const sessionAge = now - this.rechargeSessionTimestamp;
    
    // Consider session invalid if older than our timeout (55 minutes)
    return sessionAge < this.rechargeSessionTimeout;
    },
    
    /**
     * Authenticate with Recharge API
     */
    async authenticateRecharge() {
    this.rechargeAuthInProgress = true;
    
    try {
        if (typeof recharge === 'undefined') {
        throw new Error('Recharge JavaScript SDK not loaded');
        }
        
        this.rechargeSession = await recharge.auth.loginShopifyAppProxy().catch(error => {
        throw error;
        });
        
        this.rechargeSessionTimestamp = Date.now();
        return this.rechargeSession;
        
    } catch (error) {
        console.error('Failed to authenticate with Recharge:', error);
        
        // Clear invalid session data
        this.rechargeSession = null;
        this.rechargeSessionTimestamp = null;
        
        throw error;
    } finally {
        this.rechargeAuthInProgress = false;
    }
    },
    
    /**
     * Wrapper for Recharge API calls with automatic re-authentication
     * Use this for all Recharge API calls to handle session expiry gracefully
     */
    async callRechargeAPI(apiCall) {
    try {
        await this.ensureRechargeAuth();
        return await apiCall(this.rechargeSession);
        
    } catch (error) {
        if (this.isRechargeAuthError(error)) {
        this.rechargeSession = null;
        this.rechargeSessionTimestamp = null;
        
        try {
            await this.ensureRechargeAuth();
            return await apiCall(this.rechargeSession);
        } catch (retryError) {
            throw retryError;
        }
        }
        
        throw error;
    }
    },
    
    /**
     * Check if an error is likely due to authentication issues
     */
    isRechargeAuthError(error) {
    if (!error) return false;
    
    const errorMessage = error.message?.toLowerCase() || '';
    const errorStatus = error.status || error.statusCode;
    
    // Common indicators of auth errors
    return (
        errorStatus === 401 ||
        errorStatus === 403 ||
        errorMessage.includes('unauthorized') ||
        errorMessage.includes('authentication') ||
        errorMessage.includes('invalid session') ||
        errorMessage.includes('expired')
    );
    },
    
    /**
     * Load products for image resolution (lighter version for Dashboard Home view)
     */
    async loadProductsForImageResolution() {
        try {
            const products = await this.getAllProducts();
            this.products = products;
        } catch (error) {
            // Don't show error to user - this is a background enhancement
        }
    },

    /**
     * Load all subscriptions with pagination and group them
     */
    async loadAllSubscriptions() {
    // Allow the method to run even if subscriptionsLoading is true (initial state)
    // But prevent duplicate concurrent calls
    if (this.subscriptionsLoading && this.subscriptionGroups.length > 0) return;
    
    this.subscriptionsLoading = true;
    this.errors.subscriptions = '';
    
    try {
        const allSubscriptions = await this.getAllSubscriptionsWithPagination();
        const bundleSelections = await this.getAllBundleSelections();
        this.bundleSelections = bundleSelections;
        const products = await this.getAllProducts();
        this.products = products;
        const subscriptionsWithBundles = this.linkBundleSelectionsToSubscriptions(allSubscriptions, bundleSelections, products);
        
        // If we only got 1 subscription, let's try alternative approaches
        if (subscriptionsWithBundles.length <= 1) {
        console.log('Only found 1 or fewer subscriptions, trying alternative approaches...');
        
        try {
            // Try getting all charges to see if there are more subscriptions referenced
            const charges = await this.callRechargeAPI(async (session) => {
            if (recharge.customer && typeof recharge.customer.getCharges === 'function') {
                return await recharge.customer.getCharges(session, { limit: 50 });
            }
            return null;
            });
            
            if (charges && charges.charges) {
            console.log('Found charges:', charges.charges.length);
            const uniqueSubscriptionIds = [...new Set(charges.charges.map(charge => charge.subscription_id).filter(Boolean))];
            console.log('Unique subscription IDs from charges:', uniqueSubscriptionIds);
            }
        } catch (error) {
            console.log('Could not fetch charges:', error);
        }
        
        try {
            // Try getting orders to see subscription relationships
            const orders = await this.callRechargeAPI(async (session) => {
            if (recharge.customer && typeof recharge.customer.getOrders === 'function') {
                return await recharge.customer.getOrders(session, { limit: 50 });
            }
            return null;
            });
            
            if (orders && orders.orders) {
                // Additional processing could go here if needed
            }
        } catch (error) {
            // Ignore orders fetch errors
        }
        }
        
        this.subscriptions = subscriptionsWithBundles;
        
        await this.loadOnetimes();
        await this.loadCharges();
        await this.loadCustomerAddresses();
        
        this.subscriptionGroups = this.groupSubscriptionsAndOnetimes(subscriptionsWithBundles, this.onetimes, this.charges);
        
        // Fetch detailed pricing for each group that has a matching charge
        console.log('📊 Fetching detailed pricing for subscription groups...');
        for (const group of this.subscriptionGroups) {
            if (group.matchingCharge) {
                const pricing = await this.fetchGroupChargePricing(group);
                if (pricing) {
                    group.chargePricing = pricing;
                    console.log(`✅ Pricing loaded for group with charge ${pricing.chargeId}`);
                } else {
                    console.log(`⚠️ Could not load pricing for group with charge ${group.matchingCharge.id}`);
                }
            }
        }
        console.log('📊 Finished loading pricing for all groups');
        
        if (this.subscriptionGroups.length > 0) {
        this.subscriptionGroups[0].showDetails = true;
        }
        
        // Handle subscription button visibility based on actual data
        this.updateSubscriptionButtonVisibility();
    } catch (error) {
        console.error('Failed to load subscriptions:', error);
        this.errors.subscriptions = 'Failed to load subscriptions. Please try again.';
    } finally {
        this.subscriptionsLoading = false;
    }
    },

    /**
     * Load customer with addresses to display address details instead of just address IDs
     */
    async loadCustomerAddresses() {
    try {
        const result = await this.callRechargeAPI(async (session) => {
        if (typeof recharge !== 'undefined') {
            if (recharge.address && typeof recharge.address.listAddresses === 'function') {
            const addressResult = await recharge.address.listAddresses(session, {
                customer_id: this.customerId
            });
            return { addresses: addressResult.addresses || [] };
            } else {
            throw new Error('Address listing API not available');
            }
        } else {
            throw new Error('Recharge API not available');
        }
        });
        
        if (result && result.addresses && Array.isArray(result.addresses)) {
        this.customerAddresses = result.addresses;
        this.addressUpdateCounter++;
        } else {
        this.customerAddresses = [];
        this.addressUpdateCounter++;
        }
        
    } catch (error) {
        this.customerAddresses = [];
        this.addressUpdateCounter++;
    }
    
    if (!this.customerAddresses || this.customerAddresses.length === 0) {
        this.customerAddresses = [
        {
            "id": 208523680,
            "address1": "1611 Perrino Place",
            "address2": null,
            "city": "Los Angeles",
            "country_code": "US",
            "first_name": "Brooke",
            "last_name": "Fryer",
            "phone": "+12132132131",
            "province": "California",
            "zip": "90023"
        },
        {
            "id": 201525741,
            "address1": "12115 Pacific St",
            "address2": null,
            "city": "Santa Fe Springs",
            "country_code": "US",
            "first_name": "Brooke",
            "last_name": "Fryer",
            "phone": null,
            "province": "California",
            "zip": "90670"
        }
        ];
    }
    },

    /**
     * Load customer addresses with payment methods
     */
    async loadAddressesWithPaymentMethods() {
        try {
            console.log('💳 Loading addresses with payment methods...');
            
            const result = await this.callRechargeAPI(async (session) => {
                console.log('💳 Inside callRechargeAPI for addresses with payment methods');
                
                if (typeof recharge !== 'undefined' && recharge.address) {
                    console.log('💳 recharge.address exists');
                    
                    if (typeof recharge.address.listAddresses === 'function') {
                        try {
                            console.log('📞 Trying recharge.address.listAddresses() with payment_methods include');
                            const addressResult = await recharge.address.listAddresses(session, { 
                                customer_id: this.customerId,
                                limit: 250, 
                                sort_by: 'id-asc', 
                                include: 'payment_methods' 
                            });
                            console.log('✅ listAddresses result:', addressResult);
                            return addressResult;
                        } catch (error) {
                            console.error('❌ Error calling listAddresses:', error);
                            return null;
                        }
                    } else {
                        console.error('❌ recharge.address.listAddresses is not a function');
                        return null;
                    }
                } else {
                    console.error('❌ recharge.address not available');
                    return null;
                }
            });
            
            if (result?.addresses) {
                this.addressesWithPaymentMethods = result.addresses;
                return this.addressesWithPaymentMethods;
            } else {
                this.addressesWithPaymentMethods = [];
                return [];
            }
            
        } catch (error) {
            this.addressesWithPaymentMethods = [];
            return [];
        }
    },

    /**
     * Get payment method for a subscription
     */
    getPaymentMethodForSubscription(subscription) {
        try {
            if (!this.addressesWithPaymentMethods || this.addressesWithPaymentMethods.length === 0) {
                return null;
            }
            
            if (!this.paymentMethods || this.paymentMethods.length === 0) {
                return null;
            }
            
            // Find the address that matches the subscription's address_id
            const address = this.addressesWithPaymentMethods.find(addr => 
                addr.id === subscription.address_id || 
                addr.id == subscription.address_id ||
                String(addr.id) === String(subscription.address_id)
            );
            
            if (!address || !address.payment_method_id) {
                return null;
            }
            
            // Find the payment method by matching payment_method_id
            const paymentMethod = this.paymentMethods.find(pm => 
                pm.id === address.payment_method_id || 
                pm.id == address.payment_method_id ||
                String(pm.id) === String(address.payment_method_id)
            );
            
            if (!paymentMethod) {
                return null;
            }
            
            return {
                type: paymentMethod.payment_type,
                processor_name: paymentMethod.processor_name,
                payment_details: paymentMethod.payment_details,
                payment_type: paymentMethod.payment_type
            };
            
        } catch (error) {
            console.error('❌ Error getting payment method for subscription:', error);
            return null;
        }
    },

    /**
     * Get payment method for upcoming delivery
     */
    getPaymentMethodForUpcomingDelivery() {
        try {
            console.log('🔍 getPaymentMethodForUpcomingDelivery called');
            console.log('upcomingDelivery:', this.upcomingDelivery);
            console.log('subscriptions count:', this.subscriptions ? this.subscriptions.length : 0);
            console.log('addressesWithPaymentMethods count:', this.addressesWithPaymentMethods ? this.addressesWithPaymentMethods.length : 0);
            console.log('paymentMethods count:', this.paymentMethods ? this.paymentMethods.length : 0);
            
            // Try to find the subscription for the upcoming delivery
            let subscription = null;
            
            // First, try to get subscription by ID from upcomingDelivery
            if (this.upcomingDelivery && this.upcomingDelivery.subscriptionId) {
                console.log('Looking for subscription with ID:', this.upcomingDelivery.subscriptionId);
                subscription = this.subscriptions && this.subscriptions.find(sub => 
                    sub.id === this.upcomingDelivery.subscriptionId ||
                    String(sub.id) === String(this.upcomingDelivery.subscriptionId)
                );
                console.log('Found subscription by ID:', subscription);
            }
            
            // If not found, try the first active subscription
            if (!subscription && this.subscriptions && this.subscriptions.length > 0) {
                console.log('Looking for first active subscription');
                subscription = this.subscriptions.find(sub => 
                    sub.status === 'ACTIVE' || sub.status === 'active'
                );
                console.log('Found active subscription:', subscription);
            }
            
            // If we have a subscription, use the existing method
            if (subscription) {
                console.log('Calling getPaymentMethodForSubscription with:', subscription);
                const result = this.getPaymentMethodForSubscription(subscription);
                console.log('getPaymentMethodForSubscription returned:', result);
                return result;
            }
            
            console.log('No subscription found, returning null');
            return null;
            
        } catch (error) {
            console.error('❌ Error getting payment method for upcoming delivery:', error);
            return null;
        }
    },

    /**
     * Format payment method for display
     */
    formatPaymentMethod(paymentMethod) {
        if (!paymentMethod) {
            return 'No payment method';
        }
        
        try {
            let cardType = '';
            
            // If it's a credit card and we have brand info, use the brand
            if (paymentMethod.payment_type === 'CREDIT_CARD' && 
                paymentMethod.payment_details && 
                paymentMethod.payment_details.brand) {
                cardType = paymentMethod.payment_details.brand;
            } 
            // For PayPal or other payment types, use the payment_type
            else if (paymentMethod.payment_type) {
                // Convert payment type to a more readable format
                if (paymentMethod.payment_type === 'PAYPAL') {
                    cardType = 'PayPal';
                } else if (paymentMethod.payment_type === 'CREDIT_CARD') {
                    cardType = 'Credit Card';
                } else {
                    // For other payment types, format them nicely
                    cardType = paymentMethod.payment_type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                }
            }
            // Final fallback
            else {
                cardType = 'Unknown Payment Method';
            }
            
            // Get last 4 digits (only for credit cards)
            let last4 = '';
            if (paymentMethod.payment_type === 'CREDIT_CARD' && paymentMethod.payment_details) {
                if (paymentMethod.payment_details.last4) {
                    last4 = paymentMethod.payment_details.last4;
                } else if (paymentMethod.payment_details.last_four) {
                    last4 = paymentMethod.payment_details.last_four;
                }
            }
            
            // Format display text
            return last4 ? `${cardType} •••• ${last4}` : cardType;
            
        } catch (error) {
            console.error('❌ Error formatting payment method:', error);
            return 'Unknown Payment Method';
        }
    },

    /**
     * Get address details by address ID
     */
    getAddressDetails(addressId) {
    if (!addressId || !this.customerAddresses || this.customerAddresses.length === 0) {
        return null;
    }
    
    // Try both exact match and string/number conversion
    return this.customerAddresses.find(address => {
        return address.id === addressId || 
                address.id == addressId || 
                String(address.id) === String(addressId);
    });
    },

    /**
     * Format address for display
     */
    formatAddress(addressId) {
    this.addressUpdateCounter;
    
    const address = this.getAddressDetails(addressId);
    
    if (!address) {
        return `Address ID: ${addressId}`;
    }
    
    const parts = [];
    
    if (address.first_name || address.last_name) {
        parts.push(`${address.first_name || ''} ${address.last_name || ''}`.trim());
    }
    
    // Add only address1 (address line 1)
    if (address.address1) {
        parts.push(address.address1);
    }
    
    const formattedAddress = parts.join(' • ');
    console.log('📍 Final formatted address:', formattedAddress);
    return formattedAddress;
    },

    /**
     * Format customer name for display
     */
    formatCustomerName(addressId) {
        const address = this.getAddressDetails(addressId);
        
        if (!address) {
            return `Customer ID: ${addressId}`;
        }
        
        // Return formatted name
        if (address.first_name || address.last_name) {
            return `${address.first_name || ''} ${address.last_name || ''}`.trim();
        }
        
        return 'Customer';
    },

    /**
     * Convert country code to country name
     */
    getCountryName(countryCode) {
    const countryMap = {
        'US': 'United States',
        'CA': 'Canada',
        'GB': 'United Kingdom',
        'AU': 'Australia',
        'DE': 'Germany',
        'FR': 'France',
        'IT': 'Italy',
        'ES': 'Spain',
        'NL': 'Netherlands',
        'BE': 'Belgium',
        'CH': 'Switzerland',
        'AT': 'Austria',
        'SE': 'Sweden',
        'NO': 'Norway',
        'DK': 'Denmark',
        'FI': 'Finland',
        'JP': 'Japan',
        'MX': 'Mexico',
        'BR': 'Brazil',
        'AR': 'Argentina',
        'CL': 'Chile',
        'CO': 'Colombia',
        'PE': 'Peru',
        'NZ': 'New Zealand',
        'IE': 'Ireland',
        'PT': 'Portugal',
        'PL': 'Poland',
        'CZ': 'Czech Republic',
        'HU': 'Hungary',
        'RO': 'Romania',
        'BG': 'Bulgaria',
        'HR': 'Croatia',
        'SI': 'Slovenia',
        'SK': 'Slovakia',
        'EE': 'Estonia',
        'LV': 'Latvia',
        'LT': 'Lithuania'
    };
    
    return countryMap[countryCode] || countryCode;
    },

    /**
     * Get fallback product image for bundle items
     */
    getProductImageFallback(item) {
    // Try to find the product in our products array by external_product_id
    if (item.external_product_id && this.products && this.products.length > 0) {
        const product = this.products.find(p => 
        p.external_product_id === item.external_product_id ||
        String(p.external_product_id) === String(item.external_product_id)
        );
        
        if (product && product.image) {
        console.log('Found fallback image from products array:', product.image);
        return product.image;
        }
    }
    
    // Generic coffee placeholder image as final fallback
    return 'https://angelinos.com/cdn/shop/products/placeholder-coffee_400x.jpg?v=1639583847';
    },

    /**
     * Load all one-time orders
     */
    async loadOnetimes() {
    console.log('🚀 loadOnetimes() method called');
    
    if (this.onetimesLoading) {
        console.log('⏸️ Already loading one-time orders, skipping');
        return;
    }
    
    this.onetimesLoading = true;
    this.errors.subscriptions = '';
    
    try {
        console.log('=== LOADING ONE-TIME ORDERS ===');
        
        // Check what's available in the recharge object
        console.log('🔍 Checking recharge object structure...');
        console.log('recharge object exists:', !!window.recharge);
        if (window.recharge) {
        console.log('recharge keys:', Object.keys(window.recharge));
        if (window.recharge.onetime) {
            console.log('recharge.onetime exists:', !!window.recharge.onetime);
            console.log('recharge.onetime methods:', Object.keys(window.recharge.onetime));
        }
        if (window.recharge.onetimes) {
            console.log('recharge.onetimes exists:', !!window.recharge.onetimes);
            console.log('recharge.onetimes methods:', Object.keys(window.recharge.onetimes));
        }
        }
        
        // Load one-time orders using the callRechargeAPI pattern
        const result = await this.callRechargeAPI(async (session) => {
        console.log('✅ Session for onetimes:', session ? 'Valid session' : 'No session');
        
        if (recharge.onetime && typeof recharge.onetime.listOnetimes === 'function') {
            console.log('📞 Using recharge.onetime.listOnetimes()');
            return await recharge.onetime.listOnetimes(session, {
            limit: 250,
            sort_by: 'id-asc',
            });
        } else if (recharge.onetimes && typeof recharge.onetimes.list === 'function') {
            console.log('📞 Using recharge.onetimes.list()');
            return await recharge.onetimes.list(session, {
            limit: 250,
            sort_by: 'id-asc',
            });
        } else {
            console.warn('⚠️ No one-time order method found. Available methods:');
            if (recharge.onetime) {
            console.log('recharge.onetime methods:', Object.keys(recharge.onetime));
            }
            if (recharge.onetimes) {
            console.log('recharge.onetimes methods:', Object.keys(recharge.onetimes));
            }
            console.log('recharge top-level methods:', Object.keys(recharge));
            return { onetimes: [] };
        }
        });
        
        console.log('📦 One-time orders response:', result);
        
        if (result && result.onetimes) {
        // Filter only active (non-cancelled) one-time orders
        const activeOnetimes = result.onetimes.filter(onetime => !onetime.is_cancelled);
        
        console.log(`✅ Found ${result.onetimes.length} total one-time orders, ${activeOnetimes.length} active`);
        console.log('📋 Active one-time orders:', activeOnetimes);
        
        this.onetimes = activeOnetimes;
        } else {
        console.log('❌ No one-time orders found in response');
        this.onetimes = [];
        }
        
    } catch (error) {
        console.error('💥 Failed to load one-time orders:', error);
        console.error('Error details:', {
        message: error.message,
        stack: error.stack,
        name: error.name
        });
        this.onetimes = [];
        // Don't set error since one-time orders are optional
    } finally {
        this.onetimesLoading = false;
        console.log('🏁 loadOnetimes() finished, onetimesLoading set to false');
    }
    },
    
    /**
     * Load customer payment methods from Recharge API
     */
    async loadPaymentMethods() {
    console.log('🔄 Starting loadPaymentMethods()');
    this.paymentMethodsLoading = true;
    this.errors.paymentMethods = '';
    
    try {
        console.log('📞 Calling Recharge API for payment methods');
        
        // Load payment methods using the callRechargeAPI pattern
        const result = await this.callRechargeAPI(async (session) => {
        console.log('✅ Session for payment methods:', session ? 'Valid session' : 'No session');
        
        if (recharge.paymentMethod && typeof recharge.paymentMethod.listPaymentMethods === 'function') {
            console.log('📞 Using recharge.paymentMethod.listPaymentMethods()');
            return await recharge.paymentMethod.listPaymentMethods(session, {
            limit: 250,
            });
        } else {
            console.warn('⚠️ No payment method function found. Available methods:');
            if (recharge.paymentMethod) {
            console.log('recharge.paymentMethod methods:', Object.keys(recharge.paymentMethod));
            }
            console.log('recharge object keys:', Object.keys(recharge));
            return { payment_methods: [] };
        }
        });
        
        console.log('🎯 Payment methods API response:', result);
        
        if (result && result.payment_methods && Array.isArray(result.payment_methods)) {
        console.log(`✅ Found ${result.payment_methods.length} payment methods`);
        this.paymentMethods = result.payment_methods;
        
        // Log first payment method structure for debugging
        if (result.payment_methods.length > 0) {
            console.log('First payment method structure:', result.payment_methods[0]);
            console.log('Available fields:', Object.keys(result.payment_methods[0]));
        }
        } else {
        console.log('❌ No payment methods found in response');
        this.paymentMethods = [];
        }
        
    } catch (error) {
        console.error('💥 Failed to load payment methods:', error);
        console.error('Error details:', {
        message: error.message,
        stack: error.stack,
        name: error.name
        });
        this.paymentMethods = [];
        this.errors.paymentMethods = 'Failed to load payment methods. Please try again.';
    } finally {
        this.paymentMethodsLoading = false;
        console.log('🏁 loadPaymentMethods() finished, paymentMethodsLoading set to false');
    }
    },
    
    /**
     * Load charges data for Ship Now functionality
     */
    async loadCharges() {
        console.log('🔄 Starting loadCharges()');
        this.chargesLoading = true;
        
        try {
            console.log('📞 Calling Recharge API for charges');
            
            // Load charges with both 'queued' and 'error' statuses
            const queuedResult = await this.callRechargeAPI(async (session) => {
                console.log('✅ Session for charges:', session ? 'Valid session' : 'No session');
                
                if (recharge.charge && typeof recharge.charge.listCharges === 'function') {
                    console.log('📞 Using recharge.charge.listCharges() with queued status');
                    return await recharge.charge.listCharges(session, {
                        limit: 250,
                        sort_by: 'id-asc',
                        status: 'queued'
                    });
                } else {
                    console.warn('⚠️ No charge method found. Available methods:');
                    if (recharge.charge) {
                        console.log('recharge.charge methods:', Object.keys(recharge.charge));
                    }
                    console.log('recharge top-level methods:', Object.keys(recharge));
                    return { charges: [] };
                }
            });

            // Also load charges with 'error' status
            const errorResult = await this.callRechargeAPI(async (session) => {
                if (recharge.charge && typeof recharge.charge.listCharges === 'function') {
                    console.log('� Using recharge.charge.listCharges() with error status');
                    return await recharge.charge.listCharges(session, {
                        limit: 250,
                        sort_by: 'id-asc',
                        status: 'error'
                    });
                } else {
                    return { charges: [] };
                }
            });
            
            // Merge queued and error charges
            const allCharges = [
                ...(queuedResult && queuedResult.charges ? queuedResult.charges : []),
                ...(errorResult && errorResult.charges ? errorResult.charges : [])
            ];
            
            console.log('📦 Combined charges response:', {
                queued: queuedResult && queuedResult.charges ? queuedResult.charges.length : 0,
                error: errorResult && errorResult.charges ? errorResult.charges.length : 0,
                total: allCharges.length
            });
            
            if (allCharges.length > 0) {
                console.log(`✅ Found ${allCharges.length} total charges (queued + error)`);
                console.log('📋 Charges data:', allCharges);
                
                // Debug: Show charge structure
                const firstCharge = allCharges[0];
                console.log('=== FIRST CHARGE STRUCTURE ===');
                console.log('First charge keys:', Object.keys(firstCharge));
                console.log('First charge details:', {
                    id: firstCharge.id,
                    address_id: firstCharge.address_id,
                    scheduled_at: firstCharge.scheduled_at,
                    original_scheduled_at: firstCharge.original_scheduled_at,
                    status: firstCharge.status,
                    has_line_items: !!(firstCharge.line_items),
                    line_items_count: firstCharge.line_items ? firstCharge.line_items.length : 0,
                    total_price: firstCharge.total_price
                });
                
                if (firstCharge.line_items && firstCharge.line_items.length > 0) {
                    console.log('First charge line item keys:', Object.keys(firstCharge.line_items[0]));
                    console.log('First charge line item sample:', {
                        purchase_item_id: firstCharge.line_items[0].purchase_item_id,
                        external_product_id: firstCharge.line_items[0].external_product_id,
                        external_variant_id: firstCharge.line_items[0].external_variant_id,
                        original_price: firstCharge.line_items[0].original_price,
                        unit_price: firstCharge.line_items[0].unit_price,
                        total_price: firstCharge.line_items[0].total_price,
                        title: firstCharge.line_items[0].title
                    });
                }
                
                this.charges = allCharges;
            } else {
                console.log('❌ No charges found in response');
                this.charges = [];
            }
            
        } catch (error) {
            console.error('💥 Failed to load charges:', error);
            console.error('Error details:', {
                message: error.message,
                stack: error.stack,
                name: error.name
            });
            this.charges = [];
            // Don't set error since charges are optional
        } finally {
            this.chargesLoading = false;
            console.log('🏁 loadCharges() finished, chargesLoading set to false');
        }
    },
    
    /**
     * Get all subscriptions with automatic pagination
     */
    async getAllSubscriptionsWithPagination() {
    const allSubscriptions = [];
    let hasNextPage = true;
    let nextCursor = null;
    let pageCount = 0;
    
    console.log('Starting subscription pagination...');
    
    while (hasNextPage) {
        pageCount++;
        console.log(`Fetching subscriptions page ${pageCount}...`);
        
        try {
        const response = await this.callRechargeAPI(async (session) => {
            const params = {
            limit: 250, // Maximum allowed by Recharge API
            include: 'bundle_product'
            };
            
            if (nextCursor) {
            params.page_info = nextCursor;
            }
            
            console.log('API call params:', params);
            
            // Try different possible method names for listing subscriptions
            let result;
            if (recharge.customer && typeof recharge.customer.getSubscriptions === 'function') {
            console.log('Using recharge.customer.getSubscriptions()');
            result = await recharge.customer.getSubscriptions(session, params);
            } else if (recharge.customer && typeof recharge.customer.listSubscriptions === 'function') {
            console.log('Using recharge.customer.listSubscriptions()');
            result = await recharge.customer.listSubscriptions(session, params);
            } else if (recharge.subscription && typeof recharge.subscription.list === 'function') {
            console.log('Using recharge.subscription.list()');
            result = await recharge.subscription.list(session, params);
            } else if (recharge.subscription && typeof recharge.subscription.listSubscriptions === 'function') {
            console.log('Using recharge.subscription.listSubscriptions()');
            result = await recharge.subscription.listSubscriptions(session, params);
            } else if (recharge.subscription && typeof recharge.subscription.getSubscriptions === 'function') {
            console.log('Using recharge.subscription.getSubscriptions()');
            result = await recharge.subscription.getSubscriptions(session, params);
            } else if (recharge.subscriptions && typeof recharge.subscriptions.list === 'function') {
            console.log('Using recharge.subscriptions.list()');
            result = await recharge.subscriptions.list(session, params);
            } else if (recharge && typeof recharge.listSubscriptions === 'function') {
            console.log('Using recharge.listSubscriptions()');
            result = await recharge.listSubscriptions(session, params);
            } else {
            console.error('No valid subscription method found. Available methods:');
            if (recharge.customer) {
                console.log('recharge.customer methods:', Object.keys(recharge.customer));
            }
            if (recharge.subscription) {
                console.log('recharge.subscription methods:', Object.keys(recharge.subscription));
            }
            if (recharge.subscriptions) {
                console.log('recharge.subscriptions methods:', Object.keys(recharge.subscriptions));
            }
            console.log('recharge top-level methods:', Object.keys(recharge));
            throw new Error('No valid subscription listing method found in Recharge SDK');
            }
            
            return result;
        });
        
        console.log(`Page ${pageCount} response:`, response);
        
        if (response && response.subscriptions) {
            console.log(`Page ${pageCount}: Found ${response.subscriptions.length} subscriptions`);
            console.log(`Page ${pageCount} subscriptions:`, response.subscriptions);
            allSubscriptions.push(...response.subscriptions);
            
            // Check if there's a next page
            hasNextPage = response.has_next_page || false;
            nextCursor = response.next_cursor || null;
            
            console.log(`Page ${pageCount}: hasNextPage = ${hasNextPage}, nextCursor = ${nextCursor}`);
        } else {
            console.log(`Page ${pageCount}: No subscriptions in response, full response:`, response);
            hasNextPage = false;
        }
        } catch (error) {
        console.error(`Error fetching subscriptions page ${pageCount}:`, error);
        throw error;
        }
    }
    
    console.log(`Finished pagination. Total pages: ${pageCount}, Total subscriptions: ${allSubscriptions.length}`);
    return allSubscriptions;
    },
    
    /**
     * Get all bundle selections with automatic pagination
     */
    async getAllBundleSelections() {
    const allBundleSelections = [];
    let hasNextPage = true;
    let nextCursor = null;
    let pageCount = 0;
    
    console.log('Starting bundle selections pagination...');
    
    while (hasNextPage) {
        pageCount++;
        console.log(`Fetching bundle selections page ${pageCount}...`);
        
        try {
        const response = await this.callRechargeAPI(async (session) => {
            const params = {
            limit: 250, // Maximum allowed by Recharge API
            sort_by: 'id-asc'
            };
            
            if (nextCursor) {
            params.page_info = nextCursor;
            }
            
            console.log('Bundle selections API call params:', params);
            
            // Try different possible method names for listing bundle selections
            let result;
            if (recharge.bundle && typeof recharge.bundle.listBundleSelections === 'function') {
            console.log('Using recharge.bundle.listBundleSelections()');
            result = await recharge.bundle.listBundleSelections(session, params);
            } else if (recharge.bundle && typeof recharge.bundle.list === 'function') {
            console.log('Using recharge.bundle.list()');
            result = await recharge.bundle.list(session, params);
            } else if (recharge.bundleSelections && typeof recharge.bundleSelections.list === 'function') {
            console.log('Using recharge.bundleSelections.list()');
            result = await recharge.bundleSelections.list(session, params);
            } else {
            console.error('No valid bundle selection method found. Available methods:');
            if (recharge.bundle) {
                console.log('recharge.bundle methods:', Object.keys(recharge.bundle));
            }
            if (recharge.bundleSelections) {
                console.log('recharge.bundleSelections methods:', Object.keys(recharge.bundleSelections));
            }
            console.log('recharge top-level methods:', Object.keys(recharge));
            // Don't throw error - bundle selections might not be available
            console.warn('Bundle selections API not available, continuing without bundle data');
            return { bundle_selections: [] };
            }
            
            return result;
        });
        
        console.log(`Bundle selections page ${pageCount} response:`, response);
        
        if (response && response.bundle_selections) {
            console.log(`Bundle selections page ${pageCount}: Found ${response.bundle_selections.length} bundle selections`);
            console.log(`Bundle selections page ${pageCount} data:`, response.bundle_selections);
            allBundleSelections.push(...response.bundle_selections);
            
            // Check if there's a next page
            hasNextPage = response.has_next_page || false;
            nextCursor = response.next_cursor || null;
            
            console.log(`Bundle selections page ${pageCount}: hasNextPage = ${hasNextPage}, nextCursor = ${nextCursor}`);
        } else {
            console.log(`Bundle selections page ${pageCount}: No bundle selections in response, full response:`, response);
            hasNextPage = false;
        }
        } catch (error) {
        console.error(`Error fetching bundle selections page ${pageCount}:`, error);
        // Don't throw error - bundle selections might not be available for this customer
        console.warn('Bundle selections fetch failed, continuing without bundle data');
        hasNextPage = false;
        }
    }
    
    console.log(`Finished bundle selections pagination. Total pages: ${pageCount}, Total bundle selections: ${allBundleSelections.length}`);
    return allBundleSelections;
    },
    
    /**
     * Get all products with automatic pagination
     */
    async getAllProducts() {
    const allProducts = [];
    let hasNextPage = true;
    let nextCursor = null;
    let pageCount = 0;
    
    console.log('Starting products pagination...');
    
    while (hasNextPage) {
        pageCount++;
        console.log(`Fetching products page ${pageCount}...`);
        
        try {
        const response = await this.callRechargeAPI(async (session) => {
            const params = {
            limit: 250, // Maximum allowed by Recharge API
            format_version: '2022-06'
            };
            
            if (nextCursor) {
            params.page_info = nextCursor;
            }
            
            console.log('Products API call params:', params);
            
            // Try different possible method names for searching products
            let result;
            if (recharge.product && typeof recharge.product.productSearch === 'function') {
            console.log('Using recharge.product.productSearch()');
            result = await recharge.product.productSearch(session, params);
            } else if (recharge.product && typeof recharge.product.search === 'function') {
            console.log('Using recharge.product.search()');
            result = await recharge.product.search(session, params);
            } else if (recharge.product && typeof recharge.product.list === 'function') {
            console.log('Using recharge.product.list()');
            result = await recharge.product.list(session, params);
            } else if (recharge.products && typeof recharge.products.search === 'function') {
            console.log('Using recharge.products.search()');
            result = await recharge.products.search(session, params);
            } else {
            console.error('No valid product search method found. Available methods:');
            if (recharge.product) {
                console.log('recharge.product methods:', Object.keys(recharge.product));
            }
            if (recharge.products) {
                console.log('recharge.products methods:', Object.keys(recharge.products));
            }
            console.log('recharge top-level methods:', Object.keys(recharge));
            // Don't throw error - products might not be available
            console.warn('Product search API not available, continuing without product data');
            return { products: [] };
            }
            
            return result;
        });
        
        console.log(`Products page ${pageCount} response:`, response);
        
        if (response && response.products) {
            console.log(`Products page ${pageCount}: Found ${response.products.length} products`);
            console.log(`Products page ${pageCount} data:`, response.products);
            allProducts.push(...response.products);
            
            // Check if there's a next page
            hasNextPage = response.has_next_page || false;
            nextCursor = response.next_cursor || null;
            
            console.log(`Products page ${pageCount}: hasNextPage = ${hasNextPage}, nextCursor = ${nextCursor}`);
        } else {
            console.log(`Products page ${pageCount}: No products in response, full response:`, response);
            hasNextPage = false;
        }
        } catch (error) {
        console.error(`Error fetching products page ${pageCount}:`, error);
        // Don't throw error - products might not be available for this customer
        console.warn('Products fetch failed, continuing without product data');
        hasNextPage = false;
        }
    }
    
    console.log(`Finished products pagination. Total pages: ${pageCount}, Total products: ${allProducts.length}`);
    return allProducts;
    },

    /**
     * Get products inventory data from server
     */
    async getProductsInventory() {
        console.log('Fetching products inventory data...');
        
        try {
            // Use optimization parameters to reduce data size and improve performance
            const response = await fetch(this.apiUrl('/products-inventory?tracked_only=true'), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (!data.success) {
                throw new Error(data.error || 'Failed to fetch inventory data');
            }

            console.log(`Loaded inventory data for ${data.products.length} products`);
            console.log('Inventory data:', data.products);
            
            // Log 100% Kona products specifically
            const konaProducts = data.products.filter(p => p.productTitle.includes('100% Kona'));
            console.log('100% Kona products in inventory:', konaProducts);

            return data.products;
        } catch (error) {
            console.error('Error fetching products inventory:', error);
            throw error;
        }
    },

    /**
     * Load inventory data for products (no filtering, just for stock status)
     */
    filterProductsByInventory() {
        if (!this.inventoryData || this.inventoryData.length === 0) {
            console.log('No inventory data available, all products will show as available');
            return;
        }

        console.log('Inventory data loaded for stock checking...');
        console.log('Bundle collection products:', this.bundleCollectionProducts.length);
        console.log('Inventory data entries:', this.inventoryData.length);

        // Create a map of inventory status for quick lookup
        const inventoryMap = new Map();
        
        this.inventoryData.forEach(item => {
            const key = `${item.productId}-${item.variantId}`;
            inventoryMap.set(key, item);
        });

        console.log('Inventory map created with', inventoryMap.size, 'entries');

        // Log inventory status for each product (but don't filter them out)
        this.bundleCollectionProducts.forEach(bundleProduct => {
            const productId = String(bundleProduct.id || '');
            const variantId = String(bundleProduct.variant_id || '');
            const lookupKey = `${productId}-${variantId}`;
            
            const inventoryItem = inventoryMap.get(lookupKey);
            const isInStock = inventoryItem ? inventoryItem.inventory.isInStock : true; // Default to in-stock if no data
            
            console.log(`Product: ${bundleProduct.full_title} (${lookupKey}) - In Stock: ${isInStock}`);
        });

        console.log('All products will be displayed, out-of-stock items will be disabled');
    },

    /**
     * Check temporary cart items against inventory and mark out-of-stock items for removal
     */
    checkAndMarkOutOfStockItems() {
        if (!this.inventoryData || this.inventoryData.length === 0) {
            console.log('No inventory data available for stock checking');
            return;
        }

        console.log('Checking temporary cart items for out-of-stock products...');

        // Create inventory lookup map
        const inventoryMap = new Map();
        this.inventoryData.forEach(item => {
            const key = `${item.productId}-${item.variantId}`;
            inventoryMap.set(key, item);
        });

        let outOfStockCount = 0;
        const itemsToRemove = [];

        // Check each item in temporary cart
        this.temporaryCart.forEach((item, index) => {
            const productId = String(item.product_id || '');
            const variantId = String(item.variant_id || '');
            const lookupKey = `${productId}-${variantId}`;
            
            const inventoryItem = inventoryMap.get(lookupKey);

            //only if inventory is tracked
            if (inventoryItem) {
                const isInStock = inventoryItem ? inventoryItem.inventory.isInStock : false;
                
                if (!isInStock && item.quantity > 0) {
                    console.log(`Marking out-of-stock item for removal: ${item.title} (${lookupKey})`);
                    
                    // Store original quantity before marking for removal
                    item._originalQuantity = item.quantity;
                    item._removedReason = 'out_of_stock';
                    
                    // Instead of just setting quantity to 0, add to removal list
                    // This ensures change detection properly tracks these as removed items
                    itemsToRemove.push(index);
                    
                    outOfStockCount++;
                }
            }
        });

        // Remove out-of-stock items from temporary cart
        // Remove in reverse order to maintain correct indices
        itemsToRemove.reverse().forEach(index => {
            const removedItem = this.temporaryCart.splice(index, 1)[0];
            console.log(`Removed out-of-stock item from temporary cart: ${removedItem.title}`);
        });

        if (outOfStockCount > 0) {
            console.log(`Removed ${outOfStockCount} items from temporary cart due to being out of stock`);
            // Update the original cart to reflect these removals so change detection works properly
            // This ensures that when the user saves, these items are properly marked as removed
            console.log('Out-of-stock items will be tracked as removed when user saves');
        } else {
            console.log('All items in temporary cart are in stock');
        }
    },

    /**
     * Check if a product is in stock based on inventory data
     */
    isProductInStock(product) {
        if (!this.inventoryData || this.inventoryData.length === 0) {
            console.log(`No inventory data for product ${product.id} - ${product.variant_id}, assuming in stock`);
            return true; // Assume in stock if no inventory data
        }

        const productId = String(product.id || '');
        const variantId = String(product.variant_id || '');
        const lookupKey = `${productId}-${variantId}`;

        console.log(`Checking stock for product: ${product.title}, ID: ${productId}, Variant: ${variantId}, Key: ${lookupKey}`);
        
        // Log available inventory keys for debugging
        if (product.title.includes('100% Kona')) {
            console.log('Available inventory keys:', this.inventoryData.map(item => `${item.productId}-${item.variantId} (${item.productTitle})`));
        }

        const inventoryItem = this.inventoryData.find(item => 
            `${item.productId}-${item.variantId}` === lookupKey
        );

        if (!inventoryItem) {
            console.log(`No inventory item found for ${lookupKey}, defaulting to in stock`);
            return true; // Default to in-stock if not found in inventory data
        }

        const inventory = inventoryItem.inventory;
        console.log(`Found inventory for ${product.title}:`, inventory);
        
        // If tracking is enabled, check quantity
        if (inventory.tracked) {
            const inStock = inventory.quantity > 0 && inventory.availableForSale;
            console.log(`Tracked product ${product.title}: quantity=${inventory.quantity}, available=${inventory.availableForSale}, inStock=${inStock}`);
            return inStock;
        }
        
        // If tracking is disabled but quantity is 0, consider out of stock
        if (!inventory.tracked && inventory.quantity === 0) {
            console.log(`Untracked product ${product.title} with quantity 0 - OUT OF STOCK`);
            return false;
        }
        
        // Otherwise use the isInStock flag
        const inStock = inventory.isInStock && inventory.availableForSale;
        console.log(`Product ${product.title}: isInStock=${inventory.isInStock}, available=${inventory.availableForSale}, final=${inStock}`);
        return inStock;
    },

    /**
     * Get inventory info for a product
     */
    getProductInventoryInfo(product) {
        if (!this.inventoryData || this.inventoryData.length === 0) {
            return null;
        }

        const productId = String(product.id || '');
        const variantId = String(product.variant_id || '');
        const lookupKey = `${productId}-${variantId}`;

        return this.inventoryData.find(item => 
            `${item.productId}-${item.variantId}` === lookupKey
        );
    },
    
    /**
     * Link bundle selections to their corresponding subscriptions and enrich with product data
     */
    linkBundleSelectionsToSubscriptions(subscriptions, bundleSelections, products = []) {
    console.log('Linking bundle selections to subscriptions...');
    console.log('Subscriptions to link:', subscriptions.length);
    console.log('Bundle selections to link:', bundleSelections.length);
    console.log('Products to reference:', products.length);
    
    // Create a map of external product ID to product data for quick lookup
    const productsByExternalId = {};
    products.forEach(product => {
        if (product.external_product_id) {
        productsByExternalId[product.external_product_id] = product;
        }
    });
    
    console.log('Products indexed by external ID:', Object.keys(productsByExternalId).length);
    
    // Create a map of subscription ID to bundle selections
    const bundleSelectionsBySubscriptionId = {};
    bundleSelections.forEach(bundleSelection => {
        const subscriptionId = bundleSelection.purchase_item_id;
        if (!bundleSelectionsBySubscriptionId[subscriptionId]) {
        bundleSelectionsBySubscriptionId[subscriptionId] = [];
        }
        bundleSelectionsBySubscriptionId[subscriptionId].push(bundleSelection);
    });
    
    console.log('Bundle selections grouped by subscription ID:', bundleSelectionsBySubscriptionId);
    
    // Add bundle selections to each subscription and enrich with product data
    const subscriptionsWithBundles = subscriptions.map(subscription => {
        const subscriptionWithBundle = { ...subscription };
        const subscriptionId = subscription.id;
        
        if (bundleSelectionsBySubscriptionId[subscriptionId]) {
        // Enrich bundle selections with product data
        const enrichedBundleSelections = bundleSelectionsBySubscriptionId[subscriptionId].map(bundleSelection => {
            const enrichedBundleSelection = { ...bundleSelection };
            
            if (bundleSelection.items) {
            enrichedBundleSelection.items = bundleSelection.items.map(item => {
                const enrichedItem = { ...item };
                
                // Helper function to extract image URL from various possible formats
                const extractImageUrl = (imageData) => {
                if (!imageData) return null;
                
                // If it's already a string URL, return it
                if (typeof imageData === 'string') {
                    return imageData;
                }
                
                // If it's an object, try to extract the URL
                if (typeof imageData === 'object') {
                    console.log('Bundle item image data is object:', imageData);
                    
                    // Common image object properties
                    const urlFields = ['url', 'src', 'original', 'large', 'medium', 'small', 'image_url', 'featured_image_url'];
                    
                    for (const field of urlFields) {
                    if (imageData[field] && typeof imageData[field] === 'string') {
                        console.log(`Found bundle item image URL in field '${field}':`, imageData[field]);
                        return imageData[field];
                    }
                    }
                    
                    // If it's an array, get the first item
                    if (Array.isArray(imageData) && imageData.length > 0) {
                    return extractImageUrl(imageData[0]);
                    }
                }
                
                return null;
                };
                
                // Look up product data by external_product_id
                const productData = productsByExternalId[item.external_product_id];
                if (productData) {
                enrichedItem.productData = productData;
                enrichedItem.title = productData.title || productData.name || `Product ${item.external_product_id}`;
                
                // Extract image URL properly
                let imageUrl = null;
                let variant = null;
                
                // Look for variant data if available
                if (productData.variants && item.external_variant_id) {
                    variant = productData.variants.find(v => 
                    v.external_variant_id === item.external_variant_id || 
                    v.id === item.external_variant_id
                    );
                    if (variant) {
                    enrichedItem.variantData = variant;
                    enrichedItem.variantTitle = variant.title;
                    imageUrl = extractImageUrl(variant.image);
                    }
                }
                
                // If no variant image, try product image
                if (!imageUrl) {
                    imageUrl = extractImageUrl(productData.image) || extractImageUrl(productData.featured_image);
                }
                
                enrichedItem.image = imageUrl;
                
                console.log(`Enriched item ${item.id} with product data:`, {
                    title: enrichedItem.title,
                    image: enrichedItem.image,
                    external_product_id: item.external_product_id,
                    imageWasObject: typeof (productData.image) === 'object' || (variant && typeof (variant.image) === 'object')
                });
                } else {
                // Fallback if no product data found
                enrichedItem.title = `Product ${item.external_product_id}`;
                enrichedItem.image = null;
                console.log(`No product data found for external_product_id: ${item.external_product_id}`);
                }
                
                return enrichedItem;
            });
            }
            
            return enrichedBundleSelection;
        });
        
        subscriptionWithBundle.bundleSelections = enrichedBundleSelections;
        console.log(`Linked and enriched ${enrichedBundleSelections.length} bundle selections to subscription ${subscriptionId}`);
        } else {
        subscriptionWithBundle.bundleSelections = [];
        console.log(`No bundle selections found for subscription ${subscriptionId}`);
        }
        
        return subscriptionWithBundle;
    });
    
    console.log('Subscriptions with enriched bundle data linked:', subscriptionsWithBundles.length);
    return subscriptionsWithBundles;
    },
    
    /**
     * Group subscriptions and one-time orders by address_id, next_charge_scheduled_at, charge_interval_frequency, and status
     */
    groupSubscriptionsAndOnetimes(subscriptions, onetimes = [], charges = []) {
    console.log('Starting to group subscriptions and one-time orders:');
    console.log('Subscriptions:', subscriptions.length, 'items');
    console.log('One-time orders:', onetimes.length, 'items');
    console.log('Charges:', charges.length, 'items');
    
    // Fix dates for subscriptions and onetimes when there's an error charge
    // Error charges have original_scheduled_at, while the line items may have null or past dates
    const errorCharges = charges.filter(charge => charge.status === 'error' && charge.original_scheduled_at);
    
    if (errorCharges.length > 0) {
        console.log('Found error charges, fixing dates for subscriptions and onetimes...');
        
        errorCharges.forEach(errorCharge => {
            const chargeAddressId = errorCharge.address_id;
            const originalScheduledAt = errorCharge.original_scheduled_at;
            
            console.log(`Error charge ${errorCharge.id}: address=${chargeAddressId}, original_scheduled_at=${originalScheduledAt}`);
            
            // Fix subscription dates
            subscriptions.forEach(sub => {
                if (sub.address_id === chargeAddressId && (!sub.next_charge_scheduled_at || sub.next_charge_scheduled_at === null)) {
                    console.log(`  Fixing subscription ${sub.id}: null -> ${originalScheduledAt}`);
                    sub.next_charge_scheduled_at = originalScheduledAt;
                }
            });
            
            // Fix onetime dates (they may have past dates or null)
            onetimes.forEach(onetime => {
                if (onetime.address_id === chargeAddressId) {
                    const onetimeDate = onetime.next_charge_scheduled_at;
                    const isPastDate = onetimeDate && new Date(onetimeDate) < new Date();
                    
                    if (!onetimeDate || onetimeDate === null || isPastDate) {
                        console.log(`  Fixing onetime ${onetime.id}: ${onetimeDate || 'null'} -> ${originalScheduledAt}`);
                        onetime.next_charge_scheduled_at = originalScheduledAt;
                    }
                }
            });
        });
    }
    
    const groups = {};
    
    // Process subscriptions first
    subscriptions.forEach((subscription, index) => {
        console.log(`Processing subscription ${index + 1}:`, subscription);
        console.log(`Subscription ${index + 1} details:`, {
        id: subscription.id,
        product_title: subscription.product_title,
        variant_title: subscription.variant_title,
        price: subscription.price,
        quantity: subscription.quantity,
        status: subscription.status,
        next_charge_scheduled_at: subscription.next_charge_scheduled_at,
        address_id: subscription.address_id,
        charge_interval_frequency: subscription.charge_interval_frequency,
        order_interval_unit: subscription.order_interval_unit,
        properties: subscription.properties
        });
        
        const addressId = subscription.address_id || 'no-address';
        const nextChargeDate = subscription.next_charge_scheduled_at || 'no-date';
        const frequency = subscription.charge_interval_frequency || 'no-frequency';
        const interval = subscription.order_interval_unit || 'no-interval';
        const status = subscription.status || 'ACTIVE';
        
        // Create a unique key for grouping
        // For CANCELLED/cancelled subscriptions, group only by address_id and status (ignore date and frequency)
        let groupKey;
        if (status === 'CANCELLED' || status === 'cancelled') {
            groupKey = `${addressId}-CANCELLED`;
        } else {
            // For active subscriptions, use the full grouping key
            groupKey = `${addressId}-${nextChargeDate}-${frequency}-${interval}-${status}`;
        }
        console.log(`Subscription ${index + 1} group key:`, groupKey);
        
        if (!groups[groupKey]) {
        console.log(`Creating new group: ${groupKey}`);
        const isCancelledStatus = status === 'CANCELLED' || status === 'cancelled';
        groups[groupKey] = {
            key: groupKey,
            address_id: addressId,
            next_charge_scheduled_at: isCancelledStatus ? null : nextChargeDate, // No date for cancelled
            charge_interval_frequency: isCancelledStatus ? null : frequency, // No frequency for cancelled
            order_interval_unit: isCancelledStatus ? null : interval, // No interval for cancelled
            status: isCancelledStatus ? 'CANCELLED' : status, // Normalize to uppercase
            subscriptions: [],
            total_price: 0,
            line_items_count: 0,
            showDetails: false,
            isCancelled: isCancelledStatus
        };
        }
        
        groups[groupKey].subscriptions.push(subscription);
        
        // Handle price calculation - include bundle item prices if available
        let totalSubscriptionPrice = 0;
        
        // Check if subscription has bundle contents with prices
        const bundleContents = this.getBundleContents(subscription);
        if (bundleContents && bundleContents.length > 0) {
        console.log(`Subscription ${index + 1} has ${bundleContents.length} bundle items`);
        // Calculate total from bundle items
        bundleContents.forEach(item => {
            const itemTotal = (parseFloat(item.price || 0) * parseInt(item.quantity || 1));
            totalSubscriptionPrice += itemTotal;
            console.log(`Bundle item: ${item.title} - $${item.price} x ${item.quantity} = $${itemTotal}`);
        });
        console.log(`Bundle total for subscription ${index + 1}: $${totalSubscriptionPrice}`);
        } else {
        // Use regular subscription price if no bundle items
        totalSubscriptionPrice = parseFloat(subscription.price || 0);
        console.log(`Regular subscription ${index + 1} price: "${subscription.price}" -> ${totalSubscriptionPrice}`);
        }
        
        groups[groupKey].total_price += totalSubscriptionPrice;
        groups[groupKey].line_items_count += 1;
        
        console.log(`Added to group ${groupKey}. Group now has ${groups[groupKey].subscriptions.length} items, total price: ${groups[groupKey].total_price}`);
    });
    
    // Process one-time orders
    onetimes.forEach((onetime, index) => {
        console.log(`Processing one-time order ${index + 1}:`, onetime);
        console.log(`One-time order ${index + 1} details:`, {
        id: onetime.id,
        product_title: onetime.product_title,
        variant_title: onetime.variant_title,
        price: onetime.price,
        quantity: onetime.quantity,
        next_charge_scheduled_at: onetime.next_charge_scheduled_at,
        address_id: onetime.address_id,
        is_cancelled: onetime.is_cancelled
        });
        
        const addressId = onetime.address_id || 'no-address';
        const nextChargeDate = onetime.next_charge_scheduled_at || 'no-date';
        const isOnetimeCancelled = onetime.is_cancelled === true;
        
        // Only try to group with existing subscriptions if the one-time order is NOT cancelled
        let matchingGroupKey = null;
        if (!isOnetimeCancelled) {
        console.log(`One-time order ${index + 1} is active (is_cancelled = false), looking for matching subscription group...`);
        
        // Try to find an existing subscription group with matching criteria:
        // 1. onetimes.address_id = subscriptions.address_id
        // 2. onetimes.next_charge_scheduled_at = subscriptions.next_charge_scheduled_at  
        // 3. onetimes.is_cancelled = false (already checked above)
        for (const groupKey in groups) {
            const group = groups[groupKey];
            console.log(`Checking group ${groupKey}:`, {
            group_address_id: group.address_id,
            onetime_address_id: addressId,
            address_match: group.address_id === addressId,
            group_next_charge: group.next_charge_scheduled_at,
            onetime_next_charge: nextChargeDate,
            date_match: group.next_charge_scheduled_at === nextChargeDate,
            is_subscription_group: !group.isOnetimeGroup,
            group_has_subscriptions: group.subscriptions && group.subscriptions.length > 0
            });
            
            // Match based on ONLY the three criteria you specified:
            // 1. Same address_id
            // 2. Same next_charge_scheduled_at  
            // 3. One-time is not cancelled (already verified above)
            // 4. Must be a subscription group (has actual subscriptions)
            if (group.address_id === addressId && 
                group.next_charge_scheduled_at === nextChargeDate && 
                !group.isOnetimeGroup &&
                group.subscriptions && group.subscriptions.length > 0) { // Must have actual subscriptions
            matchingGroupKey = groupKey;
            console.log(`✅ Found matching subscription group for one-time order ${index + 1}: ${groupKey}`);
            console.log(`Match criteria met:`, {
                address_match: group.address_id === addressId,
                date_match: group.next_charge_scheduled_at === nextChargeDate,
                is_subscription_group: !group.isOnetimeGroup,
                has_subscriptions: group.subscriptions.length > 0,
                onetime_not_cancelled: !isOnetimeCancelled
            });
            break;
            }
        }
        } else {
        console.log(`One-time order ${index + 1} is cancelled (is_cancelled = true), will not group with subscriptions`);
        }
        
        if (matchingGroupKey) {
        // Add to existing subscription group
        if (!groups[matchingGroupKey].onetimes) {
            groups[matchingGroupKey].onetimes = [];
        }
        groups[matchingGroupKey].onetimes.push(onetime);
        
        // Calculate price for one-time order
        const onetimePrice = parseFloat(onetime.price || 0);
        console.log(`One-time order ${index + 1} price: "${onetime.price}" -> ${onetimePrice}`);
        
        groups[matchingGroupKey].total_price += onetimePrice;
        groups[matchingGroupKey].line_items_count += 1;
        
        console.log(`✅ Added one-time order to existing subscription group ${matchingGroupKey}. Group now has ${groups[matchingGroupKey].subscriptions.length} subscriptions and ${groups[matchingGroupKey].onetimes.length} one-time items, total price: ${groups[matchingGroupKey].total_price}`);
        } else {
        // Create a new one-time only group
        const frequency = 'onetime'; // Special frequency for one-time orders
        const interval = 'onetime';
        const status = isOnetimeCancelled ? 'CANCELLED' : 'ACTIVE';
        const groupKey = `${addressId}-${nextChargeDate}-${frequency}-${interval}-${status}`;
        console.log(`Creating new one-time only group: ${groupKey}`);
        
        groups[groupKey] = {
            key: groupKey,
            address_id: addressId,
            next_charge_scheduled_at: nextChargeDate,
            charge_interval_frequency: frequency,
            order_interval_unit: interval,
            status: status,
            subscriptions: [], // Keep same name for compatibility
            onetimes: [onetime], // New array for one-time orders
            total_price: 0,
            line_items_count: 0,
            showDetails: false,
            isOnetimeGroup: true // Flag to identify one-time groups
        };
        
        // Calculate price for one-time order
        const onetimePrice = parseFloat(onetime.price || 0);
        console.log(`One-time order ${index + 1} price: "${onetime.price}" -> ${onetimePrice}`);
        
        groups[groupKey].total_price += onetimePrice;
        groups[groupKey].line_items_count += 1;
        
        console.log(`Created new one-time group ${groupKey} with ${groups[groupKey].onetimes.length} one-time items, total price: ${groups[groupKey].total_price}`);
        }
    });
    
    // Convert to array and sort by status first (cancelled last), then by next charge date
    const groupArray = Object.values(groups).sort((a, b) => {
        // First, sort by status - cancelled subscriptions go to the bottom
        const aIsCancelled = a.status === 'CANCELLED' || a.status === 'cancelled';
        const bIsCancelled = b.status === 'CANCELLED' || b.status === 'cancelled';
        
        if (aIsCancelled && !bIsCancelled) return 1; // a goes after b
        if (!aIsCancelled && bIsCancelled) return -1; // a goes before b
        
        // If both have the same cancelled status, sort by date
        if (a.next_charge_scheduled_at === 'no-date') return 1;
        if (b.next_charge_scheduled_at === 'no-date') return -1;
        return new Date(a.next_charge_scheduled_at) - new Date(b.next_charge_scheduled_at);
    });
    
    // Add charge matching logic for Ship Now functionality
    console.log('=== CHARGE MATCHING FOR SHIP NOW ===');
    console.log(`Available charges (${charges.length}):`, charges);
    
    // Debug: Log all charge details first
    if (charges && charges.length > 0) {
        console.log('=== ALL CHARGE DETAILS ===');
        charges.forEach((charge, index) => {
            console.log(`Charge ${index + 1}:`, {
                id: charge.id,
                address_id: charge.address_id,
                scheduled_at: charge.scheduled_at,
                status: charge.status,
                error: charge.error,
                retry_date: charge.retry_date
            });
        });
        console.log('=== END CHARGE DETAILS ===');
    }
    
    if (charges && charges.length > 0) {
        // Process each subscription group to find matching charges
        groupArray.forEach(group => {
            console.log(`\n--- Processing group with delivery schedule: ${group.next_charge_scheduled_at} ---`);
            console.log('Group address_id:', group.address_id);
            
            // Find matching charge for this group
            let matchingCharge = null;
            
            for (let i = 0; i < charges.length; i++) {
                const charge = charges[i];
                console.log(`Checking charge ${charge.id}:`);
                console.log(`  - address_id: ${charge.address_id} (group: ${group.address_id})`);
                console.log(`  - scheduled_at: ${charge.scheduled_at} (group: ${group.next_charge_scheduled_at})`);
                console.log(`  - status: ${charge.status}`);
                
                // Match by address_id and scheduled_at (date only)
                const chargeDate = charge.scheduled_at ? charge.scheduled_at.split('T')[0] : charge.scheduled_at;
                const groupDate = group.next_charge_scheduled_at && group.next_charge_scheduled_at !== 'no-date' ? group.next_charge_scheduled_at.split('T')[0] : group.next_charge_scheduled_at;
                
                // For error charges, also check original_scheduled_at and retry_date as potential matches
                const chargeOriginalDate = charge.original_scheduled_at ? charge.original_scheduled_at.split('T')[0] : null;
                const chargeRetryDate = charge.retry_date ? charge.retry_date.split('T')[0] : null;
                
                const addressMatch = charge.address_id === group.address_id;
                const dateMatch = chargeDate === groupDate;
                const originalDateMatch = chargeOriginalDate === groupDate;
                const retryDateMatch = chargeRetryDate === groupDate;
                
                // For error charges, also match by address_id alone if group has 'no-date'
                const errorChargeAddressMatch = charge.status === 'error' && 
                                               addressMatch && 
                                               group.next_charge_scheduled_at === 'no-date';
                
                // Match if address matches AND (scheduled date matches OR original date matches OR retry date matches OR group has no-date for error charge)
                const isMatch = addressMatch && (dateMatch || originalDateMatch || retryDateMatch || errorChargeAddressMatch);
                
                if (isMatch) {
                    console.log(`  ✓ MATCH FOUND! Charge ${charge.id} matches group`);
                    console.log(`    Match reason: address=${addressMatch}, date=${dateMatch}, original=${originalDateMatch}, retry=${retryDateMatch}, error+no-date=${errorChargeAddressMatch}`);
                    matchingCharge = charge;
                    break;
                } else {
                    console.log(`  ✗ No match - address_id: ${addressMatch} | date: ${dateMatch} | original: ${originalDateMatch} | retry: ${retryDateMatch}`);
                    console.log(`    Detailed comparison:`, {
                        chargeDate,
                        chargeOriginalDate,
                        groupDate,
                        chargeRetryDate,
                        addressMatch,
                        dateMatch,
                        originalDateMatch,
                        retryDateMatch,
                        errorChargeAddressMatch,
                        groupHasNoDate: group.next_charge_scheduled_at === 'no-date'
                    });
                }
            }
            
            if (matchingCharge) {
                group.matchingCharge = matchingCharge;
                group.shipNowEnabled = true;
                console.log(`✅ Group enabled for Ship Now with charge ${matchingCharge.id} (status: ${matchingCharge.status})`);
                
                // If it's an error charge with original_scheduled_at, update the group's date
                if (matchingCharge.status === 'error' && matchingCharge.original_scheduled_at) {
                    console.log(`  Error charge detected! Updating group date to original_scheduled_at: ${matchingCharge.original_scheduled_at}`);
                    console.log(`  Previous group date was: ${group.next_charge_scheduled_at}`);
                    group.next_charge_scheduled_at = matchingCharge.original_scheduled_at;
                    console.log(`  Group date now: ${group.next_charge_scheduled_at}`);
                }
            } else {
                group.shipNowEnabled = false;
                console.log('❌ Group NOT enabled for Ship Now - no matching charge found');
            }
        });
    } else {
        console.log('No charges available for matching');
        // Disable Ship Now for all groups if no charges
        groupArray.forEach(group => {
            group.shipNowEnabled = false;
            group.matchingCharge = null;
        });
    }
    
    // Debug: Show final charge matching results
    console.log('=== FINAL CHARGE MATCHING RESULTS ===');
    groupArray.forEach((group, index) => {
        console.log(`Group ${index + 1}:`, {
            address_id: group.address_id,
            next_charge_scheduled_at: group.next_charge_scheduled_at,
            hasMatchingCharge: !!group.matchingCharge,
            matchingChargeId: group.matchingCharge ? group.matchingCharge.id : null,
            matchingChargeStatus: group.matchingCharge ? group.matchingCharge.status : null,
            shipNowEnabled: group.shipNowEnabled
        });
    });
    console.log('=== END CHARGE MATCHING RESULTS ===');
    
    return groupArray;
    },
    
    /**
     * Fetch detailed pricing for a subscription group's charge
     * Returns pricing breakdown: subtotal, discounts, shipping, tax, total
     */
    async fetchGroupChargePricing(group) {
        console.log('🔍 Fetching charge pricing for group:', group);
        
        // Check if group has a matching charge
        if (!group.matchingCharge || !group.matchingCharge.id) {
            console.log('❌ No matching charge for group');
            return null;
        }
        
        const chargeId = group.matchingCharge.id;
        console.log(`📞 Fetching charge details for charge ID: ${chargeId}`);
        
        try {
            const chargeDetails = await this.callRechargeAPI(async (session) => {
                if (recharge.charge && typeof recharge.charge.getCharge === 'function') {
                    return await recharge.charge.getCharge(session, chargeId);
                } else {
                    console.error('❌ recharge.charge.getCharge not available');
                    return null;
                }
            });
            
            if (!chargeDetails) {
                console.log('❌ No charge details returned');
                return null;
            }
            
            console.log('✅ Charge details fetched:', chargeDetails);
            
            // Extract pricing information
            const subtotal = parseFloat(chargeDetails.total_line_items_price || 0);
            const totalTax = parseFloat(chargeDetails.total_tax || 0);
            
            // Get total discounts - only if discounts array has items
            let totalDiscounts = 0;
            if (chargeDetails.discounts && Array.isArray(chargeDetails.discounts) && chargeDetails.discounts.length > 0) {
                totalDiscounts = parseFloat(chargeDetails.total_discounts || 0);
            }
            // If discounts array is empty, totalDiscounts stays 0
            
            // Calculate shipping from shipping_lines
            let totalShipping = 0;
            if (chargeDetails.shipping_lines && Array.isArray(chargeDetails.shipping_lines)) {
                chargeDetails.shipping_lines.forEach(shippingLine => {
                    totalShipping += parseFloat(shippingLine.price || 0);
                });
            }
            
            // Extract discount codes
            const appliedDiscounts = [];
            if (chargeDetails.discounts && Array.isArray(chargeDetails.discounts) && chargeDetails.discounts.length > 0) {
                chargeDetails.discounts.forEach(discount => {
                    appliedDiscounts.push({
                        id: discount.id,
                        code: discount.code,
                        value: parseFloat(chargeDetails.total_discounts || 0),
                        value_type: discount.value_type,
                        chargeId: chargeDetails.id
                    });
                });
            }
            
            // Calculate total: subtotal - discounts + shipping + tax
            const totalPrice = subtotal - totalDiscounts + totalShipping + totalTax;
            
            const pricing = {
                chargeId: chargeDetails.id,
                addressId: chargeDetails.address_id,
                subtotal: subtotal,
                totalDiscounts: totalDiscounts,
                totalShipping: totalShipping,
                totalTax: totalTax,
                totalPrice: totalPrice,
                appliedDiscounts: appliedDiscounts,
                currencyCode: chargeDetails.currency || 'USD',
                hasDetailedPricing: true
            };
            
            console.log('💰 Pricing breakdown:', pricing);
            return pricing;
            
        } catch (error) {
            console.error('❌ Error fetching charge pricing:', error);
            return null;
        }
    },
    
    /**
     * Compare line items between subscription group and charge to determine if Ship Now should be enabled
     */
    compareLineItems(subscriptionGroup, charge) {
        console.log('=== COMPARING LINE ITEMS ===');
        console.log('Subscription group:', subscriptionGroup);
        console.log('Charge:', charge);
        
        // Safety check - ensure charge has line_items
        if (!charge || !charge.line_items || !Array.isArray(charge.line_items)) {
            console.log('❌ Charge missing line_items array:', {
                hasCharge: !!charge,
                hasLineItems: !!(charge && charge.line_items),
                isArray: !!(charge && charge.line_items && Array.isArray(charge.line_items)),
                lineItemsType: charge && charge.line_items ? typeof charge.line_items : 'undefined'
            });
            return false;
        }
        
        if (charge.line_items.length === 0) {
            console.log('❌ Charge has empty line_items array');
            return false;
        }
        
        // First, let's examine the actual structure of charge line items
        console.log('=== CHARGE LINE ITEMS STRUCTURE ===');
        console.log('Charge line_items array:', charge.line_items);
        if (charge.line_items && charge.line_items.length > 0) {
            console.log('First charge line item structure:', charge.line_items[0]);
            console.log('First charge line item keys:', Object.keys(charge.line_items[0]));
        }
        
        // Get all items from the subscription group
        const groupItems = [];
        
        // Add subscription items
        if (subscriptionGroup.subscriptions) {
            subscriptionGroup.subscriptions.forEach(subscription => {
                console.log('Processing subscription for comparison:', subscription);
                console.log('Subscription keys:', Object.keys(subscription));
                
                groupItems.push({
                    type: 'subscription',
                    external_product_id: subscription.external_product_id?.ecommerce || subscription.external_product_id,
                    external_variant_id: subscription.external_variant_id?.ecommerce || subscription.external_variant_id,
                    quantity: subscription.quantity,
                    product_title: subscription.product_title,
                    variant_title: subscription.variant_title,
                    shopify_product_id: subscription.shopify_product_id,
                    shopify_variant_id: subscription.shopify_variant_id
                });
            });
        }
        
        // Add one-time items
        if (subscriptionGroup.onetimes) {
            subscriptionGroup.onetimes.forEach(onetime => {
                console.log('Processing onetime for comparison:', onetime);
                console.log('Onetime keys:', Object.keys(onetime));
                
                groupItems.push({
                    type: 'onetime',
                    external_product_id: onetime.external_product_id?.ecommerce || onetime.external_product_id,
                    external_variant_id: onetime.external_variant_id?.ecommerce || onetime.external_variant_id,
                    quantity: onetime.quantity,
                    product_title: onetime.product_title,
                    variant_title: onetime.variant_title,
                    shopify_product_id: onetime.shopify_product_id,
                    shopify_variant_id: onetime.shopify_variant_id
                });
            });
        }
        
        console.log('=== GROUP ITEMS STRUCTURE ===');
        console.log('Group items to compare:', groupItems);
        groupItems.forEach((item, index) => {
            console.log(`Group item ${index + 1}:`, item);
        });
        
        console.log('=== DETAILED COMPARISON ===');
        
        // Check if each group item has a matching line item in the charge
        const allItemsMatch = groupItems.every(groupItem => {
            console.log(`\n--- Checking group item: ${groupItem.product_title} ---`);
            
            const matchingChargeItem = charge.line_items.find(chargeItem => {
                console.log('Comparing with charge item:', {
                    chargeItem_keys: Object.keys(chargeItem),
                    title: chargeItem.title,
                    product_id: chargeItem.product_id,
                    variant_id: chargeItem.variant_id,
                    external_product_id: chargeItem.external_product_id,
                    external_variant_id: chargeItem.external_variant_id,
                    shopify_product_id: chargeItem.shopify_product_id,
                    shopify_variant_id: chargeItem.shopify_variant_id,
                    quantity: chargeItem.quantity
                });
                
                // Try multiple comparison strategies
                
                // Strategy 1: external_variant_id
                const externalVariantMatch = groupItem.external_variant_id && chargeItem.external_variant_id && 
                                           String(groupItem.external_variant_id) === String(chargeItem.external_variant_id);
                
                // Strategy 2: external_product_id
                const externalProductMatch = groupItem.external_product_id && chargeItem.external_product_id && 
                                           String(groupItem.external_product_id) === String(chargeItem.external_product_id);
                
                // Strategy 3: shopify_variant_id
                const shopifyVariantMatch = groupItem.shopify_variant_id && chargeItem.shopify_variant_id && 
                                          String(groupItem.shopify_variant_id) === String(chargeItem.shopify_variant_id);
                
                // Strategy 4: shopify_product_id  
                const shopifyProductMatch = groupItem.shopify_product_id && chargeItem.shopify_product_id && 
                                          String(groupItem.shopify_product_id) === String(chargeItem.shopify_product_id);
                
                // Strategy 5: variant_id field
                const variantIdMatch = groupItem.external_variant_id && chargeItem.variant_id && 
                                     String(groupItem.external_variant_id) === String(chargeItem.variant_id);
                
                // Strategy 6: product_id field
                const productIdMatch = groupItem.external_product_id && chargeItem.product_id && 
                                     String(groupItem.external_product_id) === String(chargeItem.product_id);
                
                // Compare quantities
                const quantityMatch = parseInt(groupItem.quantity || 1) === parseInt(chargeItem.quantity || 1);
                
                const anyIdMatch = externalVariantMatch || externalProductMatch || shopifyVariantMatch || 
                                 shopifyProductMatch || variantIdMatch || productIdMatch;
                
                const matches = anyIdMatch && quantityMatch;
                
                console.log(`Comparison results:`, {
                    externalVariantMatch,
                    externalProductMatch,
                    shopifyVariantMatch,
                    shopifyProductMatch,
                    variantIdMatch,
                    productIdMatch,
                    quantityMatch,
                    anyIdMatch,
                    matches
                });
                
                return matches;
            });
            
            if (!matchingChargeItem) {
                console.log(`❌ No matching charge item found for group item:`, groupItem);
                return false;
            }
            
            console.log(`✅ Found matching charge item for group item:`, groupItem);
            return true;
        });
        
        // Also check if charge has any extra items not in the group
        const chargeHasExtraItems = charge.line_items.some(chargeItem => {
            const matchingGroupItem = groupItems.find(groupItem => {
                const externalVariantMatch = groupItem.external_variant_id && chargeItem.external_variant_id && 
                                           String(groupItem.external_variant_id) === String(chargeItem.external_variant_id);
                const externalProductMatch = groupItem.external_product_id && chargeItem.external_product_id && 
                                           String(groupItem.external_product_id) === String(chargeItem.external_product_id);
                const shopifyVariantMatch = groupItem.shopify_variant_id && chargeItem.shopify_variant_id && 
                                          String(groupItem.shopify_variant_id) === String(chargeItem.shopify_variant_id);
                const shopifyProductMatch = groupItem.shopify_product_id && chargeItem.shopify_product_id && 
                                          String(groupItem.shopify_product_id) === String(chargeItem.shopify_product_id);
                const variantIdMatch = groupItem.external_variant_id && chargeItem.variant_id && 
                                     String(groupItem.external_variant_id) === String(chargeItem.variant_id);
                const productIdMatch = groupItem.external_product_id && chargeItem.product_id && 
                                     String(groupItem.external_product_id) === String(chargeItem.product_id);
                
                const quantityMatch = parseInt(groupItem.quantity || 1) === parseInt(chargeItem.quantity || 1);
                
                const anyIdMatch = externalVariantMatch || externalProductMatch || shopifyVariantMatch || 
                                 shopifyProductMatch || variantIdMatch || productIdMatch;
                
                return anyIdMatch && quantityMatch;
            });
            
            if (!matchingGroupItem) {
                console.log(`❌ Charge has extra item not in group:`, chargeItem);
                return true;
            }
            
            return false;
        });
        
        const perfectMatch = allItemsMatch && !chargeHasExtraItems;
        
        console.log('=== FINAL COMPARISON RESULT ===');
        console.log('Line items comparison result:', {
            groupItemsCount: groupItems.length,
            chargeItemsCount: charge.line_items.length,
            allGroupItemsHaveMatch: allItemsMatch,
            chargeHasExtraItems: chargeHasExtraItems,
            perfectMatch: perfectMatch
        });
        
        return perfectMatch;
    },
    
    /**
     * Helper function to extract image URL from various possible formats
     * Used across multiple methods for consistent image extraction
     */
    extractImageUrl(imageData) {
        if (!imageData) return null;
        
        // If it's already a string URL, return it
        if (typeof imageData === 'string') {
            return imageData;
        }
        
        // If it's an object, try to extract the URL
        if (typeof imageData === 'object') {
            // Common image object properties
            const urlFields = ['url', 'src', 'original', 'large', 'medium', 'small', 'image_url', 'featured_image_url', 'src_url'];
            
            for (const field of urlFields) {
                if (imageData[field] && typeof imageData[field] === 'string') {
                    return imageData[field];
                }
            }
            
            // If it's an array, get the first item
            if (Array.isArray(imageData) && imageData.length > 0) {
                return this.extractImageUrl(imageData[0]);
            }
        }
        
        return null;
    },

    /**
     * Get image URL for a product/variant from Shopify products feed
     * This is the most reliable method as it uses the actual product data
     */
    getImageFromProducts(item) {
        console.log('Getting image from products feed for item:', item);
        
        if (!this.products || this.products.length === 0) {
            console.log('No products data available');
            return null;
        }
        
        // Extract IDs from various possible structures
        const getProductId = (item) => {
            return item.external_product_id?.ecommerce || 
                   item.external_product_id || 
                   item.shopify_product_id ||
                   item.product_id;
        };
        
        const getVariantId = (item) => {
            return item.external_variant_id?.ecommerce || 
                   item.external_variant_id || 
                   item.shopify_variant_id ||
                   item.variant_id;
        };
        
        const productId = getProductId(item);
        const variantId = getVariantId(item);
        
        console.log('Looking for product with IDs:', { productId, variantId });
        
        // Find the product in our products array
        const product = this.products.find(p => 
            p.external_product_id === productId || 
            p.id === productId ||
            String(p.external_product_id) === String(productId)
        );
        
        if (product) {
            console.log('Found matching product:', product.title);
            
            // If we have a specific variant, try to find its image first
            if (variantId && product.variants) {
                const variant = product.variants.find(v => 
                    v.external_variant_id === variantId || 
                    v.id === variantId ||
                    String(v.external_variant_id) === String(variantId)
                );
                
                if (variant && variant.image) {
                    console.log('Found variant image');
                    const variantImageUrl = this.extractImageUrl(variant.image);
                    if (variantImageUrl) return variantImageUrl;
                }
            }
            
            // Try product's main image
            if (product.image) {
                console.log('Using product main image');
                const productImageUrl = this.extractImageUrl(product.image);
                if (productImageUrl) return productImageUrl;
            }
            
            // Try featured_image field
            if (product.featured_image) {
                console.log('Using product featured_image');
                const featuredImageUrl = this.extractImageUrl(product.featured_image);
                if (featuredImageUrl) return featuredImageUrl;
            }
            
            // Try images array
            if (product.images && Array.isArray(product.images) && product.images.length > 0) {
                console.log('Using first image from images array');
                const imagesArrayUrl = this.extractImageUrl(product.images[0]);
                if (imagesArrayUrl) return imagesArrayUrl;
            }
        } else {
            console.log('No matching product found for IDs:', { productId, variantId });
        }
        
        return null;
    },

    /**
     * Helper methods for subscription management UI
     */
    getSubscriptionImageUrl(subscription) {
        console.log('Getting image for subscription:', subscription.id);
        
        // FIRST: Try to get image from Shopify products feed (most reliable)
        const imageFromProducts = this.getImageFromProducts(subscription);
        if (imageFromProducts) {
            console.log('Using image from products feed');
            return imageFromProducts;
        }
        
        // SECOND: Check if this is a bundle product with bundle_product data
        if (subscription.include && subscription.include.bundle_product) {
            console.log('Found bundle product data');
            
            // For Build-A-Box, use a specific image
            if (subscription.product_title && subscription.product_title.toLowerCase().includes('build-a-box')) {
                console.log('Using Build-A-Box specific image');
                return 'https://angelinos.com/cdn/shop/products/BuildABox_400x.jpg?v=1639583847';
            }
        }
        
        // THIRD: Try to get image from Recharge subscription data fields
        const possibleImageFields = [
            'images',
            'variant_image',
            'product_image', 
            'image',
            'shopify_variant_image',
            'shopify_product_image'
        ];
        
        for (const field of possibleImageFields) {
            if (subscription[field]) {
                console.log(`Found image in subscription field '${field}'`);
                const extractedUrl = this.extractImageUrl(subscription[field]);
                if (extractedUrl) return extractedUrl;
            }
        }
        
        // FOURTH: Check for shopify_product_data which might contain images
        if (subscription.shopify_product_data && subscription.shopify_product_data.image) {
            console.log('Found image in shopify_product_data');
            const shopifyImageUrl = this.extractImageUrl(subscription.shopify_product_data.image);
            if (shopifyImageUrl) return shopifyImageUrl;
        }
        
        // For Build-A-Box products, try to get a generic image based on product_title
        if (subscription.product_title && subscription.product_title.toLowerCase().includes('build-a-box')) {
            console.log('Using Build-A-Box fallback image');
            return 'https://angelinos.com/cdn/shop/products/BuildABox_400x.jpg?v=1639583847';
        }
        
        console.log('No image found for subscription, using placeholder');
        // Fallback to placeholder
        return 'https://cdn.shopify.com/s/files/1/0086/6612/0255/files/placeholder.png';
    },
    
    getOnetimeImageUrl(onetime) {
        console.log('Getting image for one-time order:', onetime.id);
        
        // FIRST: Try to get image from Shopify products feed (most reliable)
        const imageFromProducts = this.getImageFromProducts(onetime);
        if (imageFromProducts) {
            console.log('Using image from products feed');
            return imageFromProducts;
        }
        
        // SECOND: Try to get image from Recharge one-time data fields
        const possibleImageFields = [
            'images',
            'variant_image',
            'product_image', 
            'image',
            'shopify_variant_image',
            'shopify_product_image'
        ];
        
        for (const field of possibleImageFields) {
            if (onetime[field]) {
                console.log(`Found image in one-time field '${field}'`);
                const extractedUrl = this.extractImageUrl(onetime[field]);
                if (extractedUrl) return extractedUrl;
            }
        }
        
        // THIRD: Check for shopify_product_data which might contain images
        if (onetime.shopify_product_data && onetime.shopify_product_data.image) {
            console.log('Found image in one-time shopify_product_data');
            const shopifyImageUrl = this.extractImageUrl(onetime.shopify_product_data.image);
            if (shopifyImageUrl) return shopifyImageUrl;
        }
        
        console.log('No image found for one-time order, using placeholder');
        // Fallback to placeholder
        return 'https://cdn.shopify.com/s/files/1/0086/6612/0255/files/placeholder.png';
    },

    /**
     * Get the primary image (position=1) from a product's images array
     */
    getProductPrimaryImage(product) {
        if (!product || !product.images || !Array.isArray(product.images)) {
            return null;
        }
        
        // Find the image with position = 1
        const primaryImage = product.images.find(img => img.position === 1);
        return primaryImage ? primaryImage.src : null;
    },

    calculateSubscribeSavePercentage(retailPrice, subscriptionPrice) {
        if (!retailPrice || !subscriptionPrice || retailPrice <= subscriptionPrice) {
            return 0;
        }
        
        const savings = retailPrice - subscriptionPrice;
        const percentage = (savings / retailPrice) * 100;
        
        console.log('Subscribe & Save calculation:', {
            retailPrice,
            subscriptionPrice, 
            savings,
            percentage,
            rounded: Math.round(percentage * 100) / 100
        });
        
        // Check if we're very close to a round half-percent (like 4.985 ≈ 5.00)
        const rounded = Math.round(percentage * 100) / 100;
        const nearestHalf = Math.round(percentage * 2) / 2; // Round to nearest 0.5%
        const nearestWhole = Math.round(percentage); // Round to nearest whole number
        
        // If within 0.02% of a whole number, snap to it (handles 4.985 -> 5.00)
        if (Math.abs(percentage - nearestWhole) < 0.02) {
            return nearestWhole;
        }
        
        // If within 0.02% of a half percent, snap to it (handles 4.48 -> 4.50)
        if (Math.abs(percentage - nearestHalf) < 0.02) {
            return nearestHalf;
        }
        
        return rounded;
    },

    getItemRetailPrice(item) {
        console.log('Getting retail price for item:', item);
        
        // Handle both item format (direct properties) and subscription format (nested .ecommerce)
        const extractId = (idObj) => {
            if (!idObj) return null;
            if (typeof idObj === 'number' || typeof idObj === 'string') return idObj;
            if (idObj.ecommerce) return idObj.ecommerce;
            return null;
        };
        
        const productId = extractId(item.external_product_id);
        const variantId = extractId(item.external_variant_id);
        
        // First, try to find the product in our products data using external_product_id
        if (productId && this.products && this.products.length > 0) {
            console.log('Looking for product with external_product_id:', productId);
            
            // Find the product in our products array
            const product = this.products.find(p => 
                p.external_product_id === productId || 
                p.id === productId ||
                String(p.external_product_id) === String(productId)
            );
            
            if (product) {
                console.log('Found matching product for retail price:', product);
                
                // If we have a specific variant, try to find its price first
                if (variantId && product.variants) {
                    const variant = product.variants.find(v => 
                        v.external_variant_id === variantId || 
                        v.id === variantId ||
                        String(v.external_variant_id) === String(variantId)
                    );
                    
                    if (variant) {
                        console.log('Found variant for retail price:', variant);
                        
                        // Check if variant has prices array with unit_price
                        if (variant.prices && Array.isArray(variant.prices) && variant.prices.length > 0) {
                            for (const priceData of variant.prices) {
                                if (priceData.unit_price && parseFloat(priceData.unit_price) > 0) {
                                    console.log('Found variant unit_price:', priceData.unit_price);
                                    return parseFloat(priceData.unit_price);
                                }
                            }
                        }
                        
                        // Try various price fields for variant as fallback
                        const priceFields = ['comparing_at_price', 'compare_at_price', 'retail_price', 'original_price', 'price', 'unit_price'];
                        for (const field of priceFields) {
                            if (variant[field] && parseFloat(variant[field]) > 0) {
                                console.log(`Found variant retail price in field '${field}':`, variant[field]);
                                return parseFloat(variant[field]);
                            }
                        }
                    }
                }
                
                // Try product's retail price fields
                console.log('Trying product retail price fields:', product);
                
                // Check if product has minimum_variant_prices array with price
                if (product.minimum_variant_prices && Array.isArray(product.minimum_variant_prices) && product.minimum_variant_prices.length > 0) {
                    for (const priceData of product.minimum_variant_prices) {
                        if (priceData.price && parseFloat(priceData.price) > 0) {
                            console.log('Found product minimum_variant_prices price:', priceData.price);
                            return parseFloat(priceData.price);
                        }
                    }
                }
                
                const priceFields = ['comparing_at_price', 'compare_at_price', 'retail_price', 'original_price', 'price', 'unit_price'];
                for (const field of priceFields) {
                    if (product[field] && parseFloat(product[field]) > 0) {
                        console.log(`Found product retail price in field '${field}':`, product[field]);
                        return parseFloat(product[field]);
                    }
                }
            } else {
                console.log('No matching product found for retail price lookup:', productId);
                console.log('Available products:', this.products?.map(p => ({ id: p.id, external_id: p.external_product_id, title: p.title })) || []);
            }
        } else {
            console.log('Missing data for retail price lookup:', { 
                external_product_id: item.external_product_id, 
                products_length: this.products?.length || 0 
            });
        }
        
        console.log('No retail price found for item');
        return null;
    },
    
    getBundleTotalQuantity(subscription) {
    const bundleContents = this.getBundleContents(subscription);
    if (!bundleContents || bundleContents.length === 0) {
        return 0;
    }
    
    return bundleContents.reduce((total, item) => {
        const quantity = parseInt(item.quantity) || 0;
        return total + quantity;
    }, 0);
    },
    
    getBundleDiscountedUnitPrice(item, subscription) {
        const retailPrice = this.getItemRetailPrice(item);
        if (retailPrice && retailPrice > 0) {
            const discount = this.getBundleDiscount(subscription);
            if (discount.totalDiscount > 0) {
                return retailPrice * (1 - discount.totalDiscount / 100);
            }
        }
        // Fallback: use item.price if available
        return parseFloat(item.price) || 0;
    },

    getBundleDiscountedTotalPrice(item, subscription) {
        const unitPrice = this.getBundleDiscountedUnitPrice(item, subscription);
        const quantity = parseInt(item.quantity) || 1;
        return unitPrice * quantity;
    },
    
    getGroupItemCount(group) {
    let totalItems = 0;
    
    // Count bundle contents for subscriptions
    if (group.subscriptions) {
        group.subscriptions.forEach(subscription => {
        const bundleContents = this.getBundleContents(subscription);
        if (bundleContents && bundleContents.length > 0) {
            // For bundles, sum up the quantities of all bundle items
            totalItems += bundleContents.reduce((sum, item) => sum + (parseInt(item.quantity) || 1), 0);
        } else {
            // For regular subscriptions, use the subscription quantity
            totalItems += parseInt(subscription.quantity) || 1;
        }
        });
    }
    
    // Count one-time orders with their quantities
    if (group.onetimes) {
        group.onetimes.forEach(onetime => {
            totalItems += parseInt(onetime.quantity) || 1;
        });
    }
    
    return totalItems;
    },
    
    getBundleDiscount(subscription) {
    // Discount levels based on number of products
    const discountLevels = [
        { products: 0, discount: 0.00 },
        { products: 1, discount: 0.00 },
        { products: 2, discount: 0.00 },
        { products: 3, discount: 0.00 },
        { products: 4, discount: 0.00 },
        { products: 5, discount: 7.76 },
        { products: 6, discount: 9.10 },
        { products: 7, discount: 14.78 },
        { products: 8, discount: 20.80 },
        { products: 9, discount: 21.07 },
        { products: 10, discount: 23.81 },
        { products: 11, discount: 24.28 },
        { products: 12, discount: 34.10 }
    ];
    
    const totalProducts = this.getBundleTotalQuantity(subscription);
    
    // Find the discount rate based on product count
    let baseDiscount = 0;
    
    if (totalProducts >= 12) {
        // Anything over 12 products gets the highest discount
        baseDiscount = 34.10;
    } else {
        // Find the exact match in the discount table
        const discountLevel = discountLevels.find(level => level.products === totalProducts);
        baseDiscount = discountLevel ? discountLevel.discount : 0;
    }
    
    // Stack 5% subscription discount with base discount
    const totalDiscount = baseDiscount + (100 - baseDiscount) * 0.05;
    
    return {
        baseDiscount: baseDiscount,
        subscriptionBonus: 5.00,
        totalDiscount: totalDiscount,
        totalProducts: totalProducts
    };
    },
    
    getBundleContents(subscription) {
    console.log('Getting bundle contents for subscription:', subscription.id);
    console.log('Subscription object:', subscription);
    
    // Check if we have any bundle selections data stored globally
    if (!this.bundleSelections || this.bundleSelections.length === 0) {
        console.log('No global bundle selections available');
        return this.getFallbackBundleContents(subscription);
    }
    
    // Find bundle selections where purchase_item_id matches subscription.id
    const matchingBundleSelections = this.bundleSelections.filter(bundleSelection => 
        bundleSelection.purchase_item_id === subscription.id
    );
    
    console.log(`Found ${matchingBundleSelections.length} bundle selections for subscription ${subscription.id}:`, matchingBundleSelections);
    
    if (matchingBundleSelections.length > 0) {
        const bundleItems = [];
        
        matchingBundleSelections.forEach(bundleSelection => {
        console.log('Processing bundle selection:', bundleSelection);
        if (bundleSelection.items && bundleSelection.items.length > 0) {
            console.log('Bundle selection has items:', bundleSelection.items);
            
            bundleSelection.items.forEach(item => {
            console.log('Processing bundle item:', item);
            
            // Find matching product in this.products using item.id
            let productData = null;
            let productTitle = `Product ${item.id}`;
            let productImage = null;
            
            console.log(`Processing bundle item with ID: ${item.id}, external_product_id: ${item.external_product_id}, external_variant_id: ${item.external_variant_id}, title: ${item.title}`);
            console.log(`Available products count: ${this.products ? this.products.length : 0}`);
            console.log(`Full bundle item data:`, item);
            
            // Log a sample of the actual product data to understand the structure
            if (this.products && this.products.length > 0) {
                console.log(`Sample product data:`, this.products[0]);
                
                // Enhanced image structure analysis
                const sampleProduct = this.products[0];
                console.log(`=== DETAILED IMAGE STRUCTURE ANALYSIS ===`);
                console.log(`Product ID: ${sampleProduct.id}, Title: ${sampleProduct.title}`);
                console.log(`Images array:`, sampleProduct.images);
                console.log(`First image:`, sampleProduct.images && sampleProduct.images[0]);
                
                if (sampleProduct.variants && sampleProduct.variants.length > 0) {
                console.log(`Sample variant image:`, sampleProduct.variants[0].image);
                console.log(`All variant images:`, sampleProduct.variants.map(v => ({
                    id: v.id,
                    image: v.image,
                    image_type: typeof v.image
                })));
                }
                
                console.log(`First 3 products:`, this.products.slice(0, 3).map(p => ({
                id: p.id,
                external_product_id: p.external_product_id,
                title: p.title,
                has_images_array: !!p.images,
                images_count: p.images ? p.images.length : 0,
                first_image_type: p.images && p.images[0] ? typeof p.images[0] : null,
                variants_count: p.variants ? p.variants.length : 0,
                variant_image_types: p.variants ? p.variants.map(v => typeof v.image) : []
                })));
            }
            
            if (this.products && this.products.length > 0) {
                console.log(`Trying to match bundle item:`, {
                item_id: item.id,
                external_product_id: item.external_product_id,
                external_variant_id: item.external_variant_id,
                title: item.title
                });
                
                // First try to find product by matching external_variant_id with product variants
                if (item.external_variant_id) {
                console.log(`Searching for product with variant ID: ${item.external_variant_id}`);
                productData = this.products.find(p => {
                    if (p.variants && p.variants.length > 0) {
                    const variantMatch = p.variants.some(v => 
                        v.id === item.external_variant_id ||
                        v.external_variant_id === item.external_variant_id ||
                        String(v.id) === String(item.external_variant_id) ||
                        String(v.external_variant_id) === String(item.external_variant_id)
                    );
                    
                    if (variantMatch) {
                        console.log(`Found product by variant match:`, {
                        product_id: p.id,
                        product_title: p.title,
                        matching_variant_id: item.external_variant_id
                        });
                        return true;
                    }
                    }
                    return false;
                });
                }
                
                // If no variant match, try to match by product IDs
                if (!productData) {
                console.log(`No variant match, trying product ID matching...`);
                productData = this.products.find(p => {
                    const match = p.id === item.id || 
                                p.external_product_id === item.id ||
                                String(p.id) === String(item.id) ||
                                String(p.external_product_id) === String(item.id) ||
                                p.id === item.external_product_id ||
                                p.external_product_id === item.external_product_id ||
                                String(p.id) === String(item.external_product_id) ||
                                String(p.external_product_id) === String(item.external_product_id);
                    
                    if (match) {
                    console.log(`Found product match by ID for item ${item.id}:`, {
                        product_id: p.id,
                        product_external_id: p.external_product_id,
                        product_title: p.title,
                        item_id: item.id,
                        item_external_id: item.external_product_id
                    });
                    }
                    
                    return match;
                });
                }
                
                // If no match by ID, try matching by title (for products like "Mad Professor")
                if (!productData && item.title) {
                console.log(`No ID match found, trying title match for: "${item.title}"`);
                productData = this.products.find(p => {
                    const titleMatch = p.title && p.title.toLowerCase().includes(item.title.toLowerCase()) ||
                                    p.name && p.name.toLowerCase().includes(item.title.toLowerCase()) ||
                                    item.title.toLowerCase().includes(p.title ? p.title.toLowerCase() : '') ||
                                    item.title.toLowerCase().includes(p.name ? p.name.toLowerCase() : '');
                    
                    if (titleMatch) {
                    console.log(`Found title match for "${item.title}":`, {
                        product_title: p.title || p.name,
                        product_id: p.id,
                        product_external_id: p.external_product_id
                    });
                    }
                    
                    return titleMatch;
                });
                }
                
                if (productData) {
                console.log(`Found product data for item ${item.id}:`, {
                    title: productData.title,
                    images_array: productData.images,
                    first_image: productData.images && productData.images[0],
                    images_count: productData.images ? productData.images.length : 0,
                    variants_count: productData.variants ? productData.variants.length : 0
                });
                productTitle = productData.title || productData.name || productTitle;
                
                // Helper function to extract image URL from various formats
                const extractImageUrl = (imageData, source) => {
                    console.log(`=== EXTRACTING IMAGE FROM ${source.toUpperCase()} ===`);
                    console.log(`Image data type: ${typeof imageData}`);
                    console.log(`Image data value:`, imageData);
                    
                    if (!imageData) {
                        console.log(`No image data provided for ${source}`);
                        return null;
                    }
                    
                    if (typeof imageData === 'string') {
                        // Validate that it's a proper HTTP URL
                        if (imageData.startsWith('http://') || imageData.startsWith('https://')) {
                            console.log(`Using valid string image from ${source}: ${imageData}`);
                            return imageData;
                        } else {
                            console.log(`String image from ${source} is not a valid HTTP URL: ${imageData}`);
                            return null;
                        }
                    } else if (typeof imageData === 'object') {
                        console.log(`Image from ${source} is object, structure:`, Object.keys(imageData));
                        console.log(`Full object:`, imageData);
                        
                        const urlFields = ['url', 'src', 'original', 'large', 'medium', 'small', 'image_url', 'src_url', 'alt_text'];
                        for (const field of urlFields) {
                            if (imageData[field]) {
                                console.log(`Found field '${field}' with value:`, imageData[field], `(type: ${typeof imageData[field]})`);
                                if (typeof imageData[field] === 'string' && 
                                    (imageData[field].startsWith('http://') || imageData[field].startsWith('https://'))) {
                                    console.log(`SUCCESS: Found valid image URL from ${source} in field '${field}': ${imageData[field]}`);
                                    return imageData[field];
                                }
                            }
                        }
                        console.log(`No valid HTTP URL found in any expected fields for ${source}`);
                        console.log(`Available fields in image object:`, Object.keys(imageData));
                    }
                    console.log(`Failed to extract valid URL from ${source}`);
                    return null;
                };
                
                // Try to find a specific variant first if we have variant info
                if (item.external_variant_id && productData.variants && productData.variants.length > 0) {
                    console.log(`Looking for specific variant ${item.external_variant_id}...`);
                    const specificVariant = productData.variants.find(v => 
                    v.id === item.external_variant_id ||
                    v.external_variant_id === item.external_variant_id ||
                    String(v.id) === String(item.external_variant_id) ||
                    String(v.external_variant_id) === String(item.external_variant_id)
                    );
                    
                    if (specificVariant && specificVariant.image) {
                    console.log(`Found specific variant with image:`, specificVariant.image);
                    productImage = extractImageUrl(specificVariant.image, 'specific variant');
                    }
                }
                
                // If no specific variant image, try main product image from images array
                if (!productImage) {
                    console.log(`No variant image found, trying main product image from images array...`);
                    if (productData.images && productData.images.length > 0) {
                    productImage = extractImageUrl(productData.images[0], 'main product images[0]');
                    }
                }
                
                // If no main product image, try second image in array as fallback
                if (!productImage && productData.images && productData.images.length > 1) {
                    console.log(`No first image, trying second image in array...`);
                    productImage = extractImageUrl(productData.images[1], 'second product image');
                }
                
                // If still no image, try any variant image as final fallback
                if (!productImage && productData.variants && productData.variants.length > 0) {
                    console.log(`No main/featured image, trying any variant images as fallback...`);
                    for (const variant of productData.variants) {
                    if (variant.image) {
                        productImage = extractImageUrl(variant.image, `variant ${variant.id || 'unknown'}`);
                        if (productImage) {
                        console.log(`Using fallback variant image: ${productImage}`);
                        break;
                        }
                    }
                    }
                }
                
                console.log(`Final image result for ${productData.title}: ${productImage || 'NO IMAGE'}`);
                } else {
                console.log(`No product data found for item ${item.id} with title "${item.title}". Available products:`, this.products.slice(0, 5).map(p => ({ id: p.id, external_id: p.external_product_id, title: p.title })));
                }
            } else {
                console.log('No products available for matching');
            }
            
            // Ensure we have a valid image URL or null for clear fallback handling
            if (productImage && !(productImage.startsWith('http://') || productImage.startsWith('https://'))) {
                console.warn(`Invalid image URL found (not HTTP/HTTPS): ${productImage}`);
                productImage = null;
            }
            
            bundleItems.push({
                id: item.id,
                quantity: item.quantity || 1,
                price: parseFloat(item.price || 0),
                external_product_id: item.external_product_id || null,
                external_variant_id: item.external_variant_id || null,
                name: productTitle,
                title: productTitle,
                image: productImage,
                productData: productData,
                // Include bundle selection ID for server-side updates
                bundleSelectionId: bundleSelection.id
            });
            
            console.log(`Final bundle item created:`, {
                id: item.id,
                title: productTitle,
                image: productImage,
                image_valid: !!(productImage && (productImage.startsWith('http://') || productImage.startsWith('https://'))),
                has_product_data: !!productData,
                original_item: item
            });
            });
        } else {
            console.log('Bundle selection has no items:', bundleSelection);
        }
        });
        
        console.log('Bundle items found:', bundleItems);
        console.log('Number of bundle items:', bundleItems.length);
        return bundleItems;
    }
    
    console.log('No matching bundle selections found for subscription');
    return this.getFallbackBundleContents(subscription);
    },
    
    getFallbackBundleContents(subscription) {
    if (subscription.properties && Array.isArray(subscription.properties)) {
        const boxContentsProperty = subscription.properties.find(prop => prop.name === 'box_contents');
        if (boxContentsProperty && boxContentsProperty.value) {
        console.log('Found box_contents property (fallback):', boxContentsProperty.value);
        
        // Parse the box contents string into individual items
        const items = boxContentsProperty.value.split('\n').map(line => {
            const trimmed = line.trim();
            if (!trimmed) return null;
            
            // Try to parse "2x Mad Professor" format
            const match = trimmed.match(/^(\d+)x\s*(.+)$/);
            if (match) {
            return {
                quantity: parseInt(match[1]),
                name: match[2].trim(),
                title: match[2].trim(),
                price: 0, // Price not available from properties
                external_product_id: null,
                external_variant_id: null,
                image: null,
                productData: null,
                variantData: null
            };
            }
            
            // Fallback: treat as single item
            return {
            quantity: 1,
            name: trimmed,
            title: trimmed,
            price: 0,
            external_product_id: null,
            external_variant_id: null,
            image: null,
            productData: null,
            variantData: null
            };
        }).filter(Boolean);
        
        console.log('Parsed bundle items from properties:', items);
        return items;
        }
    }
    
    console.log('No bundle contents found');
    return [];
    },
    
    getBundleItemsCount(subscription) {
    const bundleContents = this.getBundleContents(subscription);
    return bundleContents.reduce((total, item) => total + item.quantity, 0);
    },
    
    getGroupTotalPrice(group) {
        let totalPrice = 0;
        
        group.subscriptions.forEach(subscription => {
            const bundleContents = this.getBundleContents(subscription);
            if (bundleContents && bundleContents.length > 0) {
                // For bundle items, try to get charge prices first
                bundleContents.forEach(item => {
                    const matchingChargeLineItem = this.getMatchingChargeLineItemForBundle(item, group);
                    if (matchingChargeLineItem && matchingChargeLineItem.total_price) {
                        // Use charge total price
                        totalPrice += parseFloat(matchingChargeLineItem.total_price);
                        console.log(`Bundle item using charge price: ${matchingChargeLineItem.total_price}`);
                    } else {
                        // Fallback to original item price calculation
                        const itemTotal = (parseFloat(item.price || 0) * parseInt(item.quantity || 1));
                        totalPrice += itemTotal;
                        console.log(`Bundle item using original price: ${itemTotal}`);
                    }
                });
            } else {
                // For regular subscriptions, try to get charge price first
                const matchingChargeLineItem = this.getMatchingChargeLineItem(subscription, group);
                if (matchingChargeLineItem && matchingChargeLineItem.total_price) {
                    // Use charge total price
                    totalPrice += parseFloat(matchingChargeLineItem.total_price);
                    console.log(`Regular subscription using charge price: ${matchingChargeLineItem.total_price}`);
                } else {
                    // Fallback to original subscription price
                    totalPrice += parseFloat(subscription.price || 0);
                    console.log(`Regular subscription using original price: ${subscription.price}`);
                }
            }
        });
        
        // Add one-time products to the total price
        if (group.onetimes && group.onetimes.length > 0) {
            group.onetimes.forEach(onetime => {
                const onetimePrice = parseFloat(onetime.price || 0);
                const onetimeQuantity = parseInt(onetime.quantity || 1);
                const onetimeTotal = onetimePrice * onetimeQuantity;
                totalPrice += onetimeTotal;
                console.log(`One-time product: ${onetime.product_title || 'Unknown'} - ${onetimeQuantity}x ${onetimePrice} = ${onetimeTotal}`);
            });
        }
        
        console.log(`Group total calculated: ${totalPrice}`);
        return totalPrice;
    },
    
    getSubscriptionStatusClass(status) {
    const statusLower = (status || 'active').toLowerCase();
    
    switch (statusLower) {
        case 'active':
        return 'text-white border-green-200';
        case 'paused':
        case 'skipped':
        return 'bg-yellow-100 text-yellow-700 border-yellow-200';
        case 'cancelled':
        return 'text-cancelled border-red-200';
        default:
        return 'bg-gray-100 text-gray-700 border-gray-200';
    }
    },
    
    getChargeStatusClass(status) {
    const statusLower = (status || '').toLowerCase();
    
    switch (statusLower) {
        case 'queued':
        return 'bg-blue-100 text-blue-700 border-blue-200';
        case 'skipped':
        return 'bg-yellow-100 text-yellow-700 border-yellow-200';
        case 'error':
        return 'bg-red-100 text-red-700 border-red-200';
        case 'pending_manual_payment':
        return 'bg-orange-100 text-orange-700 border-orange-200';
        case 'pending':
        return 'bg-indigo-100 text-indigo-700 border-indigo-200';
        case 'success':
        return 'bg-green-100 text-green-700 border-green-200';
        case 'refunded':
        return 'text-refunded border-purple-200';
        default:
        return 'bg-gray-100 text-gray-700 border-gray-200';
    }
    },
    
    /**
     * Get the charge status for the next upcoming subscription
     * Used in Dashboard Home to show ERROR or SCHEDULED badge
     */
    getNextSubscriptionChargeStatus() {
        try {
            console.log('🔍 getNextSubscriptionChargeStatus called');
            console.log('Charges available:', this.charges ? this.charges.length : 0);
            console.log('Subscriptions available:', this.subscriptions ? this.subscriptions.length : 0);
            console.log('Subscription groups available:', this.subscriptionGroups ? this.subscriptionGroups.length : 0);
            
            // First, check charges directly for any error status
            if (this.charges && this.charges.length > 0) {
                console.log('Checking charges for error status...');
                const errorCharge = this.charges.find(charge => 
                    charge.status && charge.status.toLowerCase() === 'error'
                );
                
                if (errorCharge) {
                    console.log('🔴 ERROR charge found directly:', errorCharge);
                    return 'error';
                }
            }
            
            // Fallback to checking subscription groups if they're loaded
            if (!this.subscriptionGroups || this.subscriptionGroups.length === 0) {
                console.log('⚠️ No subscription groups found, defaulting to scheduled');
                return 'scheduled';
            }
            
            // Log all groups to debug
            this.subscriptionGroups.forEach((group, index) => {
                console.log(`Group ${index}:`, {
                    status: group.status,
                    next_charge: group.next_charge_scheduled_at,
                    has_matching_charge: !!group.matchingCharge,
                    charge_status: group.matchingCharge ? group.matchingCharge.status : 'N/A'
                });
            });
            
            // Get the first non-cancelled group with a future charge date
            const activeGroup = this.subscriptionGroups.find(group => {
                const isCancelled = group.status === 'CANCELLED' || 
                                  group.status === 'cancelled' || 
                                  this.isGroupCancelled(group);
                const hasFutureDate = group.next_charge_scheduled_at && 
                                     new Date(group.next_charge_scheduled_at) > new Date();
                return !isCancelled && hasFutureDate;
            });
            
            if (!activeGroup) {
                console.log('⚠️ No active group found');
                return 'scheduled';
            }
            
            console.log('✅ Active group found:', {
                has_matching_charge: !!activeGroup.matchingCharge,
                charge_status: activeGroup.matchingCharge ? activeGroup.matchingCharge.status : 'N/A'
            });
            
            // Check if the group has a matching charge with error status
            if (activeGroup.matchingCharge && 
                activeGroup.matchingCharge.status && 
                activeGroup.matchingCharge.status.toLowerCase() === 'error') {
                console.log('🔴 ERROR status detected in active group!');
                return 'error';
            }
            
            // Return the charge status if available, otherwise 'scheduled'
            const status = activeGroup.matchingCharge && activeGroup.matchingCharge.status 
                ? activeGroup.matchingCharge.status.toLowerCase() 
                : 'scheduled';
            console.log('📊 Returning status:', status);
            return status;
                
        } catch (error) {
            console.error('Error getting next subscription charge status:', error);
            return 'scheduled';
        }
    },
    
    toggleSubscriptionDetails(groupKey) {
    const group = this.subscriptionGroups.find(g => g.key === groupKey);
    if (group) {
        const wasShowing = group.showDetails;
        
        // Hide all groups first
        this.subscriptionGroups.forEach(g => {
        g.showDetails = false;
        });
        
        // If the clicked group wasn't showing, show it now
        if (!wasShowing) {
        group.showDetails = true;
        }
    }
    },
    
    editSubscriptionGroup(group) {
    // TODO: Implement subscription group editing
    console.log('Edit subscription group:', group);
    alert('Subscription group editing will be implemented soon!');
    },
    
    async skipNextSubscriptionCharge(group) {
    if (this.loadingStates.skippingSubscription) return;
    
    if (!confirm(`Are you sure you want to skip the next charge for this group (${group.subscriptions.length + (group.onetimes ? group.onetimes.length : 0)} items)?`)) return;
    
    this.loadingStates.skippingSubscription = true;
    this.errors.subscriptions = '';
    
    try {
        // Skip charge for all subscriptions in the group
        const skipPromises = group.subscriptions.map(subscription => 
        this.callRechargeAPI(async (session) => {
            return await recharge.subscription.skipSubscription({
            subscription_id: subscription.id,
            date: group.next_charge_scheduled_at
            });
        })
        );
        
        await Promise.all(skipPromises);
        
        // Refresh subscription data
        await this.loadAllSubscriptions();
        
        this.successMessages.subscriptions = 'Successfully skipped next charge for subscription group.';
        setTimeout(() => {
        this.successMessages.subscriptions = '';
        }, 5000);
        
    } catch (error) {
        console.error('Failed to skip subscription charges:', error);
        this.errors.subscriptions = 'Failed to skip charges. Please try again.';
    } finally {
        this.loadingStates.skippingSubscription = false;
    }
    },
    
    changeSubscriptionFrequency(group) {
    // TODO: Implement frequency change
    console.log('Change frequency for subscription group:', group);
    alert('Frequency change will be implemented soon!');
    },
    
    async shipNow(group) {
        console.log('🚀 Opening Ship Now modal for group:', group);
        
        // Check if ship now is enabled for this group
        if (!group.shipNowEnabled) {
            alert('Ship Now is not available for this order. The line items don\'t match the upcoming charge.');
            return;
        }
        
        // Check if we have a matching charge
        if (!group.matchingCharge) {
            alert('No matching charge found for this order. Cannot ship now.');
            return;
        }
        
        // Open the modal instead of using browser confirm
        this.subscriptionToShip = group;
        this.shipNowError = null;
        this.showShipNowModal = true;
    },

    closeShipNowModal() {
        this.showShipNowModal = false;
        this.subscriptionToShip = null;
        this.shippingNow = false;
        this.shipNowError = null;
    },

    async confirmShipNow() {
        if (!this.subscriptionToShip || !this.subscriptionToShip.matchingCharge) {
            this.shipNowError = 'No valid subscription or charge found.';
            return;
        }

        try {
            this.shippingNow = true;
            this.shipNowError = null;
            
            const group = this.subscriptionToShip;
            console.log('Processing charge for immediate shipping:', group.matchingCharge.id);
            
            // Use the Recharge API to process/ship the charge now
            const result = await this.callRechargeAPI(async (session) => {
                if (recharge.charge && typeof recharge.charge.processCharge === 'function') {
                    console.log('📞 Using recharge.charge.processCharge()');
                    return await recharge.charge.processCharge(session, group.matchingCharge.id);
                } else if (recharge.charge && typeof recharge.charge.process === 'function') {
                    console.log('📞 Using recharge.charge.process()');
                    return await recharge.charge.process(session, group.matchingCharge.id);
                } else if (recharge.charge && typeof recharge.charge.skipCharge === 'function') {
                    // If we can't process immediately, we might need to use a different approach
                    console.warn('⚠️ No process method found. Available methods:');
                    if (recharge.charge) {
                        console.log('recharge.charge methods:', Object.keys(recharge.charge));
                    }
                    throw new Error('Charge processing method not available');
                } else {
                    console.warn('⚠️ No charge processing method found');
                    console.log('recharge object keys:', Object.keys(recharge));
                    throw new Error('Charge processing API not available');
                }
            });
            
            console.log('✅ Ship Now result:', result);
            
            // Prepare success modal data
            const orderGroup = this.subscriptionToShip;
            this.shippedOrderDetails = {
                customer_name: this.formatCustomerName(orderGroup.address),
                charge_amount: orderGroup.matchingCharge.total_price,
                delivery_address: this.formatAddress(orderGroup.address)
            };
            
            // Close the confirmation modal and show success modal
            this.closeShipNowModal();
            this.showShipNowSuccessModal = true;
            
            // Refresh the subscription data to reflect the changes
            await this.loadAllSubscriptions();
            
        } catch (error) {
            console.error('💥 Failed to ship now:', error);
            this.shipNowError = error.message || 'Failed to ship the order now. Please try again or contact support.';
        } finally {
            this.shippingNow = false;
        }
    },

    closeShipNowSuccessModal() {
        this.showShipNowSuccessModal = false;
        this.shippedOrderDetails = null;
        
        // Redirect to Dashboard Home
        window.location.href = '/pages/dashboard?section=dashboard-home';
    },

    closeSuccessModal() {
        this.showSuccessModal = false;
        this.successModalTitle = '';
        this.successModalMessage = '';
        this.successModalDetails = null;
        
        // Check if we need to open cart after modal closes
        if (this.redirectToCartAfterModal) {
            this.redirectToCartAfterModal = false;
            
            // Safely open Rebuy Smart Cart if available
            if (typeof window.Rebuy !== 'undefined' && 
                window.Rebuy.SmartCart && 
                typeof window.Rebuy.SmartCart.show === 'function') {
                // Small delay to ensure modal is fully closed before opening cart
                setTimeout(() => {
                    window.Rebuy.SmartCart.show();
                }, 100);
            } else {
                // Fallback: Navigate to cart page if Rebuy is not available
                //window.location.href = '/cart';
            }
        }
    },

    showSuccess(title, message, details = null) {
        this.successModalTitle = title;
        this.successModalMessage = message;
        this.successModalDetails = details;
        this.showSuccessModal = true;
    },

    closeSuccessModalAndGoToSubscriptions() {
        this.closeSuccessModal();
        // Redirect to manage subscriptions page with URL update
        window.location.href = '/pages/dashboard?section=manage-subscriptions';
    },

    closeErrorModal() {
        this.showErrorModal = false;
        this.errorModalTitle = '';
        this.errorModalMessage = '';
        this.errorModalDetails = null;
    },

    showError(title, message, details = null) {
        this.errorModalTitle = title;
        this.errorModalMessage = message;
        this.errorModalDetails = details;
        this.showErrorModal = true;
    },

    /**
     * Bundle Products Modal Methods
     */
    async showBundleProductsModalForGroup(group) {
        console.log('Show bundle products modal for group:', group);
        
        // Show loading overlay immediately
        this.loadingBundleProductsModal = true;
        
        try {
            // Store the current editing group
            this.currentEditingGroup = group;
        
        // Load BAB collection products FIRST to ensure proper item type detection
        await this.loadBABCollectionProducts();
        
        // Load products inventory data for stock checking
        console.log('Loading products inventory data...');
        try {
            this.inventoryData = await this.getProductsInventory();
            console.log('Loaded inventory data:', this.inventoryData.length, 'items');
        } catch (error) {
            console.error('Failed to load inventory data:', error);
            this.inventoryData = []; // Fallback to empty array
        }
        
        // Load bundle collection products and filter by inventory
        await this.loadBundleCollectionProducts();
        this.filterProductsByInventory();
        
        // Initialize temporary cart with current bundle contents
        this.temporaryCart = [];
        this.originalCart = []; // Reset original cart for change tracking
        
        // Load current bundle contents for all subscriptions in the group
        if (group.subscriptions && group.subscriptions.length > 0) {
            group.subscriptions.forEach(subscription => {
                const bundleContents = this.getBundleContents(subscription);
                console.log('Bundle contents for subscription:', subscription.id, bundleContents);
                
                // Add each bundle item to temporary cart
                bundleContents.forEach(bundleItem => {
                    console.log('Processing bundle item for temporary cart:', bundleItem);
                    
                    // Check if product already exists in temporary cart
                    const existingItem = this.temporaryCart.find(item => {
                        // Try multiple matching strategies
                        return (
                            // Match by external_product_id (most reliable)
                            (bundleItem.external_product_id && item.product_id === bundleItem.external_product_id) ||
                            // Match by external_variant_id
                            (bundleItem.external_variant_id && item.variant_id === bundleItem.external_variant_id) ||
                            // Match by id field
                            (bundleItem.id && item.product_id === bundleItem.id) ||
                            // Match by converted string IDs
                            (bundleItem.external_product_id && item.product_id === String(bundleItem.external_product_id)) ||
                            (bundleItem.external_variant_id && item.variant_id === String(bundleItem.external_variant_id))
                        );
                    });
                    
                    if (existingItem) {
                        // Increment quantity if already exists
                        existingItem.quantity += bundleItem.quantity || 1;
                        
                        // Ensure item_type is set (for backwards compatibility)
                        if (!existingItem.item_type) {
                            const productForTypeCheck = {
                                id: existingItem.product_id,
                                variant_id: existingItem.variant_id
                            };
                            existingItem.item_type = this.getItemType(productForTypeCheck);
                        }
                        
                        console.log(`Incremented existing item quantity:`, existingItem);
                    } else {
                        // Add new item to temporary cart
                        // Try to determine item type from bundle item data
                        const productForTypeCheck = {
                            id: bundleItem.external_product_id || bundleItem.id,
                            variant_id: bundleItem.external_variant_id
                        };
                        const itemType = this.getItemType(productForTypeCheck);
                        
                        const newItem = {
                            product_id: bundleItem.external_product_id || bundleItem.id,
                            variant_id: bundleItem.external_variant_id,
                            title: bundleItem.title || bundleItem.product_title,
                            quantity: bundleItem.quantity || 1,
                            price: bundleItem.price,
                            item_type: itemType,
                            // Store original bundle item data for debugging
                            _originalBundleItem: bundleItem,
                            // Store bundle selection ID for server-side updates
                            _bundleSelectionId: bundleItem.bundleSelectionId
                        };
                        
                        this.temporaryCart.push(newItem);
                        console.log(`Added new item to temporary cart with type "${itemType}":`, newItem);
                    }
                });
            });
        }
        
        // Also add regular subscription items (non-bundle items) to temporary cart
        if (group.subscriptions && group.subscriptions.length > 0) {
            group.subscriptions.forEach(subscription => {
                console.log('Processing regular subscription for temporary cart:', subscription);
                
                // Check if this subscription has bundle contents (skip if it does, already processed above)
                const bundleContents = this.getBundleContents(subscription);
                if (bundleContents && bundleContents.length > 0) {
                    console.log('Subscription has bundle contents, skipping regular subscription processing');
                    return; // Skip this subscription as it's already processed as bundle
                }
                
                // This is a regular subscription (not a bundle), add it to temporary cart
                // Properly extract product_id and variant_id from potentially complex objects
                const productId = subscription.external_product_id?.ecommerce || subscription.external_product_id || subscription.shopify_product_id;
                const variantId = subscription.external_variant_id?.ecommerce || subscription.external_variant_id || subscription.shopify_variant_id;
                
                const subscriptionProduct = {
                    id: productId,
                    variant_id: variantId
                };
                const itemType = this.getItemType(subscriptionProduct, 'subscription');
                
                // Check if product already exists in temporary cart
                const existingItem = this.temporaryCart.find(item => {
                    const matches = [
                        // Match by extracted product_id
                        String(item.product_id) === String(productId),
                        // Match by extracted variant_id
                        variantId && String(item.variant_id) === String(variantId)
                    ];
                    
                    return matches.some(match => match);
                });
                
                if (existingItem) {
                    // Increment quantity if already exists
                    existingItem.quantity += subscription.quantity || 1;
                    
                    // Ensure item_type is set
                    if (!existingItem.item_type) {
                        existingItem.item_type = itemType;
                    }
                    
                    console.log(`Incremented existing subscription item quantity:`, existingItem);
                } else {
                    // Add new subscription item to temporary cart
                    // Properly extract product_id and variant_id from potentially complex objects
                    const productId = subscription.external_product_id?.ecommerce || subscription.external_product_id || subscription.shopify_product_id;
                    const variantId = subscription.external_variant_id?.ecommerce || subscription.external_variant_id || subscription.shopify_variant_id;
                    
                    const newItem = {
                        product_id: String(productId || ''),
                        variant_id: String(variantId || ''),
                        title: subscription.product_title,
                        variant_title: subscription.variant_title,
                        full_title: subscription.variant_title && subscription.variant_title !== 'Default Title' 
                            ? `${subscription.product_title} - ${subscription.variant_title}` 
                            : subscription.product_title,
                        quantity: subscription.quantity || 1,
                        price: parseFloat(subscription.price) || 0,
                        item_type: itemType,
                        // Store original subscription data as plain object for debugging
                        _originalSubscription: {
                            id: subscription.id,
                            product_title: subscription.product_title,
                            variant_title: subscription.variant_title,
                            external_product_id: subscription.external_product_id,
                            external_variant_id: subscription.external_variant_id,
                            shopify_product_id: subscription.shopify_product_id,
                            shopify_variant_id: subscription.shopify_variant_id,
                            quantity: subscription.quantity,
                            price: subscription.price,
                            status: subscription.status
                        }
                    };
                    
                    this.temporaryCart.push(newItem);
                    console.log(`Added new subscription item to temporary cart with type "${itemType}":`, newItem);
                }
            });
        }
        
        // Process onetime products from the group
        if (group.onetimes && group.onetimes.length > 0) {
            console.log('Processing onetime products for temporary cart:', group.onetimes);
            
            group.onetimes.forEach(onetime => {
                // Properly extract product_id and variant_id from potentially complex objects
                const productId = onetime.shopify_product_id || onetime.external_product_id?.ecommerce || onetime.external_product_id;
                const variantId = onetime.shopify_variant_id || onetime.external_variant_id?.ecommerce || onetime.external_variant_id;
                
                const onetimeProduct = {
                    id: productId,
                    variant_id: variantId
                };
                const itemType = this.getItemType(onetimeProduct, 'onetime');
                
                // Check if product already exists in temporary cart
                const existingItem = this.temporaryCart.find(item => {
                    const matches = [
                        // Match by extracted product_id
                        String(item.product_id) === String(productId),
                        // Match by extracted variant_id
                        variantId && String(item.variant_id) === String(variantId)
                    ];
                    
                    return matches.some(match => match);
                });
                
                if (existingItem) {
                    // Increment quantity if already exists
                    existingItem.quantity += onetime.quantity || 1;
                    
                    // Ensure item_type is set
                    if (!existingItem.item_type) {
                        existingItem.item_type = itemType;
                    }
                    
                    console.log(`Incremented existing onetime item quantity:`, existingItem);
                } else {
                    // Add new onetime item to temporary cart
                    const newItem = {
                        product_id: String(productId || ''),
                        variant_id: String(variantId || ''),
                        title: onetime.product_title,
                        variant_title: onetime.variant_title,
                        full_title: onetime.variant_title && onetime.variant_title !== 'Default Title' 
                            ? `${onetime.product_title} - ${onetime.variant_title}` 
                            : onetime.product_title,
                        quantity: onetime.quantity || 1,
                        price: parseFloat(onetime.price) || 0,
                        item_type: itemType,
                        // Store original onetime data as plain object for debugging
                        _originalOnetime: {
                            id: onetime.id,
                            product_title: onetime.product_title,
                            variant_title: onetime.variant_title,
                            shopify_product_id: onetime.shopify_product_id,
                            shopify_variant_id: onetime.shopify_variant_id,
                            external_product_id: onetime.external_product_id,
                            external_variant_id: onetime.external_variant_id,
                            quantity: onetime.quantity,
                            price: onetime.price,
                            address_id: onetime.address_id
                        }
                    };
                    
                    this.temporaryCart.push(newItem);
                    console.log(`Added new onetime item to temporary cart with type "${itemType}":`, newItem);
                }
            });
        }
        
        console.log('Initialized temporary cart with:', this.temporaryCart);
        
        // Initialize change tracking with deep copy of current state BEFORE checking stock
        // This ensures out-of-stock removals are properly tracked as changes
        this.originalCart = JSON.parse(JSON.stringify(this.temporaryCart));
        
            // Check for out-of-stock items in temporary cart and remove them
            // This happens AFTER saving the original cart, so removals will be tracked
            this.checkAndMarkOutOfStockItems();
            this.initializeChangeTracking();
            
            this.selectedBundleProducts = [];
            this.showBundleProductsModal = true;
            
        } catch (error) {
            console.error('Error loading bundle products modal:', error);
            alert('Failed to load products. Please try again.');
        } finally {
            // Hide loading overlay
            this.loadingBundleProductsModal = false;
        }
    },

    closeBundleProductsModal() {
        this.showBundleProductsModal = false;
        this.loadingBundleProductsModal = false; // Reset loading state
        this.showSelectedOnly = false; // Reset toggle to show all products
        this.selectedBundleProducts = [];
        this.temporaryCart = [];
        this.originalCart = [];
        this.currentEditingGroup = null;
        this.resetChangeTracking();
    },

    /**
     * Debug method to log temporary cart contents to console
     */
    debugTemporaryCart() {
        console.log('=== TEMPORARY CART DEBUG ===');
        console.log('Temporary cart length:', this.temporaryCart.length);
        console.log('Temporary cart contents:', this.temporaryCart);
        console.table(this.temporaryCart);
        
        console.log('=== TEMPORARY CART STATS ===');
        const stats = this.getTemporaryCartStats();
        console.log('Cart stats:', stats);
        console.table(stats);
        
        console.log('=== CURRENT EDITING GROUP ===');
        console.log('Current editing group:', this.currentEditingGroup);
        
        console.log('=== BUNDLE COLLECTION PRODUCTS ===');
        console.log('Bundle collection products length:', this.bundleCollectionProducts.length);
        console.log('Bundle collection products:', this.bundleCollectionProducts);
        
        // Show a sample of how getProductQuantityInCart works
        if (this.bundleCollectionProducts.length > 0) {
            const sampleProduct = this.bundleCollectionProducts[0];
            console.log('=== SAMPLE QUANTITY CHECK ===');
            console.log('Sample product:', sampleProduct);
            console.log('Sample product quantity in cart:', this.getProductQuantityInCart(sampleProduct));
        }
        
        // Alert for user feedback
        alert('Temporary cart debug info logged to console. Check the console for details.');
    },

    // ========================================
    // CHANGE TRACKING METHODS
    // ========================================
    
    /**
     * Initialize change tracking system
     */
    initializeChangeTracking() {
        this.changeTracking = {
            enabled: true,
            originalState: JSON.parse(JSON.stringify(this.originalCart)),
            currentState: JSON.parse(JSON.stringify(this.temporaryCart)),
            changes: {
                added: [],
                removed: [],
                modified: []
            }
        };
        console.log('Change tracking initialized:', this.changeTracking);
    },

    /**
     * Reset change tracking system
     */
    resetChangeTracking() {
        this.changeTracking = {
            enabled: false,
            originalState: [],
            currentState: [],
            changes: {
                added: [],
                removed: [],
                modified: []
            }
        };
    },

    /**
     * Detect changes between original cart and current temporary cart
     * Returns object with arrays of added, removed, and modified items
     */
    detectCartChanges() {
        if (!this.changeTracking.enabled) {
            console.warn('Change tracking is not enabled');
            return {
                added: [],
                removed: [],
                modified: []
            };
        }

        const original = this.originalCart || [];
        const current = this.temporaryCart || [];
        
        const changes = {
            added: [],
            removed: [],
            modified: []
        };

        // Helper function to find item by ID
        const findItem = (items, searchItem) => {
            return items.find(item => {
                return (
                    (item.product_id && item.product_id === searchItem.product_id) ||
                    (item.variant_id && item.variant_id === searchItem.variant_id) ||
                    (item.id && item.id === searchItem.id)
                );
            });
        };

        // Find added items (in current but not in original)
        current.forEach(currentItem => {
            const originalItem = findItem(original, currentItem);
            if (!originalItem) {
                changes.added.push({
                    ...currentItem,
                    _changeType: 'added'
                });
            }
        });

        // Find removed items (in original but not in current)
        original.forEach(originalItem => {
            const currentItem = findItem(current, originalItem);
            if (!currentItem) {
                changes.removed.push({
                    ...originalItem,
                    _changeType: 'removed'
                });
            }
        });

        // Find modified items (in both but with different quantities)
        original.forEach(originalItem => {
            const currentItem = findItem(current, originalItem);
            if (currentItem && currentItem.quantity !== originalItem.quantity) {
                changes.modified.push({
                    ...currentItem,
                    _changeType: 'modified',
                    _originalQuantity: originalItem.quantity,
                    _newQuantity: currentItem.quantity,
                    _quantityDiff: currentItem.quantity - originalItem.quantity
                });
            }
        });

        // Update change tracking state
        this.changeTracking.currentState = JSON.parse(JSON.stringify(current));
        this.changeTracking.changes = changes;

        console.log('Changes detected:', changes);
        return changes;
    },

    /**
     * Check if there are any pending changes
     */
    hasChanges() {
        const changes = this.detectCartChanges();
        return (
            changes.added.length > 0 ||
            changes.removed.length > 0 ||
            changes.modified.length > 0
        );
    },

    /**
     * Get a summary of pending changes for display
     */
    getChangesSummary() {
        const changes = this.detectCartChanges();
        const summary = [];
        
        if (changes.added.length > 0) {
            summary.push(`${changes.added.length} item(s) to add`);
        }
        
        if (changes.removed.length > 0) {
            summary.push(`${changes.removed.length} item(s) to remove`);
        }
        
        if (changes.modified.length > 0) {
            summary.push(`${changes.modified.length} item(s) to update`);
        }
        
        return summary.length > 0 ? summary.join(', ') : 'No changes';
    },

    addProductToBundle(product) {
        console.log('Add product to bundle:', product);
        
        // Check if product already exists in temporary cart using variant-specific matching
        const existingItem = this.temporaryCart.find(item => {
            const matches = [
                // Direct product ID match (for products without variants)
                !product.variant_id && item.product_id === product.id,
                // Variant-specific match (preferred for products with variants)
                product.variant_id && item.variant_id === product.variant_id,
                // String conversion matches
                !product.variant_id && item.product_id === String(product.id),
                product.variant_id && item.variant_id === String(product.variant_id),
                !product.variant_id && String(item.product_id) === String(product.id),
                product.variant_id && String(item.variant_id) === String(product.variant_id)
            ];
            
            return matches.some(match => match);
        });
        
        if (existingItem) {
            // Increment quantity if already exists
            existingItem.quantity += 1;
            
            // Ensure item_type is set (for backwards compatibility)
            if (!existingItem.item_type) {
                existingItem.item_type = this.getItemType(product);
            }
            
            console.log(`Incremented quantity for ${product.full_title}. New quantity: ${existingItem.quantity}`);
        } else {
            // Add new item to temporary cart
            const itemType = this.getItemType(product);
            const newItem = {
                product_id: product.id,
                variant_id: product.variant_id,
                title: product.title,
                variant_title: product.variant_title,
                full_title: product.full_title,
                quantity: 1,
                price: product.price,
                item_type: itemType
            };

            // If this is a subscription item and we have a current editing group, include subscription fields
            if (itemType === 'subscription' && this.currentEditingGroup) {
                newItem.address_id = this.currentEditingGroup.address_id;
                newItem.charge_interval_frequency = this.currentEditingGroup.charge_interval_frequency;
                newItem.next_charge_scheduled_at = this.currentEditingGroup.next_charge_scheduled_at;
                newItem.order_interval_frequency = this.currentEditingGroup.order_interval_frequency;
                newItem.order_interval_unit = this.currentEditingGroup.order_interval_unit;
                
                // Add properly formatted external_variant_id for Recharge API
                newItem.external_variant_id = {
                    ecommerce: {
                        id: product.variant_id || product.id
                    }
                };
                
                // Also add external_product_id for completeness
                newItem.external_product_id = {
                    ecommerce: {
                        id: product.id
                    }
                };
                
                console.log(`Added subscription fields to new item:`, {
                    address_id: newItem.address_id,
                    charge_interval_frequency: newItem.charge_interval_frequency,
                    next_charge_scheduled_at: newItem.next_charge_scheduled_at,
                    order_interval_frequency: newItem.order_interval_frequency,
                    order_interval_unit: newItem.order_interval_unit,
                    external_variant_id: newItem.external_variant_id,
                    external_product_id: newItem.external_product_id
                });
            } else if (itemType === 'onetime' && this.currentEditingGroup) {
                // Onetimes need fewer fields than subscriptions
                newItem.address_id = this.currentEditingGroup.address_id;
                newItem.next_charge_scheduled_at = this.currentEditingGroup.next_charge_scheduled_at;
                
                // Add properly formatted external_variant_id for Recharge API
                newItem.external_variant_id = {
                    ecommerce: {
                        id: product.variant_id || product.id
                    }
                };
                
                // Also add external_product_id for completeness
                newItem.external_product_id = {
                    ecommerce: {
                        id: product.id
                    }
                };
                
                console.log(`Added onetime fields to new item:`, {
                    address_id: newItem.address_id,
                    next_charge_scheduled_at: newItem.next_charge_scheduled_at,
                    external_variant_id: newItem.external_variant_id,
                    external_product_id: newItem.external_product_id
                });
            } else if (itemType === 'bundle' && this.currentEditingGroup) {
                // For bundle items, we need to specify which bundle selection to add the item to
                console.log(`🔍 Adding bundle item - checking for target bundle selection...`);
                
                // Try to find an existing bundle selection ID from the current editing group
                let targetBundleSelectionId = null;
                
                // Check if the current editing group has bundle selections
                if (this.currentEditingGroup.bundleSelections && this.currentEditingGroup.bundleSelections.length > 0) {
                    // Use the first bundle selection ID (most common case)
                    targetBundleSelectionId = this.currentEditingGroup.bundleSelections[0].id;
                    console.log(`📦 Found target bundle selection ID: ${targetBundleSelectionId}`);
                } else if (this.currentEditingGroup.subscriptions && this.currentEditingGroup.subscriptions.length > 0) {
                    // Try to find bundle selections from subscriptions
                    for (const subscription of this.currentEditingGroup.subscriptions) {
                        if (subscription.bundleSelections && subscription.bundleSelections.length > 0) {
                            targetBundleSelectionId = subscription.bundleSelections[0].id;
                            console.log(`📦 Found bundle selection from subscription: ${targetBundleSelectionId}`);
                            break;
                        }
                    }
                }
                
                if (targetBundleSelectionId) {
                    newItem._bundleSelectionId = targetBundleSelectionId;
                    console.log(`✅ Added bundle selection ID ${targetBundleSelectionId} to new bundle item`);
                } else {
                    console.log(`⚠️ No existing bundle selection found - will create new bundle with subscription`);
                    
                    // Add required fields for creating a new bundle (subscription + bundle selection)
                    newItem.address_id = this.currentEditingGroup.address_id;
                    
                    // Use subscription settings from current editing group or defaults
                    if (this.currentEditingGroup.subscriptions && this.currentEditingGroup.subscriptions.length > 0) {
                        const firstSub = this.currentEditingGroup.subscriptions[0];
                        newItem.charge_interval_frequency = firstSub.charge_interval_frequency || 4;
                        newItem.order_interval_frequency = firstSub.order_interval_frequency || firstSub.charge_interval_frequency || 4;
                        newItem.order_interval_unit = firstSub.order_interval_unit || 'week';
                        newItem.next_charge_scheduled_at = firstSub.next_charge_scheduled_at || this.currentEditingGroup.next_charge_scheduled_at;
                    } else {
                        // Default bundle subscription settings
                        newItem.charge_interval_frequency = 4; // 4 weeks
                        newItem.order_interval_frequency = 4;
                        newItem.order_interval_unit = 'week';
                        
                        // Default next charge date (4 weeks from now)
                        const nextChargeDate = new Date();
                        nextChargeDate.setDate(nextChargeDate.getDate() + 28); // 4 weeks = 28 days
                        newItem.next_charge_scheduled_at = nextChargeDate.toISOString().split('T')[0];
                    }
                    
                    console.log(`📦 Added bundle creation fields:`, {
                        address_id: newItem.address_id,
                        charge_interval_frequency: newItem.charge_interval_frequency,
                        order_interval_frequency: newItem.order_interval_frequency,
                        order_interval_unit: newItem.order_interval_unit,
                        next_charge_scheduled_at: newItem.next_charge_scheduled_at
                    });
                }
            }
            
            this.temporaryCart.push(newItem);
            console.log(`Added new product ${product.full_title} to temporary cart with type "${itemType}":`, newItem);
        }
        
        console.log('Updated temporary cart:', this.temporaryCart);
    },

    /**
     * Remove or decrement a product from the temporary cart
     */
    removeProductFromBundle(product) {
        console.log('Remove/decrement product from bundle:', product);
        
        const existingItemIndex = this.temporaryCart.findIndex(item => {
            const matches = [
                // Direct product ID match (for products without variants)
                !product.variant_id && item.product_id === product.id,
                // Variant-specific match (preferred for products with variants)
                product.variant_id && item.variant_id === product.variant_id,
                // String conversion matches
                !product.variant_id && item.product_id === String(product.id),
                product.variant_id && item.variant_id === String(product.variant_id),
                !product.variant_id && String(item.product_id) === String(product.id),
                product.variant_id && String(item.variant_id) === String(product.variant_id)
            ];
            
            return matches.some(match => match);
        });
        
        if (existingItemIndex !== -1) {
            const existingItem = this.temporaryCart[existingItemIndex];
            
            if (existingItem.quantity > 1) {
                // Decrement quantity if more than 1
                existingItem.quantity -= 1;
                console.log(`Decremented quantity for ${product.full_title}. New quantity: ${existingItem.quantity}`);
            } else {
                // Remove item completely if quantity is 1
                this.temporaryCart.splice(existingItemIndex, 1);
                console.log(`Removed ${product.full_title} from temporary cart`);
            }
        }
        
        console.log('Updated temporary cart:', this.temporaryCart);
    },

    /**
     * Get the quantity of a product in the temporary cart for display
     */
    getProductQuantityInCart(product) {
        if (!this.temporaryCart || this.temporaryCart.length === 0) {
            return 0;
        }
        
        console.log('Checking quantity for product:', {
            id: product.id,
            variant_id: product.variant_id,
            title: product.title,
            full_title: product.full_title
        });
        console.log('Current temporary cart:', this.temporaryCart);
        
        const cartItem = this.temporaryCart.find(item => {
            // Try multiple matching strategies for variant-specific products
            const matches = [
                // Direct product ID match (for products without variants)
                !product.variant_id && item.product_id === product.id,
                // Variant-specific match (preferred for products with variants)
                product.variant_id && item.variant_id === product.variant_id,
                // String conversion matches
                !product.variant_id && item.product_id === String(product.id),
                product.variant_id && item.variant_id === String(product.variant_id),
                !product.variant_id && String(item.product_id) === String(product.id),
                product.variant_id && String(item.variant_id) === String(product.variant_id)
            ];
            
            const isMatch = matches.some(match => match);
            
            if (isMatch) {
                console.log('Found matching cart item:', item, 'for product:', product.full_title);
            }
            
            return isMatch;
        });
        
        const quantity = cartItem ? cartItem.quantity : 0;
        console.log(`Product ${product.full_title} (ID: ${product.id}, Variant: ${product.variant_id}) has quantity: ${quantity}`);
        
        return quantity;
    },

    /**
     * Check if a product/variant is in the BAB collection for labeling
     */
    isProductInBABCollection(product) {
        if (!this.babCollectionProducts || this.babCollectionProducts.length === 0) {
            return false;
        }
        
        const babProduct = this.babCollectionProducts.find(babItem => {
            const matches = [
                // Direct product ID match (for products without variants)
                !product.variant_id && babItem.id === product.id,
                // Variant-specific match (preferred for products with variants)
                product.variant_id && babItem.variant_id === product.variant_id,
                // String conversion matches
                !product.variant_id && babItem.id === String(product.id),
                product.variant_id && babItem.variant_id === String(product.variant_id),
                !product.variant_id && String(babItem.id) === String(product.id),
                product.variant_id && String(babItem.variant_id) === String(product.variant_id)
            ];
            
            return matches.some(match => match);
        });
        
        return !!babProduct;
    },

    /**
     * Determine the type of item for temporary cart tracking
     * Returns: "bundle", "subscription", "onetime", or "other"
     */
    getItemType(product, context = null) {
        console.log('=== getItemType() DEBUG ===');
        console.log('Input product:', product);
        console.log('Context:', context);
        
        // First check if product is in BAB collection
        if (this.isProductInBABCollection(product)) {
            console.log('Product is in BAB collection, returning "bundle"');
            return "bundle";
        }
        
        // Special case: if this is called from subscription initialization and we have context
        if (context === 'subscription') {
            console.log('Product is from subscription context, returning "subscription"');
            return "subscription";
        }
        
        // If not in BAB collection, check Recharge products
        if (!this.products || this.products.length === 0) {
            console.log('No Recharge products available, returning "other"');
            return "other";
        }
        
        console.log('Searching Recharge products for match...');
        console.log('Available Recharge products count:', this.products.length);
        
        // Find matching Recharge product by external_product_id
        const rechargeProduct = this.products.find(p => {
            const productMatches = [
                // Match by product ID
                p.external_product_id === product.id,
                p.external_product_id === String(product.id),
                String(p.external_product_id) === String(product.id),
                // Also try matching by ID field if external_product_id doesn't exist
                p.id === product.id,
                p.id === String(product.id),
                String(p.id) === String(product.id)
            ];
            
            const isMatch = productMatches.some(match => match);
            if (isMatch) {
                console.log('Found matching Recharge product:', p);
            }
            return isMatch;
        });
        
        if (!rechargeProduct) {
            console.log('No matching Recharge product found, returning "other"');
            // Debug: show what products we have
            console.log('Sample Recharge products (first 3):', this.products.slice(0, 3).map(p => ({
                id: p.id,
                external_product_id: p.external_product_id,
                title: p.title
            })));
            return "other";
        }
        
        console.log('Found matching Recharge product, checking plans...');
        console.log('Recharge product structure:', rechargeProduct);
        
        // Check plans array for subscription/onetime types
        if (rechargeProduct.plans && Array.isArray(rechargeProduct.plans)) {
            console.log('Product has plans array:', rechargeProduct.plans);
            const hasSubscription = rechargeProduct.plans.some(plan => plan.type === "subscription");
            const hasOnetime = rechargeProduct.plans.some(plan => plan.type === "onetime");
            
            console.log('Plan analysis:', { hasSubscription, hasOnetime });
            
            if (hasSubscription && !hasOnetime) {
                console.log('Product has subscription plan only, returning "subscription"');
                return "subscription";
            } else if (hasOnetime && !hasSubscription) {
                console.log('Product has onetime plan only, returning "onetime"');
                return "onetime";
            } else if (hasSubscription && hasOnetime) {
                console.log('Product has both plans, defaulting to "subscription"');
                return "subscription";
            }
        } else {
            console.log('Product has no plans array or plans is not an array');
            console.log('Checking for alternative subscription indicators...');
        }
        
        // Fallback: check if product has subscription-like properties
        if (rechargeProduct.subscription_defaults || rechargeProduct.is_subscription_product) {
            console.log('Product has subscription indicators, returning "subscription"');
            return "subscription";
        }
        
        // Additional fallback: check for common Recharge subscription fields
        if (rechargeProduct.subscription_id || rechargeProduct.delivery_frequency || rechargeProduct.charge_interval_frequency) {
            console.log('Product has Recharge subscription fields, returning "subscription"');
            return "subscription";
        }
        
        console.log('No clear plan type found, returning "other"');
        return "other";
    },

    /**
     * Get the appropriate product label based on collection and Recharge status
     */
    getProductLabel(product) {
        // First check if product is in BAB collection
        if (this.isProductInBABCollection(product)) {
            return "BULK SAVE";
        }
        
        // If not in BAB collection, check Recharge products
        if (!this.products || this.products.length === 0) {
            return "Not in Recharge";
        }
        
        // Find matching Recharge product by external_product_id and external_variant_id
        const rechargeProduct = this.products.find(p => {
            const productMatches = [
                // Match by product ID
                p.external_product_id === product.id,
                p.external_product_id === String(product.id),
                String(p.external_product_id) === String(product.id)
            ];
            
            return productMatches.some(match => match);
        });
        
        if (!rechargeProduct) {
            return "Not in Recharge";
        }
        
        // Check plans array for subscription/onetime types
        if (rechargeProduct.plans && Array.isArray(rechargeProduct.plans)) {
            const hasSubscription = rechargeProduct.plans.some(plan => plan.type === "subscription");
            const hasOnetime = rechargeProduct.plans.some(plan => plan.type === "onetime");
            
            //if (hasSubscription && hasOnetime) {
            //    return "SUBSCRIPTION / ONE-TIME";
            //} else
            if (hasSubscription) {
                return "SUBSCRIPTION";
            } else if (hasOnetime) {
                return "ONE-TIME";
            }
        }
        
        // Fallback: check if product has subscription-like properties
        // Some Recharge APIs might structure data differently
        if (rechargeProduct.subscription_defaults || rechargeProduct.is_subscription_product) {
            return "SUBSCRIPTION";
        }
        
        // If found in Recharge but no clear plan type
        return "Not in Recharge";
    },

    /**
     * Get the CSS classes for product label styling
     */
    getProductLabelClasses(label) {
        switch (label) {
            case "BULK SAVE":
                return "text-bulk-save bg-bulk-save";
            case "SUBSCRIPTION":
                return "text-green-600 bg-green-100";
            case "ONE-TIME":
                return "text-onetime bg-onetime";
            //case "SUBSCRIPTION / ONE-TIME":
            //    return "text-purple-600 bg-purple-100";
            case "Not in Recharge":
            default:
                return "text-gray-600 bg-gray-100";
        }
    },

    /**
     * Get temporary cart statistics by item type
     */
    getTemporaryCartStats() {
        const stats = {
            bundle: { count: 0, quantity: 0 },
            subscription: { count: 0, quantity: 0 },
            onetime: { count: 0, quantity: 0 },
            other: { count: 0, quantity: 0 },
            total: { count: 0, quantity: 0 }
        };
        
        this.temporaryCart.forEach(item => {
            // Only count items with quantity > 0 (exclude out-of-stock items marked for removal)
            const quantity = item.quantity || 0;
            if (quantity > 0) {
                const type = item.item_type || 'other';
                if (stats[type]) {
                    stats[type].count++;
                    stats[type].quantity += quantity;
                }
                stats.total.count++;
                stats.total.quantity += quantity;
            }
        });
        
        return stats;
    },

    /**
     * Calculate discount for temporary cart (reusing the discount logic from getBundleDiscount)
     * This is used in the bundle selection modal to show real-time discount updates
     * Only bundle items count towards the volume discount
     */
    getTemporaryCartDiscount() {
        // Discount levels based on number of products (same as getBundleDiscount)
        const discountLevels = [
            { products: 0, discount: 0.00 },
            { products: 1, discount: 0.00 },
            { products: 2, discount: 0.00 },
            { products: 3, discount: 0.00 },
            { products: 4, discount: 0.00 },
            { products: 5, discount: 7.76 },
            { products: 6, discount: 9.10 },
            { products: 7, discount: 14.78 },
            { products: 8, discount: 20.80 },
            { products: 9, discount: 21.07 },
            { products: 10, discount: 23.81 },
            { products: 11, discount: 24.28 },
            { products: 12, discount: 34.10 }
        ];

        // Calculate total quantity of BUNDLE items only in temporary cart
        const stats = this.getTemporaryCartStats();
        const totalProducts = stats.bundle.quantity;

        // Find the discount rate based on product count (same logic as getBundleDiscount)
        let baseDiscount = 0;
        
        if (totalProducts >= 12) {
            // Anything over 12 products gets the highest discount
            baseDiscount = 34.10;
        } else {
            // Find the exact match in the discount table
            const discountLevel = discountLevels.find(level => level.products === totalProducts);
            baseDiscount = discountLevel ? discountLevel.discount : 0;
        }

        // Stack 5% subscription discount with base discount (same as getBundleDiscount)
        const totalDiscount = baseDiscount + (100 - baseDiscount) * 0.05;

        return {
            baseDiscount: baseDiscount,
            subscriptionBonus: 5.00,
            totalDiscount: totalDiscount,
            totalProducts: totalProducts
        };
    },

    /**
     * Calculate discounted price for a product based on current temporary cart discount
     * Bundle items get full discount, subscription items get only bonus discount, one-time items get no discount
     */
    getDiscountedPrice(originalPrice, product) {
        if (!originalPrice || originalPrice <= 0) {
            return originalPrice;
        }

        if (product) {
            const itemType = this.getItemType(product);
            
            if (itemType === 'bundle') {
                // Bundle items get the full discount (volume + subscription bonus)
                const discount = this.getTemporaryCartDiscount();
                const discountMultiplier = (100 - discount.totalDiscount) / 100;
                return originalPrice * discountMultiplier;
            } else if (itemType === 'subscription') {
                // Subscription items get only the 5% subscription bonus discount
                const subscriptionBonusDiscount = 5.0;
                const discountMultiplier = (100 - subscriptionBonusDiscount) / 100;
                return originalPrice * discountMultiplier;
            } else {
                // One-time items and other types get no discount
                return originalPrice;
            }
        } else {
            // If no product passed, assume it's not eligible for discount (backwards compatibility)
            return originalPrice;
        }
    },

    /**
     * Check if the temporary cart qualifies for any discount
     */
    hasTemporaryCartDiscount() {
        const discount = this.getTemporaryCartDiscount();
        return discount.totalDiscount > 0;
    },

    /**
     * Check if there are subscription items in the temporary cart
     */
    hasSubscriptionItemsInCart() {
        const stats = this.getTemporaryCartStats();
        return stats.subscription.quantity > 0;
    },

    /**
     * Get information about the next discount level (only bundle items count)
     */
    getNextDiscountLevel() {
        const discountLevels = [
            { products: 5, discount: 7.76 },
            { products: 6, discount: 9.10 },
            { products: 7, discount: 14.78 },
            { products: 8, discount: 20.80 },
            { products: 9, discount: 21.07 },
            { products: 10, discount: 23.81 },
            { products: 11, discount: 24.28 },
            { products: 12, discount: 34.10 }
        ];

        const stats = this.getTemporaryCartStats();
        const currentProducts = stats.bundle.quantity;

        // Find the next discount level
        const nextLevel = discountLevels.find(level => level.products > currentProducts);
        
        if (nextLevel) {
            return {
                productsNeeded: nextLevel.products - currentProducts,
                nextDiscount: nextLevel.discount + (100 - nextLevel.discount) * 0.05, // Include subscription bonus
                nextThreshold: nextLevel.products
            };
        }

        return null; // Already at max discount or beyond
    },

    /**
     * Validate bundle configuration in delivery schedule
     * Returns validation result with warnings if multiple bundles found
     */
    validateBundleConfiguration() {
        if (!this.currentEditingGroup) {
            return { isValid: true, warnings: [] };
        }

        // Count parent bundle subscriptions (subscriptions that have bundleSelections)
        // We should look at the currentEditingGroup.subscriptions, not the cart items
        const bundleSubscriptions = (this.currentEditingGroup.subscriptions || []).filter(subscription => 
            subscription.bundleSelections && subscription.bundleSelections.length > 0
        );

        const warnings = [];
        let isValid = true;

        if (bundleSubscriptions.length > 1) {
            isValid = false;
            warnings.push(
                `This delivery schedule contains ${bundleSubscriptions.length} bundle subscriptions, but only 1 bundle subscription per delivery schedule is supported. ` +
                'Multiple bundle subscriptions can cause conflicts with product selections and delivery schedules. ' +
                'Please contact customer support to resolve this configuration before making changes.'
            );
            console.warn('Multiple bundle subscriptions detected:', bundleSubscriptions);
        }

        return { isValid, warnings, bundleCount: bundleSubscriptions.length, bundleItems: bundleSubscriptions };
    },

    /**
     * Check if bundle operations should be blocked due to configuration issues
     */
    shouldBlockBundleOperations() {
        const validation = this.validateBundleConfiguration();
        return !validation.isValid;
    },

    async saveBundleProducts() {
        console.log('=== SAVING BUNDLE PRODUCTS ===');
        console.log('Current editing group:', this.currentEditingGroup);
        
        if (!this.currentEditingGroup) {
            alert('Error: No delivery schedule selected for editing');
            return;
        }

        // Validate bundle configuration before allowing changes
        const bundleValidation = this.validateBundleConfiguration();
        if (!bundleValidation.isValid) {
            alert(bundleValidation.warnings.join('\n\n'));
            return;
        }
        
        // Check if there's at least one subscription item in the cart
        const stats = this.getTemporaryCartStats();
        const totalSubscriptionItems = stats.subscription.quantity + stats.bundle.quantity;
        
        if (totalSubscriptionItems === 0) {
            // Show error modal instead of allowing save
            this.showError(
                'No Subscription Items Selected',
                'You must select at least one subscription item. If you want to cancel your subscription, please close this window and use the "Cancel" button from the delivery schedule section.',
                null
            );
            return;
        }
        
        // Detect changes before saving
        const changes = this.detectCartChanges();
        console.log('Changes to be processed:', changes);
        
        if (!this.hasChanges()) {
            alert('No changes detected. Nothing to save.');
            this.closeBundleProductsModal();
            return;
        }
        
        // Prepare changes summary for logging
        const summary = this.getChangesSummary();
        console.log('Changes to save:', summary);
        
        
        try {
            this.loadingStates.savingBundleProducts = true;
            
            const results = {
                bundle: null,
                subscriptions: [],
                onetimes: [],
                errors: []
            };
            
            // Process changes by type
            // 1. Process added items first (to ensure subscription exists)
            if (changes.added.length > 0) {
                console.log('Processing added items:', changes.added);
                await this.processAddedItems(changes.added, results);
            }
            
            // 2. Process modified items (quantity changes)
            if (changes.modified.length > 0) {
                console.log('Processing modified items:', changes.modified);
                await this.processModifiedItems(changes.modified, results);
            }
            
            // 3. Process removed items last (to avoid deleting subscription before adding new items)
            if (changes.removed.length > 0) {
                console.log('Processing removed items:', changes.removed);
                await this.processRemovedItems(changes.removed, results);
            }
            
            console.log('Save results:', results);
            
            // Check for any errors
            if (results.errors.length > 0) {
                console.error('Save completed with errors:', results.errors);
                alert(`Changes saved with some errors:\n${results.errors.join('\n')}`);
            } else {
                console.log('Save completed successfully');
                // Success - no alert needed, just close modal silently
            }
            
            // Close modal and refresh data
            this.closeBundleProductsModal();
            await this.loadAllSubscriptions();
            await this.loadOnetimes();
            
        } catch (error) {
            console.error('Failed to save bundle products:', error);
            alert(`Failed to save changes: ${error.message}`);
        } finally {
            this.loadingStates.savingBundleProducts = false;
        }
    },

    // ========================================
    // CHANGE PROCESSING METHODS
    // ========================================

    /**
     * Process removed items (delete subscriptions/one-time orders)
     */
    async processRemovedItems(removedItems, results) {
        console.log('Processing removed items:', removedItems);
        
        // Separate items that should go through server endpoint vs old methods
        const serverItems = removedItems.filter(item => 
            item.item_type === 'subscription' || 
            item.item_type === 'onetime' || 
            item.item_type === 'bundle'
        );
        const otherItems = removedItems.filter(item => 
            item.item_type !== 'subscription' && 
            item.item_type !== 'onetime' && 
            item.item_type !== 'bundle'
        );
        
        // Process subscriptions and onetimes through server endpoint
        if (serverItems.length > 0) {
            try {
                console.log('Processing subscription, onetime, and bundle deletions through server:', serverItems);
                
                const response = await fetch(this.apiUrl('/process-subscription-changes'), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        changes: {
                            removed: serverItems,
                            modified: [],
                            added: []
                        }
                    })
                });

                const serverResponse = await response.json();
                
                if (serverResponse.success) {
                    console.log('Server successfully processed deletions:', serverResponse.results);
                    // Add server results to our results
                    serverResponse.results.removed.forEach(item => {
                        if (item.type === 'subscription') {
                            results.subscriptions.push({ 
                                action: 'deleted', 
                                id: item.id, 
                                title: item.title,
                                success: item.success 
                            });
                        } else if (item.type === 'onetime') {
                            results.onetimes.push({ 
                                action: 'deleted', 
                                id: item.id, 
                                title: item.title,
                                success: item.success 
                            });
                        }
                    });
                    // Add any server errors
                    if (serverResponse.results.errors.length > 0) {
                        results.errors.push(...serverResponse.results.errors);
                    }
                } else {
                    console.error('Server failed to process deletions:', serverResponse);
                    results.errors.push(`Server error: ${serverResponse.error}`);
                }
                
            } catch (error) {
                console.error('Failed to call server for deletions:', error);
                results.errors.push(`Failed to process deletions: ${error.message}`);
            }
        }
        
        // Process other item types with existing logic
        for (const item of otherItems) {
            try {
                if (item.item_type === 'bundle') {
                    // Handle bundle item removal - update bundle selections
                    console.log('Removing bundle item:', item);
                    // TODO: Implement bundle item removal
                    results.bundle = { action: 'removed', item: item, success: true };
                }
                
            } catch (error) {
                console.error('Failed to remove item:', item, error);
                results.errors.push(`Failed to remove ${item.title}: ${error.message}`);
            }
        }
    },

    /**
     * Process modified items (update quantities)
     */
    async processModifiedItems(modifiedItems, results) {
        console.log('Processing modified items:', modifiedItems);
        
        // Separate items that should go through server endpoint vs old methods
        const serverItems = modifiedItems.filter(item => 
            item.item_type === 'subscription' || 
            item.item_type === 'onetime' || 
            item.item_type === 'bundle'
        );
        const otherItems = modifiedItems.filter(item => 
            item.item_type !== 'subscription' && 
            item.item_type !== 'onetime' && 
            item.item_type !== 'bundle'
        );
        
        // Process subscriptions, onetimes, and bundles through server endpoint
        if (serverItems.length > 0) {
            try {
                console.log('Processing subscription, onetime, and bundle updates through server:', serverItems);
                
                const response = await fetch(this.apiUrl('/process-subscription-changes'), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        changes: {
                            removed: [],
                            modified: serverItems,
                            added: []
                        }
                    })
                });

                const serverResponse = await response.json();
                
                if (serverResponse.success) {
                    console.log('Server successfully processed updates:', serverResponse.results);
                    // Add server results to our results
                    serverResponse.results.modified.forEach(item => {
                        if (item.type === 'subscription') {
                            results.subscriptions.push({ 
                                action: 'updated', 
                                id: item.id, 
                                title: item.title,
                                quantity: item.newQuantity,
                                oldQuantity: item.oldQuantity,
                                success: item.success 
                            });
                        } else if (item.type === 'onetime') {
                            results.onetimes.push({ 
                                action: 'updated', 
                                id: item.id, 
                                title: item.title,
                                quantity: item.newQuantity,
                                oldQuantity: item.oldQuantity,
                                success: item.success 
                            });
                        }
                    });
                    // Add any server errors
                    if (serverResponse.results.errors.length > 0) {
                        results.errors.push(...serverResponse.results.errors);
                    }
                } else {
                    console.error('Server failed to process updates:', serverResponse);
                    results.errors.push(`Server error: ${serverResponse.error}`);
                }
                
            } catch (error) {
                console.error('Failed to call server for updates:', error);
                results.errors.push(`Failed to process updates: ${error.message}`);
            }
        }
        
        // Process other item types with existing logic
        for (const item of otherItems) {
            try {
                if (item.item_type === 'bundle') {
                    // Handle bundle item quantity change
                    console.log('Updating bundle item quantity:', item);
                    // TODO: Implement bundle item quantity update
                    results.bundle = { action: 'updated', item: item, success: true };
                }
                
            } catch (error) {
                console.error('Failed to update item:', item, error);
                results.errors.push(`Failed to update ${item.title}: ${error.message}`);
            }
        }
    },

    /**
     * Process added items (create new subscriptions/one-time orders)
     */
    async processAddedItems(addedItems, results) {
        console.log('Processing added items:', addedItems);
        
        // Separate items that should go through server endpoint vs old methods
        const serverItems = addedItems.filter(item => 
            item.item_type === 'subscription' || 
            item.item_type === 'onetime' || 
            item.item_type === 'bundle'
        );
        const otherItems = addedItems.filter(item => 
            item.item_type !== 'subscription' && 
            item.item_type !== 'onetime' && 
            item.item_type !== 'bundle'
        );
        
        // Process subscriptions, onetimes, and bundles through server endpoint
        if (serverItems.length > 0) {
            try {
                console.log('Processing subscription, onetime, and bundle creations through server:', serverItems);
                
                const response = await fetch(this.apiUrl('/process-subscription-changes'), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        changes: {
                            removed: [],
                            modified: [],
                            added: serverItems
                        }
                    })
                });

                const serverResponse = await response.json();
                
                if (serverResponse.success) {
                    console.log('Server successfully processed creations:', serverResponse.results);
                    // Add server results to our results
                    serverResponse.results.added.forEach(item => {
                        if (item.type === 'subscription') {
                            results.subscriptions.push({ 
                                action: 'created', 
                                id: item.id, 
                                title: item.title,
                                quantity: item.quantity,
                                success: item.success 
                            });
                        } else if (item.type === 'onetime') {
                            results.onetimes.push({ 
                                action: 'created', 
                                id: item.id, 
                                title: item.title,
                                quantity: item.quantity,
                                success: item.success 
                            });
                        }
                    });
                    // Add any server errors
                    if (serverResponse.results.errors.length > 0) {
                        results.errors.push(...serverResponse.results.errors);
                    }
                } else {
                    console.error('Server failed to process creations:', serverResponse);
                    results.errors.push(`Server error: ${serverResponse.error}`);
                }
                
            } catch (error) {
                console.error('Failed to call server for creations:', error);
                results.errors.push(`Failed to process creations: ${error.message}`);
            }
        }
        
        // Process other item types with existing logic
        for (const item of otherItems) {
            try {
                if (item.item_type === 'bundle') {
                    // Handle bundle item addition - not typically done as bundles are pre-configured
                    console.log('Adding bundle item (unusual):', item);
                    // TODO: Implement bundle item addition if needed
                    results.bundle = { action: 'added', item: item, success: true };
                }
                
            } catch (error) {
                console.error('Failed to add item:', item, error);
                results.errors.push(`Failed to add ${item.title}: ${error.message}`);
            }
        }
    },

    /**
     * Helper method to create a new subscription from cart item
     */
    async createSubscription(item) {
        const { address_id, charge_interval_frequency, order_interval_unit, next_charge_scheduled_at } = this.currentEditingGroup;
        
        const subscriptionData = {
            address_id: address_id,
            shopify_product_id: item.product_id,
            shopify_variant_id: item.variant_id,
            external_product_id: item.product_id,
            external_variant_id: item.variant_id,
            quantity: item.quantity,
            charge_interval_frequency: charge_interval_frequency,
            order_interval_unit: order_interval_unit,
            next_charge_scheduled_at: next_charge_scheduled_at
        };
        
        console.log('Creating subscription with data:', subscriptionData);
        
        // TODO: Implement actual Recharge API call
        // const result = await this.callRechargeAPI(async (session) => {
        //     return await recharge.subscription.create(session, subscriptionData);
        // });
        
        // For now, return mock success
        return { id: 'new_subscription_id', ...subscriptionData };
    },

    /**
     * Helper method to create a new one-time order from cart item
     */
    async createOnetime(item) {
        const { address_id, next_charge_scheduled_at } = this.currentEditingGroup;
        
        const onetimeData = {
            address_id: address_id,
            shopify_product_id: item.product_id,
            shopify_variant_id: item.variant_id,
            external_product_id: item.product_id,
            external_variant_id: item.variant_id,
            quantity: item.quantity,
            next_charge_scheduled_at: next_charge_scheduled_at
        };
        
        console.log('Creating one-time order with data:', onetimeData);
        
        // TODO: Implement actual Recharge API call
        // const result = await this.callRechargeAPI(async (session) => {
        //     return await recharge.onetime.create(session, onetimeData);
        // });
        
        // For now, return mock success
        return { id: 'new_onetime_id', ...onetimeData };
    },

    /**
     * Helper method to delete a subscription
     */
    async deleteSubscription(subscriptionId) {
        console.log('Deleting subscription:', subscriptionId);
        
        // TODO: Implement actual Recharge API call
        // const result = await this.callRechargeAPI(async (session) => {
        //     return await recharge.subscription.delete(session, subscriptionId);
        // });
        
        // For now, return mock success
        return { success: true, id: subscriptionId };
    },

    /**
     * Helper method to delete a one-time order
     */
    async deleteOnetime(onetimeId) {
        console.log('Deleting one-time order:', onetimeId);
        
        // TODO: Implement actual Recharge API call
        // const result = await this.callRechargeAPI(async (session) => {
        //     return await recharge.onetime.delete(session, onetimeId);
        // });
        
        // For now, return mock success
        return { success: true, id: onetimeId };
    },

    /**
     * Helper method to update subscription quantity
     */
    async updateSubscriptionQuantity(subscriptionId, newQuantity) {
        console.log('Updating subscription quantity:', subscriptionId, newQuantity);
        
        // TODO: Implement actual Recharge API call
        // const result = await this.callRechargeAPI(async (session) => {
        //     return await recharge.subscription.update(session, subscriptionId, { quantity: newQuantity });
        // });
        
        // For now, return mock success
        return { success: true, id: subscriptionId, quantity: newQuantity };
    },

    /**
     * Helper method to update one-time order quantity
     */
    async updateOnetimeQuantity(onetimeId, newQuantity) {
        console.log('Updating one-time order quantity:', onetimeId, newQuantity);
        
        // TODO: Implement actual Recharge API call
        // const result = await this.callRechargeAPI(async (session) => {
        //     return await recharge.onetime.update(session, onetimeId, { quantity: newQuantity });
        // });
        
        // For now, return mock success
        return { success: true, id: onetimeId, quantity: newQuantity };
    },

    /**
     * Find existing bundle in current editing group
     */
    findExistingBundle() {
        if (!this.currentEditingGroup || !this.currentEditingGroup.subscriptions) {
            return null;
        }
        
        // Look for a subscription that has bundle contents
        for (const subscription of this.currentEditingGroup.subscriptions) {
            const bundleContents = this.getBundleContents(subscription);
            if (bundleContents && bundleContents.length > 0) {
                console.log('Found existing bundle in subscription:', subscription.id);
                return subscription;
            }
        }
        
        return null;
    },

    /**
     * Update bundle items in existing bundle
     */
    async updateBundleItems(bundleSubscription, bundleItems) {
        console.log('Updating bundle items for subscription:', bundleSubscription.id);
        console.log('New bundle items:', bundleItems);
        
        try {
            // TODO: Implement bundle update API call
            // This will likely involve updating the bundle_selections for the subscription
            
            console.log('Bundle items update - TO BE IMPLEMENTED');
            
            // For now, return success
            return { success: true, subscription_id: bundleSubscription.id, items: bundleItems };
            
        } catch (error) {
            console.error('Failed to update bundle items:', error);
            throw new Error(`Failed to update bundle items: ${error.message}`);
        }
    },

    /**
     * Update regular subscription items
     */
    async updateSubscriptionItems(subscriptionItems) {
        console.log('Updating subscription items:', subscriptionItems);
        
        const results = [];
        
        for (const item of subscriptionItems) {
            try {
                // Find existing subscription for this product/variant
                const existingSubscription = this.findExistingSubscription(item);
                
                if (existingSubscription) {
                    // Update existing subscription quantity
                    console.log(`Updating existing subscription ${existingSubscription.id} quantity to ${item.quantity}`);
                    const result = await this.updateSubscriptionQuantity(existingSubscription.id, item.quantity);
                    results.push(result);
                } else {
                    // Create new subscription
                    console.log('Creating new subscription for item:', item);
                    const result = await this.createNewSubscription(item);
                    results.push(result);
                }
                
            } catch (error) {
                console.error(`Failed to update subscription item ${item.title}:`, error);
                results.push({ error: `Failed to update ${item.title}: ${error.message}` });
            }
        }
        
        return results;
    },

    /**
     * Update one-time order items
     */
    async updateOnetimeItems(onetimeItems) {
        console.log('Updating one-time items:', onetimeItems);
        
        const results = [];
        
        for (const item of onetimeItems) {
            try {
                // Find existing one-time order for this product/variant
                const existingOnetime = this.findExistingOnetime(item);
                
                if (existingOnetime) {
                    // Update existing one-time order quantity
                    console.log(`Updating existing one-time order ${existingOnetime.id} quantity to ${item.quantity}`);
                    const result = await this.updateOnetimeQuantity(existingOnetime.id, item.quantity);
                    results.push(result);
                } else {
                    // Create new one-time order
                    console.log('Creating new one-time order for item:', item);
                    const result = await this.createNewOnetime(item);
                    results.push(result);
                }
                
            } catch (error) {
                console.error(`Failed to update one-time item ${item.title}:`, error);
                results.push({ error: `Failed to update ${item.title}: ${error.message}` });
            }
        }
        
        return results;
    },

    /**
     * Find existing subscription in current group for a cart item
     */
    findExistingSubscription(cartItem) {
        if (!this.currentEditingGroup || !this.currentEditingGroup.subscriptions) {
            return null;
        }
        
        return this.currentEditingGroup.subscriptions.find(subscription => {
            // Match by external_product_id and external_variant_id
            const productIdMatch = String(subscription.external_product_id) === String(cartItem.product_id);
            const variantIdMatch = !cartItem.variant_id || String(subscription.external_variant_id) === String(cartItem.variant_id);
            
            return productIdMatch && variantIdMatch;
        });
    },

    /**
     * Find existing one-time order in current group for a cart item
     */
    findExistingOnetime(cartItem) {
        // TODO: Implement finding existing one-time orders
        // This depends on how one-time orders are structured in the currentEditingGroup
        console.log('Finding existing one-time order - TO BE IMPLEMENTED');
        return null;
    },

    /**
     * Update subscription quantity via Recharge API
     */
    async updateSubscriptionQuantity(subscriptionId, newQuantity) {
        console.log(`Updating subscription ${subscriptionId} quantity to ${newQuantity}`);
        
        try {
            const result = await this.callRechargeAPI(async (session) => {
                const updateData = {
                    quantity: newQuantity
                };
                
                console.log('Subscription update data:', updateData);
                
                if (recharge.subscription && typeof recharge.subscription.update === 'function') {
                    return await recharge.subscription.update(session, subscriptionId, updateData);
                } else {
                    throw new Error('Subscription update API method not available');
                }
            });
            
            console.log('Subscription update result:', result);
            return { success: true, subscription_id: subscriptionId, new_quantity: newQuantity };
            
        } catch (error) {
            console.error('Failed to update subscription quantity:', error);
            throw error;
        }
    },

    /**
     * Update one-time order quantity via Recharge API
     */
    async updateOnetimeQuantity(onetimeId, newQuantity) {
        console.log(`Updating one-time order ${onetimeId} quantity to ${newQuantity}`);
        
        try {
            const result = await this.callRechargeAPI(async (session) => {
                const updateData = {
                    quantity: newQuantity
                };
                
                console.log('One-time order update data:', updateData);
                
                if (recharge.onetime && typeof recharge.onetime.update === 'function') {
                    return await recharge.onetime.update(session, onetimeId, updateData);
                } else {
                    throw new Error('One-time order update API method not available');
                }
            });
            
            console.log('One-time order update result:', result);
            return { success: true, onetime_id: onetimeId, new_quantity: newQuantity };
            
        } catch (error) {
            console.error('Failed to update one-time order quantity:', error);
            throw error;
        }
    },

    /**
     * Create new subscription via Recharge API
     */
    async createNewSubscription(cartItem) {
        console.log('Creating new subscription for cart item:', cartItem);
        
        try {
            const result = await this.callRechargeAPI(async (session) => {
                const subscriptionData = {
                    external_product_id: cartItem.product_id,
                    external_variant_id: cartItem.variant_id,
                    quantity: cartItem.quantity,
                    address_id: this.currentEditingGroup.address_id,
                    charge_interval_frequency: this.currentEditingGroup.charge_interval_frequency,
                    order_interval_unit: this.currentEditingGroup.order_interval_unit,
                    next_charge_scheduled_at: this.currentEditingGroup.next_charge_scheduled_at
                };
                
                console.log('New subscription data:', subscriptionData);
                
                if (recharge.subscription && typeof recharge.subscription.create === 'function') {
                    return await recharge.subscription.create(session, subscriptionData);
                } else {
                    throw new Error('Subscription create API method not available');
                }
            });
            
            console.log('New subscription created:', result);
            return { success: true, subscription: result, cart_item: cartItem };
            
        } catch (error) {
            console.error('Failed to create new subscription:', error);
            throw error;
        }
    },

    /**
     * Create new one-time order via Recharge API
     */
    async createNewOnetime(cartItem) {
        console.log('Creating new one-time order for cart item:', cartItem);
        
        try {
            const result = await this.callRechargeAPI(async (session) => {
                const onetimeData = {
                    external_product_id: cartItem.product_id,
                    external_variant_id: cartItem.variant_id,
                    quantity: cartItem.quantity,
                    address_id: this.currentEditingGroup.address_id,
                    next_charge_scheduled_at: this.currentEditingGroup.next_charge_scheduled_at
                };
                
                console.log('New one-time order data:', onetimeData);
                
                if (recharge.onetime && typeof recharge.onetime.create === 'function') {
                    return await recharge.onetime.create(session, onetimeData);
                } else {
                    throw new Error('One-time order create API method not available');
                }
            });
            
            console.log('New one-time order created:', result);
            return { success: true, onetime: result, cart_item: cartItem };
            
        } catch (error) {
            console.error('Failed to create new one-time order:', error);
            throw error;
        }
    },

    async loadBundleCollectionProducts() {
        console.log('Loading bundle collection products from Shopify collection "build-a-box"...');
        
        try {
            // Fetch products from Shopify collection "build-a-box" using our server endpoint
            const collectionHandle = 'build-a-box';
            
            console.log(`Fetching products from collection: ${collectionHandle} with metafields...`);
            
            // Make API call to our server endpoint that uses Shopify Admin API GraphQL
            const response = await fetch(this.apiUrl(`/collection-products-with-metafields?collection_handle=${collectionHandle}`), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            
            if (!response.ok) {
                throw new Error(`Failed to fetch collection products: ${response.status} ${response.statusText}`);
            }
            
            const data = await response.json();
            
            if (!data.products || !Array.isArray(data.products)) {
                throw new Error('Invalid response format from API');
            }
            
            console.log(`Successfully fetched ${data.products.length} products from collection "${collectionHandle}"`);
            
            // Debug: Log first product to verify metafields are included
            if (data.products.length > 0) {
                console.log('Sample product with metafields:', data.products[0]);
                console.log('Sample product subtitle:', data.products[0].subtitle);
            }
            
            // Data is already transformed by the server endpoint
            this.bundleCollectionProducts = data.products;
            
            console.log('Loaded bundle collection products:', this.bundleCollectionProducts);
            
            // Cache the results for future use
            if (!window.cached) {
                window.cached = {};
            }
            window.cached.bundleCollectionProducts = this.bundleCollectionProducts;
            
        } catch (error) {
            console.error('Failed to load bundle collection products from Shopify:', error);
            
            // Fallback to empty array
            this.bundleCollectionProducts = [];
            
            // Show error to user
            console.warn('Could not load bundle collection products. Please check your connection and try again.');
        }
    },

    async loadBABCollectionProducts() {
        console.log('Loading BAB collection products from Shopify collection "bab"...');
        
        try {
            // Fetch products from Shopify collection "bab" (ID: 275143491647)
            const collectionHandle = 'bab';
            const collectionId = 275143491647;
            
            console.log(`Fetching products from Shopify collection: ${collectionHandle} (ID: ${collectionId})`);
            
            // Make API call to Shopify to get collection products
            const response = await fetch(`/collections/${collectionHandle}/products.json?limit=250`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            
            if (!response.ok) {
                throw new Error(`Failed to fetch BAB collection products: ${response.status} ${response.statusText}`);
            }
            
            const data = await response.json();
            
            if (!data.products || !Array.isArray(data.products)) {
                throw new Error('Invalid response format from Shopify API for BAB collection');
            }
            
            console.log(`Successfully fetched ${data.products.length} products from BAB collection "${collectionHandle}"`);
            
            // Transform products to create separate entries for each variant (same as bundle products)
            this.babCollectionProducts = [];
            
            data.products.forEach(product => {
                // If product has variants, create separate entries for each variant
                if (product.variants && product.variants.length > 0) {
                    product.variants.forEach(variant => {
                        this.babCollectionProducts.push({
                            id: product.id,
                            variant_id: variant.id,
                            title: product.title,
                            variant_title: variant.title,
                            full_title: `${product.title}${variant.title !== 'Default Title' ? ` - ${variant.title}` : ''}`,
                            handle: product.handle,
                            price: parseFloat(variant.price),
                            sku: variant.sku,
                            // Store the original variant for reference
                            variant: variant,
                            // Store original product data for reference
                            original_product: {
                                id: product.id,
                                title: product.title,
                                variants: product.variants
                            }
                        });
                    });
                } else {
                    // If no variants, create single entry
                    this.babCollectionProducts.push({
                        id: product.id,
                        variant_id: null,
                        title: product.title,
                        variant_title: null,
                        full_title: product.title,
                        handle: product.handle,
                        price: 0,
                        variant: null,
                        original_product: {
                            id: product.id,
                            title: product.title,
                            variants: []
                        }
                    });
                }
            });
            
            console.log('Transformed BAB collection products:', this.babCollectionProducts);
            
            // Cache the results for future use
            if (!window.cached) {
                window.cached = {};
            }
            window.cached.babCollectionProducts = this.babCollectionProducts;
            
        } catch (error) {
            console.error('Failed to load BAB collection products from Shopify:', error);
            
            // Fallback to empty array
            this.babCollectionProducts = [];
            
            // Show error to user
            console.warn('Could not load BAB collection products. Please check your connection and try again.');
        }
    },
    
    editProducts(group) {
        // Prevent multiple clicks while already loading
        if (this.loadingBundleProductsModal) {
            console.log('Already loading bundle products modal, ignoring click');
            return;
        }
        
        // Show bundle products modal for editing subscription products
        console.log('Edit products for delivery schedule:', group);
        this.showBundleProductsModalForGroup(group);
    },
    
    cancelDelivery(group) {
    // TODO: Implement cancel delivery functionality
    console.log('Cancel delivery for schedule:', group);
    if (confirm('Are you sure you want to cancel this delivery schedule? This action cannot be undone.')) {
        alert('Cancel functionality will be implemented soon!');
    }
    },

    /**
     * Show cancel confirmation modal
     */
    showCancelConfirmation(group) {
        console.log('Showing cancel confirmation for group:', group);
        this.subscriptionToCancel = group;
        this.showCancelConfirmationModal = true;
        this.cancellingSubscription = false;
    },

    /**
     * Close cancel confirmation modal
     */
    closeCancelConfirmationModal() {
        this.showCancelConfirmationModal = false;
        this.subscriptionToCancel = null;
        this.cancellingSubscription = false;
    },

    /**
     * Confirm subscription cancellation
     * Updates both subscriptions and one-time orders to set status to "CANCELLED" using bulk API
     */
    async confirmCancelSubscription() {
        if (!this.subscriptionToCancel) {
            console.error('No subscription to cancel');
            return;
        }

        this.cancellingSubscription = true;
        
        try {
            console.log('Cancelling subscription group:', this.subscriptionToCancel);
            
            const group = this.subscriptionToCancel;
            
            // Get the correct address ID from the group
            const addressId = group.address_id;
            console.log('Using address ID from group:', addressId);
            
            if (!addressId) {
                throw new Error('No address ID found in subscription group');
            }
            
            // Prepare bulk update data for subscriptions only
            const subscriptionsToUpdate = [];
            const onetimesToCancel = [];
            
            // Add all subscriptions to the update list
            if (group.subscriptions && group.subscriptions.length > 0) {
                console.log(`Adding ${group.subscriptions.length} subscriptions to bulk cancellation...`);
                group.subscriptions.forEach(subscription => {
                    console.log(`Adding subscription ${subscription.id} with address_id ${subscription.address_id}`);
                    subscriptionsToUpdate.push({
                        id: subscription.id,
                        status: 'CANCELLED'
                    });
                });
            }
            
            // Collect one-time orders for separate handling
            if (group.onetimes && group.onetimes.length > 0) {
                console.log(`Collecting ${group.onetimes.length} one-time orders for deletion...`);
                group.onetimes.forEach(onetime => {
                    console.log(`Collecting onetime ${onetime.id} for deletion with address_id ${onetime.address_id}`);
                    onetimesToCancel.push(onetime);
                });
            }
            
            if (subscriptionsToUpdate.length === 0 && onetimesToCancel.length === 0) {
                throw new Error('No items found to cancel in this subscription group');
            }
            
            console.log('Subscriptions to cancel:', subscriptionsToUpdate);
            console.log('One-times to delete:', onetimesToCancel);
            console.log('Using address ID for bulk update:', addressId);
            
            // First, cancel subscriptions using bulk API (if any)
            let bulkResult = null;
            if (subscriptionsToUpdate.length > 0) {
                bulkResult = await this.callRechargeAPI(async (session) => {
                    if (!recharge.subscription) {
                        throw new Error('Recharge subscription API not available');
                    }

                    console.log('Available subscription methods:', Object.keys(recharge.subscription));

                    if (typeof recharge.subscription.updateSubscriptions !== 'function') {
                        throw new Error('Bulk updateSubscriptions method not available. Available methods: ' + Object.keys(recharge.subscription).join(', '));
                    }

                    console.log('Using recharge.subscription.updateSubscriptions() for bulk subscription cancellation');
                    console.log('API call parameters:', {
                        session: '(session object)',
                        addressId: addressId,
                        subscriptionsCount: subscriptionsToUpdate.length
                    });
                    
                    // Call the bulk update API for subscriptions only (no allow_onetimes flag)
                    return await recharge.subscription.updateSubscriptions(
                        session, 
                        addressId,
                        subscriptionsToUpdate
                    );
                });
                
                console.log('Bulk subscription cancellation result:', bulkResult);
            }
            
            // Then, cancel one-time orders individually using the onetime API
            const onetimeResults = [];
            if (onetimesToCancel.length > 0) {
                console.log(`Deleting ${onetimesToCancel.length} one-time orders individually...`);
                
                for (const onetime of onetimesToCancel) {
                    console.log(`Deleting one-time order ${onetime.id}...`);
                    
                    try {
                        const result = await this.callRechargeAPI(async (session) => {
                            if (!recharge.onetime) {
                                throw new Error('Recharge onetime API not available');
                            }

                            console.log('Available onetime methods:', Object.keys(recharge.onetime));

                            // Try different API method names to delete one-time order
                            if (typeof recharge.onetime.deleteOnetime === 'function') {
                                console.log('Using recharge.onetime.deleteOnetime()');
                                return await recharge.onetime.deleteOnetime(session, onetime.id);
                            } else if (typeof recharge.onetime.delete === 'function') {
                                console.log('Using recharge.onetime.delete()');
                                return await recharge.onetime.delete(session, onetime.id);
                            } else if (typeof recharge.onetime.removeOnetime === 'function') {
                                console.log('Using recharge.onetime.removeOnetime()');
                                return await recharge.onetime.removeOnetime(session, onetime.id);
                            } else if (typeof recharge.onetime.remove === 'function') {
                                console.log('Using recharge.onetime.remove()');
                                return await recharge.onetime.remove(session, onetime.id);
                            } else {
                                throw new Error('No suitable onetime deletion method found. Available methods: ' + Object.keys(recharge.onetime).join(', '));
                            }
                        });
                        
                        console.log(`One-time order ${onetime.id} deleted successfully:`, result);
                        onetimeResults.push({ type: 'onetime', id: onetime.id, success: true, result });
                        
                    } catch (error) {
                        console.error(`Failed to delete one-time order ${onetime.id}:`, error);
                        onetimeResults.push({ type: 'onetime', id: onetime.id, success: false, error: error.message });
                    }
                }
            }
            
            // Check overall results - calculate total quantities including bundle contents
            const totalSubscriptionQuantity = group.subscriptions ? group.subscriptions.reduce((sum, sub) => {
                const bundleContents = this.getBundleContents(sub);
                if (bundleContents && bundleContents.length > 0) {
                    // For bundles, count the bundle items
                    const bundleItemsCount = bundleContents.reduce((total, item) => total + (parseInt(item.quantity) || 1), 0);
                    return sum + bundleItemsCount;
                } else {
                    // For regular subscriptions, use the subscription quantity
                    return sum + (parseInt(sub.quantity) || 1);
                }
            }, 0) : 0;
            
            const totalOnetimeQuantity = group.onetimes ? group.onetimes.reduce((sum, ot) => sum + (parseInt(ot.quantity) || 1), 0) : 0;
            const totalItems = totalSubscriptionQuantity + totalOnetimeQuantity;
            
            const successfulSubscriptionQuantity = bulkResult ? totalSubscriptionQuantity : 0;
            const successfulOnetimeQuantity = onetimeResults.filter(r => r.success).reduce((sum, r) => {
                const onetime = onetimesToCancel.find(ot => ot.id === r.id);
                return sum + (onetime ? (parseInt(onetime.quantity) || 1) : 0);
            }, 0);
            const totalSuccessful = successfulSubscriptionQuantity + successfulOnetimeQuantity;
            
            console.log('Combined cancellation results:', {
                totalItems,
                totalSubscriptionQuantity,
                totalOnetimeQuantity,
                subscriptions: { attempted: subscriptionsToUpdate.length, successful: bulkResult ? 'yes' : 'no', successfulQuantity: successfulSubscriptionQuantity },
                onetimes: { attempted: onetimesToCancel.length, successfulCount: onetimeResults.filter(r => r.success).length, successfulQuantity: successfulOnetimeQuantity },
                totalSuccessful
            });
            
            // Check if the operations were successful
            if (totalSuccessful === totalItems) {
                console.log(`Successfully cancelled all ${totalItems} items!`);
                
                // Close the modal
                this.closeCancelConfirmationModal();
                
                // Refresh subscriptions data to reflect the changes
                console.log('Refreshing subscription data after cancellation...');
                await this.loadAllSubscriptions();
                
                // Show success message
                this.showSuccess(
                    'Subscription Cancelled Successfully!',
                    `Successfully cancelled ${totalItems} item(s) in this subscription group.`,
                    `<strong>What happens next:</strong><br>
                    • No future charges will be processed for cancelled items<br>
                    • You'll receive a cancellation confirmation email<br>
                    • Any pending orders will continue to ship as normal`
                );
                
            } else if (totalSuccessful > 0) {
                console.warn(`Partial cancellation success: ${totalSuccessful} of ${totalItems} items cancelled`);
                
                // Close the modal
                this.closeCancelConfirmationModal();
                
                // Refresh subscriptions data
                await this.loadAllSubscriptions();
                
                // Show partial success message
                const failedCount = totalItems - totalSuccessful;
                this.showSuccess(
                    'Subscription Partially Cancelled',
                    `Cancelled ${totalSuccessful} of ${totalItems} items. ${failedCount} items could not be cancelled.`,
                    `<strong>Next steps:</strong><br>
                    • Successfully cancelled items will stop recurring<br>
                    • Please try cancelling the remaining items again<br>
                    • Contact support if this issue persists`
                );
                
            } else {
                throw new Error('Failed to cancel any items in the subscription group');
            }
            
        } catch (error) {
            console.error('Error in bulk subscription cancellation:', error);
            console.error('Full error details:', {
                message: error.message,
                stack: error.stack,
                response: error.response,
                data: error.data
            });
            
            // If bulk API fails, fall back to individual cancellations as backup
            console.log('Bulk cancellation failed, attempting individual cancellations as fallback...');
            
            try {
                await this.fallbackIndividualCancellation(this.subscriptionToCancel);
            } catch (fallbackError) {
                console.error('Fallback individual cancellation also failed:', fallbackError);
                
                // Show error message to user
                this.showError(
                    'Failed to Cancel Subscription',
                    `Could not cancel the subscription: ${error.message}`,
                    `<strong>What you can do:</strong><br>
                    • Try again in a few minutes<br>
                    • Check your internet connection<br>
                    • Contact support if the problem persists<br><br>
                    <strong>Error details:</strong> ${error.message}`
                );
            }
            
        } finally {
            this.cancellingSubscription = false;
        }
    },

    /**
     * Fallback method for individual cancellations if bulk API fails
     */
    async fallbackIndividualCancellation(group) {
        console.log('Starting fallback individual cancellations...');
        
        const results = [];
        
        // Cancel subscriptions individually
        if (group.subscriptions && group.subscriptions.length > 0) {
            console.log(`Individually cancelling ${group.subscriptions.length} subscriptions...`);
            
            for (const subscription of group.subscriptions) {
                console.log(`Cancelling subscription ${subscription.id}...`);
                
                try {
                    const result = await this.callRechargeAPI(async (session) => {
                        if (!recharge.subscription) {
                            throw new Error('Recharge subscription API not available');
                        }

                        // Try different API method names to update subscription status
                        if (typeof recharge.subscription.updateSubscription === 'function') {
                            console.log('Using recharge.subscription.updateSubscription()');
                            return await recharge.subscription.updateSubscription(session, subscription.id, {
                                status: 'CANCELLED'
                            });
                        } else if (typeof recharge.subscription.update === 'function') {
                            console.log('Using recharge.subscription.update()');
                            return await recharge.subscription.update(session, subscription.id, {
                                status: 'CANCELLED'
                            });
                        } else if (typeof recharge.subscription.cancelSubscription === 'function') {
                            console.log('Using recharge.subscription.cancelSubscription()');
                            return await recharge.subscription.cancelSubscription(session, subscription.id);
                        } else if (typeof recharge.subscription.cancel === 'function') {
                            console.log('Using recharge.subscription.cancel()');
                            return await recharge.subscription.cancel(session, subscription.id);
                        } else {
                            throw new Error('No suitable subscription cancellation method found. Available methods: ' + Object.keys(recharge.subscription).join(', '));
                        }
                    });
                    
                    console.log(`Subscription ${subscription.id} cancelled successfully:`, result);
                    results.push({ type: 'subscription', id: subscription.id, success: true, result });
                    
                } catch (error) {
                    console.error(`Failed to cancel subscription ${subscription.id}:`, error);
                    results.push({ type: 'subscription', id: subscription.id, success: false, error: error.message });
                }
            }
        }
        
        // Cancel one-time orders individually
        if (group.onetimes && group.onetimes.length > 0) {
            console.log(`Individually cancelling ${group.onetimes.length} one-time orders...`);
            
            for (const onetime of group.onetimes) {
                console.log(`Cancelling one-time order ${onetime.id}...`);
                
                try {
                    const result = await this.callRechargeAPI(async (session) => {
                        if (!recharge.onetime) {
                            throw new Error('Recharge onetime API not available');
                        }

                        // Try different API method names to update one-time order status
                        if (typeof recharge.onetime.updateOnetime === 'function') {
                            console.log('Using recharge.onetime.updateOnetime()');
                            return await recharge.onetime.updateOnetime(session, onetime.id, {
                                status: 'CANCELLED'
                            });
                        } else if (typeof recharge.onetime.update === 'function') {
                            console.log('Using recharge.onetime.update()');
                            return await recharge.onetime.update(session, onetime.id, {
                                status: 'CANCELLED'
                            });
                        } else if (typeof recharge.onetime.cancelOnetime === 'function') {
                            console.log('Using recharge.onetime.cancelOnetime()');
                            return await recharge.onetime.cancelOnetime(session, onetime.id);
                        } else if (typeof recharge.onetime.cancel === 'function') {
                            console.log('Using recharge.onetime.cancel()');
                            return await recharge.onetime.cancel(session, onetime.id);
                        } else {
                            throw new Error('No suitable onetime cancellation method found. Available methods: ' + Object.keys(recharge.onetime).join(', '));
                        }
                    });
                    
                    console.log(`One-time order ${onetime.id} cancelled successfully:`, result);
                    results.push({ type: 'onetime', id: onetime.id, success: true, result });
                    
                } catch (error) {
                    console.error(`Failed to cancel one-time order ${onetime.id}:`, error);
                    results.push({ type: 'onetime', id: onetime.id, success: false, error: error.message });
                }
            }
        }
        
        // Check fallback results - calculate total quantities including bundle contents
        const totalSubscriptionQuantity = group.subscriptions ? group.subscriptions.reduce((sum, sub) => {
            const bundleContents = this.getBundleContents(sub);
            if (bundleContents && bundleContents.length > 0) {
                // For bundles, count the bundle items
                const bundleItemsCount = bundleContents.reduce((total, item) => total + (parseInt(item.quantity) || 1), 0);
                return sum + bundleItemsCount;
            } else {
                // For regular subscriptions, use the subscription quantity
                return sum + (parseInt(sub.quantity) || 1);
            }
        }, 0) : 0;
        
        const totalOnetimeQuantity = group.onetimes ? group.onetimes.reduce((sum, ot) => sum + (parseInt(ot.quantity) || 1), 0) : 0;
        const totalItems = totalSubscriptionQuantity + totalOnetimeQuantity;
        
        const successfulResults = results.filter(r => r.success);
        const successfulCancellations = successfulResults.reduce((sum, r) => {
            if (r.type === 'subscription') {
                const subscription = group.subscriptions.find(sub => sub.id === r.id);
                if (subscription) {
                    const bundleContents = this.getBundleContents(subscription);
                    if (bundleContents && bundleContents.length > 0) {
                        // For bundles, count the bundle items
                        return sum + bundleContents.reduce((total, item) => total + (parseInt(item.quantity) || 1), 0);
                    } else {
                        // For regular subscriptions
                        return sum + (parseInt(subscription.quantity) || 1);
                    }
                }
            } else if (r.type === 'onetime') {
                const onetime = group.onetimes.find(ot => ot.id === r.id);
                return sum + (onetime ? (parseInt(onetime.quantity) || 1) : 0);
            }
            return sum;
        }, 0);
        
        const failedCancellations = results.filter(r => !r.success);
        const failedQuantity = totalItems - successfulCancellations;
        
        console.log('Fallback cancellation results:', {
            total: totalItems,
            successful: successfulCancellations,
            failed: failedQuantity,
            details: results
        });
        
        if (successfulCancellations === totalItems) {
            // All items cancelled successfully
            console.log('All items cancelled successfully via fallback!');
            
            // Close the modal
            this.closeCancelConfirmationModal();
            
            // Refresh subscriptions data
            await this.loadAllSubscriptions();
            
            // Show success message
            this.showSuccess(
                'Subscription Cancelled Successfully!',
                `Successfully cancelled ${totalItems} item(s) in this subscription group.`,
                `<strong>What happens next:</strong><br>
                • No future charges will be processed for cancelled items<br>
                • You'll receive a cancellation confirmation email<br>
                • Any pending orders will continue to ship as normal`
            );
            
        } else if (successfulCancellations > 0) {
            // Partial success
            console.warn('Partial cancellation success via fallback');
            
            // Close the modal
            this.closeCancelConfirmationModal();
            
            // Refresh subscriptions data
            await this.loadAllSubscriptions();
            
            // Show partial success message
            this.showSuccess(
                'Subscription Partially Cancelled',
                `Cancelled ${successfulCancellations} of ${totalItems} items. ${failedQuantity} items could not be cancelled.`,
                `<strong>Next steps:</strong><br>
                • Successfully cancelled items will stop recurring<br>
                • Please try cancelling the remaining items again<br>
                • Contact support if this issue persists`
            );
            
        } else {
            // Complete failure
            throw new Error('Failed to cancel any items in the subscription group via fallback');
        }
    },

    /**
     * Show reactivate modal for cancelled subscriptions
     */
    showReactivateSubscriptionModal(group) {
        console.log('Showing reactivate modal for cancelled group:', group);
        this.currentReactivateGroup = group;
        this.showReactivateModal = true;
        this.reactivatingSubscription = false;
        this.reactivateSubscriptionError = '';
        this.selectedReactivateDate = '';
        this.selectedReactivateFrequency = this.availableFrequencies[0]; // Default to first frequency
        
        // Set minimum date to tomorrow
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        this.selectedReactivateDate = tomorrow.toISOString().split('T')[0];
    },

    /**
     * Close reactivate modal
     */
    closeReactivateModal() {
        this.showReactivateModal = false;
        this.currentReactivateGroup = null;
        this.reactivatingSubscription = false;
        this.reactivateSubscriptionError = '';
        this.selectedReactivateDate = '';
        this.selectedReactivateFrequency = null;
    },

    /**
     * Confirm subscription reactivation
     */
    async confirmReactivateSubscription() {
        if (!this.currentReactivateGroup) {
            console.error('No subscription group to reactivate');
            return;
        }

        if (!this.selectedReactivateDate || !this.selectedReactivateFrequency) {
            this.reactivateSubscriptionError = 'Please select both a next ship date and frequency.';
            return;
        }

        this.reactivatingSubscription = true;
        this.reactivateSubscriptionError = '';
        
        try {
            console.log('Reactivating subscription group:', this.currentReactivateGroup);
            console.log('Selected date:', this.selectedReactivateDate);
            console.log('Selected frequency:', this.selectedReactivateFrequency);
            
            const group = this.currentReactivateGroup;
            
            // Prepare bulk update data for subscriptions only
            const subscriptionsToUpdate = [];
            
            if (group.subscriptions && group.subscriptions.length > 0) {
                console.log(`Adding ${group.subscriptions.length} subscriptions to bulk reactivation...`);
                group.subscriptions.forEach(subscription => {
                    subscriptionsToUpdate.push({
                        id: subscription.id,
                        status: 'ACTIVE',
                        next_charge_scheduled_at: this.selectedReactivateDate,
                        charge_interval_frequency: this.selectedReactivateFrequency.count,
                        order_interval_frequency: this.selectedReactivateFrequency.count, // Required by Recharge API
                        order_interval_unit: this.selectedReactivateFrequency.unit
                    });
                });
            }
            
            if (subscriptionsToUpdate.length === 0) {
                throw new Error('No subscriptions found to reactivate in this group');
            }
            
            console.log('Subscriptions to reactivate:', subscriptionsToUpdate);
            
            // Update subscriptions using bulk API
            const bulkResult = await this.callRechargeAPI(async (session) => {
                if (!recharge.subscription) {
                    throw new Error('Recharge subscription API not available');
                }

                if (typeof recharge.subscription.updateSubscriptions !== 'function') {
                    throw new Error('Bulk updateSubscriptions method not available');
                }

                console.log('Using recharge.subscription.updateSubscriptions() for bulk subscription reactivation');
                
                return await recharge.subscription.updateSubscriptions(
                    session, 
                    group.address_id,
                    subscriptionsToUpdate
                );
            });
            
            console.log('Bulk subscription reactivation result:', bulkResult);
            
            // Calculate total quantity of items reactivated including bundle contents
            const totalQuantity = group.subscriptions.reduce((sum, sub) => {
                const bundleContents = this.getBundleContents(sub);
                if (bundleContents && bundleContents.length > 0) {
                    // For bundles, count the bundle items
                    const bundleItemsCount = bundleContents.reduce((total, item) => total + (parseInt(item.quantity) || 1), 0);
                    return sum + bundleItemsCount;
                } else {
                    // For regular subscriptions, use the subscription quantity
                    return sum + (parseInt(sub.quantity) || 1);
                }
            }, 0);
            
            // Save the selected date before closing modal (for success message)
            const reactivationDate = this.selectedReactivateDate;
            const formattedDate = new Date(reactivationDate + 'T00:00:00').toLocaleDateString('en-US', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
            });
            
            // Close the modal
            this.closeReactivateModal();
            
            // Refresh subscriptions data to reflect the changes
            console.log('Refreshing subscription data after reactivation...');
            await this.loadAllSubscriptions();
            
            // Show success message
            this.showSuccess(
                'Subscription Reactivated Successfully!',
                `Successfully reactivated ${totalQuantity} item(s).`,
                `<strong>Delivery Details:</strong><br>
                • Next delivery scheduled for: <strong>${formattedDate}</strong><br>
                • Subscription is now active and will process automatically<br>
                • You'll receive confirmation emails for upcoming orders`
            );
            
        } catch (error) {
            console.error('Error in subscription reactivation:', error);
            this.reactivateSubscriptionError = `Failed to reactivate subscription: ${error.message}`;
        } finally {
            this.reactivatingSubscription = false;AC
        }
    },

    /**
     * Show delete confirmation modal for cancelled subscriptions
     */
    showDeleteConfirmation(group) {
        console.log('Showing delete confirmation for cancelled group:', group);
        this.subscriptionToDelete = group;
        this.showDeleteConfirmationModal = true;
        this.deletingSubscription = false;
    },

    /**
     * Close delete confirmation modal
     */
    closeDeleteConfirmationModal() {
        this.showDeleteConfirmationModal = false;
        this.subscriptionToDelete = null;
        this.deletingSubscription = false;
    },

    /**
     * Confirm subscription deletion (permanent removal)
     */
    async confirmDeleteSubscription() {
        if (!this.subscriptionToDelete) {
            console.error('No subscription to delete');
            return;
        }

        this.deletingSubscription = true;
        
        try {
            console.log('Permanently deleting subscription group:', this.subscriptionToDelete);
            
            const group = this.subscriptionToDelete;
            
            // Collect all subscription IDs and customer IDs for batch deletion
            const subscriptionData = [];
            if (group.subscriptions && group.subscriptions.length > 0) {
                group.subscriptions.forEach(subscription => {
                    if (subscription.id && subscription.customer_id) {
                        subscriptionData.push({
                            subscription_id: subscription.id,
                            customer_id: subscription.customer_id
                        });
                    } else {
                        console.warn('Subscription missing id or customer_id:', subscription);
                    }
                });
            }

            if (subscriptionData.length === 0) {
                throw new Error('No valid subscription data found to delete (missing IDs or customer IDs)');
            }

            console.log(`Permanently deleting ${subscriptionData.length} subscriptions in batch:`, subscriptionData);
            
            // Make a single batch request to our backend endpoint via Shopify proxy
            console.log(`Making batch DELETE request via Shopify proxy...`);
            const backendUrl = this.apiUrl('/delete-recharge-subscriptions');
            console.log(`Making batch request to backend: ${backendUrl}`);
            
            const response = await fetch(backendUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    subscription_data: subscriptionData
                })
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
                console.error(`Backend batch request failed:`, {
                    status: response.status,
                    statusText: response.statusText,
                    error: errorData
                });
                throw new Error(`Failed to delete subscriptions via backend: ${response.status} ${response.statusText} - ${errorData.error || errorData.message}`);
            }

            const responseData = await response.json();
            console.log(`Backend batch DELETE response:`, responseData);
            
            // Process the batch results
            const { results } = responseData;
            const totalRequested = results.total;
            const successfulDeletions = results.successful;
            const failedDeletions = results.failed;
            
            console.log('Batch deletion results:', {
                totalRequested,
                successful: successfulDeletions,
                failed: failedDeletions,
                overallSuccess: responseData.success,
                details: results.details
            });
            
            if (responseData.success && successfulDeletions === totalRequested) {
                console.log(`Successfully deleted all ${totalRequested} subscriptions!`);
                
                // Close the modal
                this.closeDeleteConfirmationModal();
                
                // Refresh subscriptions data to reflect the changes
                console.log('Refreshing subscription data after deletion...');
                await this.loadAllSubscriptions();
                
                // Show success message
                this.showSuccess(
                    'Subscription Deleted Successfully!',
                    `Successfully deleted ${totalRequested} subscription(s) permanently.`,
                    `<strong>Important:</strong><br>
                    • All subscription data has been permanently removed<br>
                    • No future charges will be processed<br>
                    • This action cannot be undone<br>
                    • Any pending orders may still be fulfilled`
                );
                
            } else if (successfulDeletions > 0) {
                console.warn(`Partial deletion success: ${successfulDeletions} of ${totalRequested} subscriptions deleted`);
                
                // Log details of failed deletions for debugging
                const failedItems = results.details.filter(item => !item.success);
                console.error('Failed deletions:', failedItems);
                
                // Close the modal
                this.closeDeleteConfirmationModal();
                
                // Refresh subscriptions data
                await this.loadAllSubscriptions();
                
                // Show detailed error message
                const failureReasons = failedItems.map(item => `ID ${item.subscription_id}: ${item.error}`).join('<br>• ');
                this.showSuccess(
                    'Subscription Partially Deleted',
                    `Deleted ${successfulDeletions} of ${totalRequested} subscriptions.`,
                    `<strong>${failedDeletions} subscriptions could not be deleted:</strong><br>
                    • ${failureReasons}<br><br>
                    <strong>Next steps:</strong><br>
                    • Please try deleting the remaining items again<br>
                    • Contact support if this issue persists`
                );
                
            } else {
                // Complete failure - show detailed error information
                const failedItems = results.details.filter(item => !item.success);
                const failureReasons = failedItems.map(item => `ID ${item.subscription_id}: ${item.error}`).join('\n');
                throw new Error(`Failed to delete any subscriptions:\n${failureReasons}`);
            }
            
        } catch (error) {
            console.error('Error in batch subscription deletion:', error);
            
            // Show user-friendly error message
            const errorMessage = error.message.includes('subscription_data') 
                ? 'Invalid subscription data. Please refresh the page and try again.'
                : error.message.includes('Failed to delete subscriptions via backend')
                ? 'Server error occurred while deleting subscriptions. Please try again later.'
                : error.message.includes('Network error')
                ? 'Network connection error. Please check your internet connection and try again.'
                : `Failed to delete subscription: ${error.message}`;
                
            alert(`${errorMessage}\n\nIf the problem persists, please contact support.`);
            
        } finally {
            this.deletingSubscription = false;
        }
    },

    /**
     * Handle payment update - either FPR portal or modal based on configuration
     */
   async updatePayment(group) {
        console.log('Update payment for delivery schedule:', group);
        this.currentPaymentGroup = group;
        
        if (this.useFPR) {
            // Use FPR (Failed Payment Recovery) - redirect to customer portal
            await this.openPaymentPortal(group);
        } else {
            // Use existing modal approach
            this.showUpdatePaymentModal = true;
            this.updatePaymentSuccess = false;
            this.updatePaymentError = '';
            this.sendingUpdateLink = false;
        }
    },
    
    /**
     * Open Recharge customer portal for payment methods (FPR)
     */
    async openPaymentPortal(group) {
        try {
            console.log('Opening payment portal for group:', group);
            
            // Call Recharge API to get customer portal access
            const portalData = await this.callRechargeAPI(async (session) => {
                if (!recharge.customer || typeof recharge.customer.getCustomerPortalAccess !== 'function') {
                    throw new Error('Recharge customer portal API not available');
                }
                
                return await recharge.customer.getCustomerPortalAccess(session, {
                    page_destination: 'payment_methods'
                });
            });
            
            console.log('Portal access response:', portalData);
            
            // Check if we got a valid portal URL
            if (portalData && portalData.portal_url) {
                // Navigate to the portal in the same window
                window.location.href = portalData.portal_url;
                console.log('Navigating to payment portal:', portalData.portal_url);
            } else {
                throw new Error('Invalid portal response - no portal URL received');
            }
            
        } catch (error) {
            console.error('Failed to open payment portal:', error);
            
            // Show error to user
            alert(`Failed to open payment portal: ${error.message || 'Please try again later.'}`);
        }
    },

    /**
     * Close update payment modal
     */
    closeUpdatePaymentModal() {
        this.showUpdatePaymentModal = false;
        this.currentPaymentGroup = null;
        this.updatePaymentSuccess = false;
        this.updatePaymentError = '';
        this.sendingUpdateLink = false;
    },

    /**
     * Send update payment link via Recharge API
     */
    async sendUpdatePaymentLink() {
        if (!this.currentPaymentGroup) {
            this.updatePaymentError = 'No payment group selected';
            return;
        }

        this.sendingUpdateLink = true;
        this.updatePaymentError = '';

        try {
            // Get the address_id from the group - this is all we need
            const addressId = this.currentPaymentGroup.address_id;
            
            if (!addressId) {
                throw new Error('Unable to find address ID for this subscription');
            }

            console.log('Sending update payment notification for address:', addressId);

            // Call the Recharge API to send the update payment notification
            // Only address_id is required - Recharge will handle the rest
            await this.callRechargeAPI(async (session) => {
                if (!recharge.customer || typeof recharge.customer.sendCustomerNotification !== 'function') {
                    throw new Error('Recharge customer notification API not available');
                }

                return await recharge.customer.sendCustomerNotification(
                    session, 
                    'SHOPIFY_UPDATE_PAYMENT_INFO', 
                    {
                        address_id: addressId
                    }
                );
            });

            this.updatePaymentSuccess = true;
            console.log('Update payment link sent successfully');

        } catch (error) {
            console.error('Failed to send update payment link:', error);
            this.updatePaymentError = error.message || 'Failed to send update link. Please try again.';
        } finally {
            this.sendingUpdateLink = false;
        }
    },

    /**
     * Open update address modal
     */
    updateAddress(group) {
        console.log('Update address for delivery schedule (v4.0 - Shopify addresses):', group);
        
        // Find the current Recharge address details for this group
        const rechargeAddress = this.getAddressDetails(group.address_id);
        
        if (!rechargeAddress) {
            alert('Unable to find address details for this delivery');
            return;
        }

        // Set up editing data from the current Recharge address
        this.editingAddressData = {
            id: rechargeAddress.id,
            first_name: rechargeAddress.first_name || '',
            last_name: rechargeAddress.last_name || '',
            address1: rechargeAddress.address1 || '',
            address2: rechargeAddress.address2 || '',
            city: rechargeAddress.city || '',
            province: rechargeAddress.province || '',
            zip: rechargeAddress.zip || '',
            country_code: rechargeAddress.country_code || 'US',
            phone: rechargeAddress.phone || '',
            company: rechargeAddress.company || ''
        };

        this.currentAddressGroup = group;
        this.addressMode = 'select';
        this.saveCustomAddressToBook = true;
        this.showUpdateAddressModal = true;
        this.updateAddressSuccess = false;
        this.updateAddressError = '';
        this.savingAddress = false;

        // Load Shopify addresses if not already loaded, then pre-select the matching one
        const initDropdown = () => {
            // Try to match the current Recharge address to a Shopify address by content
            const matched = this.findMatchingShopifyAddress(rechargeAddress);
            if (matched) {
                this.selectedAddressId = matched.id;
                this.isCurrentAddressSelected = true;
            } else {
                // No match — use 'current' to show the Recharge address as an option
                this.selectedAddressId = 'current';
                this.isCurrentAddressSelected = true;
            }
        };

        if (!this.addresses || this.addresses.length === 0) {
            this.loadAddresses({ silent: true }).then(() => initDropdown());
        } else {
            initDropdown();
        }
    },

    /**
     * Close update address modal
     */
    closeUpdateAddressModal() {
        this.showUpdateAddressModal = false;
        this.currentAddressGroup = null;
        this.editingAddressData = null;
        this.updateAddressSuccess = false;
        this.updateAddressError = '';
        this.savingAddress = false;
        this.addressMode = 'select';
        this.selectedAddressId = null;
        this.isCurrentAddressSelected = true;
        this.saveCustomAddressToBook = true;
    },

    /**
     * Find a Shopify address that matches a Recharge address by content
     */
    findMatchingShopifyAddress(rechargeAddr) {
        if (!rechargeAddr || !this.addresses || this.addresses.length === 0) return null;
        const normalize = (s) => (s || '').trim().toLowerCase();
        return this.addresses.find(shopAddr => {
            return normalize(shopAddr.address1) === normalize(rechargeAddr.address1) &&
                   normalize(shopAddr.zip) === normalize(rechargeAddr.zip);
        }) || null;
    },

    /**
     * Format a one-line address summary for the dropdown (Shopify camelCase fields)
     */
    formatAddressOneLine(address) {
        if (!address) return '';
        const parts = [];
        if (address.address1) parts.push(address.address1);
        if (address.city) parts.push(address.city);
        if (address.province) parts.push(address.province);
        if (address.zip) parts.push(address.zip);
        return parts.join(', ');
    },

    /**
     * Format the full dropdown label for a Shopify address option
     * Shopify uses camelCase: firstName, lastName
     */
    formatAddressDropdownLabel(address) {
        if (!address) return '';
        const name = ((address.firstName || address.first_name || '') + ' ' + (address.lastName || address.last_name || '')).trim();
        const line = this.formatAddressOneLine(address);
        if (name && line) return name + ' \u2014 ' + line;
        return name || line || 'Address';
    },

    /**
     * Format the dropdown label for the current Recharge address
     * (shown when no matching Shopify address exists)
     */
    formatCurrentRechargeAddressLabel() {
        const addr = this.editingAddressData;
        if (!addr) return 'Current Address';
        const name = ((addr.first_name || '') + ' ' + (addr.last_name || '')).trim();
        const parts = [];
        if (addr.address1) parts.push(addr.address1);
        if (addr.city) parts.push(addr.city);
        if (addr.province) parts.push(addr.province);
        if (addr.zip) parts.push(addr.zip);
        const line = parts.join(', ');
        if (name && line) return name + ' \u2014 ' + line + ' (current)';
        return (name || line || 'Current Address') + ' (current)';
    },

    /**
     * Handle address dropdown selection change (Shopify addresses)
     */
    onAddressSelectionChange() {
        if (this.selectedAddressId === 'custom') {
            this.addressMode = 'custom';
            this.isCurrentAddressSelected = false;
            // Clear the form for a fresh custom address
            this.editingAddressData = {
                id: null,
                first_name: '',
                last_name: '',
                address1: '',
                address2: '',
                city: '',
                province: '',
                zip: '',
                country_code: 'US',
                phone: '',
                company: ''
            };
        } else if (this.selectedAddressId === 'none' || this.selectedAddressId === 'current') {
            this.addressMode = 'select';
            this.isCurrentAddressSelected = (this.selectedAddressId === 'current');
        } else {
            this.addressMode = 'select';
            // Check if the selected Shopify address matches the current Recharge address
            const rechargeAddr = this.getAddressDetails(this.currentAddressGroup?.address_id);
            const matched = rechargeAddr ? this.findMatchingShopifyAddress(rechargeAddr) : null;
            this.isCurrentAddressSelected = matched && String(matched.id) === String(this.selectedAddressId);
            // Find the selected Shopify address and map to editing data
            const shopAddr = this.addresses.find(a => String(a.id) === String(this.selectedAddressId));
            if (shopAddr) {
                this.editingAddressData = {
                    id: this.currentAddressGroup.address_id, // Keep the Recharge address ID for update
                    first_name: shopAddr.firstName || '',
                    last_name: shopAddr.lastName || '',
                    address1: shopAddr.address1 || '',
                    address2: shopAddr.address2 || '',
                    city: shopAddr.city || '',
                    province: shopAddr.province || '',
                    zip: shopAddr.zip || '',
                    country_code: shopAddr.country || 'US',
                    phone: shopAddr.phone || '',
                    company: shopAddr.company || ''
                };
            }
        }
    },


    /**
     * Open reschedule delivery modal (with frequency)
     */
    rescheduleDelivery(group) {
        console.log('Reschedule delivery for group:', group);
        // Set the current group 
        this.currentRescheduleGroup = group;
        // Set default selected date to current next_charge_scheduled_at
        if (group.next_charge_scheduled_at) {
            const currentDate = new Date(group.next_charge_scheduled_at);
            this.selectedDeliveryDate = currentDate.toISOString().split('T')[0];
        } else {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.selectedDeliveryDate = tomorrow.toISOString().split('T')[0];
        }
        // Set default selected frequency based on current group frequency
        const currentFrequency = this.availableFrequencies.find(freq => 
            freq.unit === group.order_interval_unit && freq.count === group.charge_interval_frequency
        );
        this.selectedFrequency = currentFrequency || this.availableFrequencies[0];
        // Reset modal state
        this.showRescheduleModal = true;
        this.updateDeliveryDateSuccess = false;
        this.updateDeliveryDateError = '';
        this.updatingDeliveryDate = false;
        this.updateFrequencySuccess = false;
        this.updateFrequencyError = '';
        this.updatingFrequency = false;
    },
    /**
     * Update both delivery date and frequency in one action
     */
    async updateDeliveryDateAndFrequency() {
        if (!this.currentRescheduleGroup || !this.selectedDeliveryDate || !this.selectedFrequency) {
            this.updateDeliveryDateError = !this.selectedDeliveryDate ? 'Please select a delivery date' : '';
            this.updateFrequencyError = !this.selectedFrequency ? 'Please select a frequency' : '';
            return;
        }

        this.updatingDeliveryDate = true;
        this.updatingFrequency = true;
        this.updateDeliveryDateError = '';
        this.updateFrequencyError = '';

        try {
            const group = this.currentRescheduleGroup;
            const newDeliveryDate = this.selectedDeliveryDate;
            const newFrequency = this.selectedFrequency;
            const deliveryDateISO = new Date(newDeliveryDate + 'T00:00:00.000Z').toISOString();

            // Prepare updates for subscriptions (update both date and frequency)
            const subscriptionUpdates = group.subscriptions.map(subscription => ({
                subscription_id: subscription.id,
                charge_interval_frequency: newFrequency.count,
                order_interval_frequency: newFrequency.count,
                order_interval_unit: newFrequency.unit,
                next_charge_scheduled_at: deliveryDateISO
            }));

            // Prepare updates for one-times (if any, only update date)
            const onetimeUpdates = (group.onetimes || []).map(onetime => ({
                onetime_id: onetime.id,
                next_charge_scheduled_at: deliveryDateISO
            }));

            // Call the Recharge API to update subscriptions and one-times
            await this.callRechargeAPI(async (session) => {
                const results = [];
                // Update subscriptions
                if (subscriptionUpdates.length > 0) {
                    if (!recharge.subscription) {
                        throw new Error('Recharge subscription API not available');
                    }
                    for (const update of subscriptionUpdates) {
                        let result = null;
                        if (typeof recharge.subscription.updateSubscription === 'function') {
                            result = await recharge.subscription.updateSubscription(session, update.subscription_id, {
                                charge_interval_frequency: update.charge_interval_frequency,
                                order_interval_frequency: update.order_interval_frequency,
                                order_interval_unit: update.order_interval_unit,
                                next_charge_scheduled_at: update.next_charge_scheduled_at
                            });
                        } else if (typeof recharge.subscription.update === 'function') {
                            result = await recharge.subscription.update(session, update.subscription_id, {
                                charge_interval_frequency: update.charge_interval_frequency,
                                order_interval_frequency: update.order_interval_frequency,
                                order_interval_unit: update.order_interval_unit,
                                next_charge_scheduled_at: update.next_charge_scheduled_at
                            });
                        } else if (typeof recharge.subscription.patch === 'function') {
                            result = await recharge.subscription.patch(session, update.subscription_id, {
                                charge_interval_frequency: update.charge_interval_frequency,
                                order_interval_frequency: update.order_interval_frequency,
                                order_interval_unit: update.order_interval_unit,
                                next_charge_scheduled_at: update.next_charge_scheduled_at
                            });
                        } else {
                            throw new Error('No suitable subscription update method found.');
                        }
                        results.push(result);
                    }
                }
                // Update one-times
                if (onetimeUpdates.length > 0 && recharge.onetime) {
                    for (const update of onetimeUpdates) {
                        let result = null;
                        if (typeof recharge.onetime.updateOnetime === 'function') {
                            result = await recharge.onetime.updateOnetime(session, update.onetime_id, {
                                next_charge_scheduled_at: update.next_charge_scheduled_at
                            });
                        } else if (typeof recharge.onetime.update === 'function') {
                            result = await recharge.onetime.update(session, update.onetime_id, {
                                next_charge_scheduled_at: update.next_charge_scheduled_at
                            });
                        } else if (typeof recharge.onetime.patch === 'function') {
                            result = await recharge.onetime.patch(session, update.onetime_id, {
                                next_charge_scheduled_at: update.next_charge_scheduled_at
                            });
                        }
                        if (result) results.push(result);
                    }
                }
                return results;
            });

            this.updateDeliveryDateSuccess = true;
            this.updateFrequencySuccess = true;
            // Refresh subscription data to reflect the changes
            setTimeout(async () => {
                await this.loadAllSubscriptions();
            }, 1000);
        } catch (error) {
            this.updateDeliveryDateError = error.message || 'Failed to update delivery date.';
            this.updateFrequencyError = error.message || 'Failed to update frequency.';
        } finally {
            this.updatingDeliveryDate = false;
            this.updatingFrequency = false;
        }
    },

    /**
     * Close reschedule delivery modal
     */
    closeRescheduleModal() {
        this.showRescheduleModal = false;
        this.currentRescheduleGroup = null;
        this.selectedDeliveryDate = '';
        this.updateDeliveryDateSuccess = false;
        this.updateDeliveryDateError = '';
        this.updatingDeliveryDate = false;
    },

    /**
     * Save updated address via Recharge API
     */
    async saveUpdatedAddress() {
        this.savingAddress = true;
        this.updateAddressError = '';

        try {
            // MODE 1: Selecting an existing Shopify address
            if (this.addressMode === 'select' && this.selectedAddressId && this.selectedAddressId !== 'custom' && this.selectedAddressId !== 'none') {
                const currentAddressId = this.currentAddressGroup.address_id;

                // Check if the selected Shopify address is the same as the current Recharge address
                const rechargeAddress = this.getAddressDetails(currentAddressId);
                const matched = rechargeAddress ? this.findMatchingShopifyAddress(rechargeAddress) : null;
                const isSameAddress = matched && String(matched.id) === String(this.selectedAddressId);

                if (isSameAddress) {
                    console.log('Selected Shopify address matches current Recharge address, no changes needed');
                    this.updateAddressSuccess = true;
                } else {
                    // Update the Recharge address with the selected Shopify address data
                    console.log('Updating Recharge address', currentAddressId, 'with selected Shopify address data');
                    const updateData = {
                        first_name: this.editingAddressData.first_name,
                        last_name: this.editingAddressData.last_name,
                        address1: this.editingAddressData.address1,
                        address2: this.editingAddressData.address2 || null,
                        city: this.editingAddressData.city,
                        province: this.editingAddressData.province,
                        zip: this.editingAddressData.zip,
                        country_code: this.editingAddressData.country_code,
                        phone: this.editingAddressData.phone || null,
                        company: this.editingAddressData.company || null
                    };
                    await this.callRechargeAPI(async (session) => {
                        if (!recharge.address || typeof recharge.address.updateAddress !== 'function') {
                            throw new Error('Recharge address update API not available');
                        }
                        return await recharge.address.updateAddress(session, currentAddressId, updateData);
                    });
                    this.updateAddressSuccess = true;
                    console.log('Address updated successfully (Shopify select mode)');
                }

            // MODE 2: Custom new address
            } else if (this.addressMode === 'custom') {
                if (!this.editingAddressData || !this.isAddressFormValid) {
                    this.updateAddressError = 'Please fill in all required fields';
                    this.savingAddress = false;
                    return;
                }

                const currentAddressId = this.currentAddressGroup.address_id;
                const updateData = {
                    first_name: this.editingAddressData.first_name,
                    last_name: this.editingAddressData.last_name,
                    address1: this.editingAddressData.address1,
                    address2: this.editingAddressData.address2 || null,
                    city: this.editingAddressData.city,
                    province: this.editingAddressData.province,
                    zip: this.editingAddressData.zip,
                    country_code: this.editingAddressData.country_code,
                    phone: this.editingAddressData.phone || null,
                    company: this.editingAddressData.company || null
                };

                console.log('Updating address with custom data:', { currentAddressId, updateData });

                // Update the existing Recharge address with the new data
                await this.callRechargeAPI(async (session) => {
                    if (!recharge.address || typeof recharge.address.updateAddress !== 'function') {
                        throw new Error('Recharge address update API not available');
                    }
                    return await recharge.address.updateAddress(session, currentAddressId, updateData);
                });

                // Optionally save to Shopify address book
                if (this.saveCustomAddressToBook) {
                    try {
                        console.log('Saving custom address to Shopify address book...');
                        // Map to Shopify field names (camelCase + 'country' instead of 'country_code')
                        const shopifyPayload = {
                            firstName: updateData.first_name,
                            lastName: updateData.last_name,
                            address1: updateData.address1,
                            address2: updateData.address2,
                            city: updateData.city,
                            province: updateData.province,
                            zip: updateData.zip,
                            country: updateData.country_code || 'US',
                            phone: updateData.phone,
                            company: updateData.company
                        };
                        const resp = await fetch(this.apiUrl('/create-address'), {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(shopifyPayload)
                        });
                        if (!resp.ok) {
                            const errData = await resp.json().catch(() => ({}));
                            console.warn('Failed to save address to address book:', errData);
                        } else {
                            console.log('Address saved to address book');
                            // Refresh Shopify addresses cache
                            this.loadAddresses({ silent: true });
                        }
                    } catch (bookErr) {
                        console.warn('Failed to save address to address book (non-critical):', bookErr);
                    }
                }

                this.updateAddressSuccess = true;
                console.log('Address updated successfully (custom mode)');

            } else {
                this.updateAddressError = 'Please select an address or enter a new one';
                this.savingAddress = false;
                return;
            }

            // Update local cache and refresh
            this.addressUpdateCounter++;
            this.$forceUpdate();
            await this.loadCustomerAddresses();
            await this.loadAllSubscriptions();
            console.log('Address data refreshed from API after update');

        } catch (error) {
            console.error('Failed to update address:', error);
            this.updateAddressError = error.message || 'Failed to update address. Please try again.';
        } finally {
            this.savingAddress = false;
        }
    },


    /**
     * Update delivery date for all subscriptions and one-times in the group
     */
    async updateDeliveryDate() {
        if (!this.currentRescheduleGroup || !this.selectedDeliveryDate) {
            this.updateDeliveryDateError = 'Please select a delivery date';
            return;
        }

        this.updatingDeliveryDate = true;
        this.updateDeliveryDateError = '';

        try {
            const group = this.currentRescheduleGroup;
            const newDeliveryDate = this.selectedDeliveryDate;
            
            // Convert YYYY-MM-DD to ISO format for API
            const deliveryDateISO = new Date(newDeliveryDate + 'T00:00:00.000Z').toISOString();
            
            console.log('Updating delivery date:', {
                group: group,
                newDeliveryDate: newDeliveryDate,
                deliveryDateISO: deliveryDateISO,
                subscriptions: group.subscriptions,
                onetimes: group.onetimes || []
            });

            // Prepare updates for subscriptions (don't change frequency, just date)
            const subscriptionUpdates = group.subscriptions.map(subscription => ({
                subscription_id: subscription.id,
                next_charge_scheduled_at: deliveryDateISO
            }));

            // Prepare updates for one-times (if any)
            const onetimeUpdates = (group.onetimes || []).map(onetime => ({
                onetime_id: onetime.id,
                next_charge_scheduled_at: deliveryDateISO
            }));

            console.log('Updates to send:', {
                subscriptionUpdates,
                onetimeUpdates
            });

            // Call the Recharge API to update subscriptions and one-times
            await this.callRechargeAPI(async (session) => {
                const results = [];

                // Update subscriptions
                if (subscriptionUpdates.length > 0) {
                    if (!recharge.subscription) {
                        throw new Error('Recharge subscription API not available');
                    }

                    console.log('Available subscription methods:', Object.keys(recharge.subscription));

                    for (const update of subscriptionUpdates) {
                        console.log(`Updating subscription ${update.subscription_id} delivery date...`);
                        
                        let result = null;
                        
                        // Try different API method names
                        if (typeof recharge.subscription.updateSubscription === 'function') {
                            console.log('Using recharge.subscription.updateSubscription()');
                            result = await recharge.subscription.updateSubscription(session, update.subscription_id, {
                                next_charge_scheduled_at: update.next_charge_scheduled_at
                            });
                        } else if (typeof recharge.subscription.update === 'function') {
                            console.log('Using recharge.subscription.update()');
                            result = await recharge.subscription.update(session, update.subscription_id, {
                                next_charge_scheduled_at: update.next_charge_scheduled_at
                            });
                        } else if (typeof recharge.subscription.patch === 'function') {
                            console.log('Using recharge.subscription.patch()');
                            result = await recharge.subscription.patch(session, update.subscription_id, {
                                next_charge_scheduled_at: update.next_charge_scheduled_at
                            });
                        } else {
                            throw new Error('No suitable subscription update method found. Available methods: ' + Object.keys(recharge.subscription).join(', '));
                        }
                        
                        console.log(`Subscription ${update.subscription_id} delivery date updated:`, result);
                        results.push(result);
                    }
                }

                // Update one-times
                if (onetimeUpdates.length > 0) {
                    if (!recharge.onetime) {
                        console.warn('Recharge onetime API not available, skipping one-time updates');
                    } else {
                        console.log('Available onetime methods:', Object.keys(recharge.onetime));

                        for (const update of onetimeUpdates) {
                            console.log(`Updating one-time ${update.onetime_id} delivery date...`);
                            
                            let result = null;
                            
                            // Try different API method names for one-times
                            if (typeof recharge.onetime.updateOnetime === 'function') {
                                console.log('Using recharge.onetime.updateOnetime()');
                                result = await recharge.onetime.updateOnetime(session, update.onetime_id, {
                                    next_charge_scheduled_at: update.next_charge_scheduled_at
                                });
                            } else if (typeof recharge.onetime.update === 'function') {
                                console.log('Using recharge.onetime.update()');
                                result = await recharge.onetime.update(session, update.onetime_id, {
                                    next_charge_scheduled_at: update.next_charge_scheduled_at
                                });
                            } else if (typeof recharge.onetime.patch === 'function') {
                                console.log('Using recharge.onetime.patch()');
                                result = await recharge.onetime.patch(session, update.onetime_id, {
                                    next_charge_scheduled_at: update.next_charge_scheduled_at
                                });
                            } else {
                                console.warn('No suitable onetime update method found. Available methods: ' + Object.keys(recharge.onetime).join(', '));
                            }
                            
                            if (result) {
                                console.log(`One-time ${update.onetime_id} delivery date updated:`, result);
                                results.push(result);
                            }
                        }
                    }
                }
                
                return results;
            });

            this.updateDeliveryDateSuccess = true;
            console.log('Delivery date updated successfully');

            // Refresh subscription data to reflect the changes
            setTimeout(async () => {
                await this.loadAllSubscriptions();
                console.log('Subscription data refreshed after delivery date update');
            }, 1000);

        } catch (error) {
            console.error('Failed to update delivery date:', error);
            this.updateDeliveryDateError = error.message || 'Failed to update delivery date. Please try again.';
        } finally {
            this.updatingDeliveryDate = false;
        }
    },

    /**
     * Debug method to inspect Recharge API structure
     * Usage: window.vueApp.debugRechargeAPI()
     */
    async debugRechargeAPI() {
    try {
        await this.ensureRechargeAuth();
        
        console.log('=== RECHARGE DEBUG INFO ===');
        console.log('Recharge SDK available:', typeof window.recharge !== 'undefined');
        console.log('Recharge session:', this.rechargeSession);
        console.log('Customer ID:', this.customerId);
        console.log('Customer Email:', this.customerEmail);
        
        if (window.recharge) {
        console.log('Recharge object structure:', Object.keys(window.recharge));
        
        if (window.recharge.customer) {
            console.log('Recharge customer methods:', Object.keys(window.recharge.customer));
        }
        
        if (window.recharge.subscription) {
            console.log('Recharge subscription methods:', Object.keys(window.recharge.subscription));
        }
        }
        
        if (this.rechargeSession) {
        console.log('Session object keys:', Object.keys(this.rechargeSession));
        
        if (this.rechargeSession.customer) {
            console.log('Session customer methods:', Object.keys(this.rechargeSession.customer));
        }
        }
        
        console.log('=== END DEBUG INFO ===');
        
    } catch (error) {
        console.error('Debug failed:', error);
    }
    },
    
    /**
     * Simple method for testing Recharge API calls from console
     * Usage: window.vueApp.testRechargeAPI('getDeliverySchedule')
     */
    async testRechargeAPI(methodName, params = {}) {
    try {
        return await this.callRechargeAPI(async (session) => {
        if (!window.recharge || !session) {
            throw new Error('Recharge SDK not loaded or session not available');
        }
        
        console.log(`Testing Recharge API method: ${methodName}`);
        console.log('Parameters:', params);
        
        // Add customer ID to params if not provided
        const apiParams = {
            customerId: this.customerId,
            customerEmail: this.customerEmail,
            ...params
        };
        
        // Try different approaches to call the method
        if (methodName === 'getDeliverySchedule') {
            // Use correct parameter structure: session first, options second
            const options = {
            date_max: params.date_max || new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
            ...params
            };
            return await recharge.customer.getDeliverySchedule(session, options);
        }
        
        // Generic method calling
        const parts = methodName.split('.');
        let obj = window.recharge;
        
        for (let i = 0; i < parts.length - 1; i++) {
            obj = obj[parts[i]];
            if (!obj) throw new Error(`Method path ${parts.slice(0, i + 1).join('.')} not found`);
        }
        
        const method = obj[parts[parts.length - 1]];
        if (!method) throw new Error(`Method ${methodName} not found`);
        
        return await method(apiParams);
        });
    } catch (error) {
        console.error('Recharge API test failed:', error);
        throw error;
    }
    },
    
    // ========================================
    // END RECHARGE SESSION MANAGEMENT
    // ========================================
    
    async fetchLastOrder() {
    this.lastOrderLoading = true;
    try {
        const res = await fetch(this.apiUrl('/last-order'), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({}) // or any required payload
        });
        
        if (!res.ok) {
        throw new Error(`HTTP ${res.status}: ${res.statusText}`);
        }
        
        const json = await res.json();
        if (json && json.success && json.order) {
        this.lastOrder = json.order;
        }
    } catch (err) {
        console.error('Failed to load last order:', err);
    } finally {
        this.lastOrderLoading = false;
    }
    },

    async fetchUnfulfilledOrders() {
    this.unfulfilledOrdersLoading = true;
    try {
        const res = await fetch(this.apiUrl('/unfulfilled-orders'), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({})
        });
        
        if (!res.ok) {
        throw new Error(`HTTP ${res.status}: ${res.statusText}`);
        }
        
        const json = await res.json();
        if (json && json.success && json.orders) {
        this.unfulfilledOrders = json.orders;
        }
    } catch (err) {
        console.error('Failed to load unfulfilled orders:', err);
    } finally {
        this.unfulfilledOrdersLoading = false;
    }
    },
    
    async fetchUpcomingDelivery() {
    this.upcomingDeliveryLoading = true;
    try {
        const deliverySchedule = await this.callRechargeAPI(async (session) => {
        // Use Recharge SDK to get delivery schedule
        if (!window.recharge || !session) {
            throw new Error('Recharge SDK not loaded or session not available');
        }
        
        // Call Recharge API with session as first parameter and options as second
        // Get upcoming deliveries (next 365 days / 1 year)
        const futureDate = new Date();
        futureDate.setDate(futureDate.getDate() + 365);
        
        return await recharge.customer.getDeliverySchedule(session, {
            date_max: futureDate.toISOString().split('T')[0] // Format: YYYY-MM-DD
        });
        });
        
        // Find the next upcoming delivery
        if (deliverySchedule && deliverySchedule.length > 0) {
        console.log('Delivery schedule received:', deliverySchedule); // Debug log
        
        // Sort by date to get the earliest upcoming delivery
        const upcomingDeliveries = deliverySchedule
            .filter(delivery => new Date(delivery.date) > new Date())
            .sort((a, b) => new Date(a.date) - new Date(b.date));
        
        console.log('Upcoming deliveries:', upcomingDeliveries); // Debug log
        
        if (upcomingDeliveries.length > 0) {
            // Get the earliest delivery date
            const earliestDate = upcomingDeliveries[0].date;
            console.log('Earliest delivery date:', earliestDate);
            
            // Get all deliveries on the earliest date (there might be multiple with different addresses)
            const deliveriesOnEarliestDate = upcomingDeliveries.filter(d => d.date === earliestDate);
            console.log(`Found ${deliveriesOnEarliestDate.length} delivery/deliveries on ${earliestDate}`);
            
            // Group orders by address_id across all deliveries on this date
            const ordersByAddress = {};
            
            deliveriesOnEarliestDate.forEach(delivery => {
                console.log('Processing delivery:', delivery);
                
                if (delivery.orders && Array.isArray(delivery.orders)) {
                    delivery.orders.forEach(order => {
                        const addressId = order.address_id?.toString() || 'unknown';
                        
                        if (!ordersByAddress[addressId]) {
                            ordersByAddress[addressId] = {
                                orders: [],
                                date: delivery.date,
                                deliveryId: delivery.id,
                                shippingAddress: order.shipping_address || delivery.shipping_address
                            };
                        }
                        
                        ordersByAddress[addressId].orders.push(order);
                    });
                }
            });
            
            console.log('Orders grouped by address_id:', ordersByAddress);
            
            // Create a delivery group for each address
            const deliveryGroups = [];
            
            for (const [addressId, addressData] of Object.entries(ordersByAddress)) {
                console.log(`\n📦 Processing address_id: ${addressId}`);
                
                const nextDelivery = addressData;
            
                // Extract line items from orders array
                let allLineItems = [];
                if (nextDelivery.orders && Array.isArray(nextDelivery.orders)) {
                console.log('Orders in delivery:', nextDelivery.orders);
                
                nextDelivery.orders.forEach((order, orderIndex) => {
                    console.log(`Order ${orderIndex}:`, order);
                    
                    // Try multiple possible line items properties
                    const orderItems = order.line_items || 
                                    order.items || 
                                    order.subscription_line_items || 
                                    order.products || 
                                    [];
                                    
                    console.log(`Order ${orderIndex} line items:`, orderItems);
                    
                    if (Array.isArray(orderItems)) {
                    allLineItems = allLineItems.concat(orderItems);
                    }
                });
                }
                
                console.log('All extracted line items:', allLineItems);
                
                // Calculate total price from orders and look for charge IDs
                let totalPrice = 0;
                let chargeIds = [];
                let enhancedPricing = null;
                let deliveryAddressId = addressId; // Use the address_id from grouping
                
                if (nextDelivery.orders && Array.isArray(nextDelivery.orders)) {
                    nextDelivery.orders.forEach(order => {
                        const orderTotal = parseFloat(order.order_subtotal || order.subtotal || order.total || 0);
                        totalPrice += orderTotal;
                        
                        // Collect charge IDs for enhanced pricing lookup
                        if (order.charge_id) {
                            chargeIds.push(order.charge_id);
                            console.log(`📦 Order found with charge_id: ${order.charge_id}`);
                        }
                    });
                    console.log('📅 Next delivery date from schedule:', nextDelivery.date);
                    console.log('🆔 Total charge IDs found:', chargeIds);
                    console.log('🏠 Delivery address_id:', deliveryAddressId);
                }
                
                // If no charge IDs found, check if there's an error charge for this address
                if (chargeIds.length === 0 && deliveryAddressId && this.charges && this.charges.length > 0) {
                    console.log('⚠️ No charge_id in delivery schedule, checking for error charges by address...');
                    const errorCharge = this.charges.find(charge => 
                        charge.address_id === deliveryAddressId && 
                        charge.status === 'error' &&
                        charge.original_scheduled_at
                    );
                    
                    if (errorCharge) {
                        console.log('🚨 Found error charge by address match!');
                        console.log(`  Charge ID: ${errorCharge.id}`);
                        console.log(`  Original scheduled: ${errorCharge.original_scheduled_at}`);
                        console.log(`  Retry date: ${errorCharge.retry_date}`);
                        chargeIds.push(errorCharge.id);
                    }
                }
                
                // If we have charge IDs, fetch detailed pricing from charges
                if (chargeIds.length > 0) {
                    try {
                        console.log('Fetching charge details for IDs:', chargeIds);
                        const chargeResult = await this.callRechargeAPI(async (session) => {
                            if (recharge.charge && typeof recharge.charge.listCharges === 'function') {
                                // Get all charges and filter by our charge IDs
                                const result = await recharge.charge.listCharges(session, {
                                    limit: 250,
                                    sort_by: 'id-desc'
                                });
                                
                                if (result && result.charges) {
                                    return {
                                        charges: result.charges.filter(charge => 
                                            chargeIds.includes(charge.id.toString()) || chargeIds.includes(charge.id)
                                        )
                                    };
                                }
                                return { charges: [] };
                            }
                            return { charges: [] };
                        });
                        
                        if (chargeResult && chargeResult.charges && chargeResult.charges.length > 0) {
                            console.log(`💰 Processing ${chargeResult.charges.length} charges for pricing details`);
                            
                            // Sum up pricing details from all matching charges
                            let totalChargePrice = 0;
                            let totalDiscounts = 0;
                            let totalTax = 0;
                            let totalShipping = 0;
                            let subtotalBeforeDiscounts = 0;
                            let appliedDiscounts = [];
                            let chargeAddressId = null; // Store the address_id from the first charge
                            let originalScheduledAt = null; // Store original_scheduled_at from error charges
                            let hasErrorCharge = false; // Track if any charge has error status
                            
                            chargeResult.charges.forEach((charge, index) => {
                                console.log(`  Charge ${index + 1}/${chargeResult.charges.length}: ID=${charge.id}, Status=${charge.status}`);
                                
                                // Store address_id from the first charge
                                if (!chargeAddressId && charge.address_id) {
                                    chargeAddressId = charge.address_id;
                                }
                                
                                // Check if this is an error charge and store original_scheduled_at
                                if (charge.status === 'error' && charge.original_scheduled_at) {
                                    console.log(`🚨 ERROR CHARGE FOUND! Charge ID: ${charge.id}`);
                                    console.log(`  - Status: ${charge.status}`);
                                    console.log(`  - original_scheduled_at: ${charge.original_scheduled_at}`);
                                    console.log(`  - scheduled_at: ${charge.scheduled_at}`);
                                    hasErrorCharge = true;
                                    if (!originalScheduledAt) {
                                        originalScheduledAt = charge.original_scheduled_at;
                                        console.log(`  - Set originalScheduledAt to: ${originalScheduledAt}`);
                                    }
                                }
                                
                                // Calculate subtotal from line items price (before discounts)
                                subtotalBeforeDiscounts += parseFloat(charge.total_line_items_price || 0);
                                
                                // Get total discounts from charge - only if discounts array has items
                                if (charge.discounts && Array.isArray(charge.discounts) && charge.discounts.length > 0) {
                                    totalDiscounts += parseFloat(charge.total_discounts || 0);
                                }
                                // If discounts array is empty, don't add to totalDiscounts (stays 0)
                                
                                // Extract discount codes from discounts array for display
                                if (charge.discounts && Array.isArray(charge.discounts)) {
                                    charge.discounts.forEach(discount => {
                                        appliedDiscounts.push({
                                            id: discount.id,
                                            code: discount.code,
                                            value: parseFloat(charge.total_discounts || 0), // Use charge's total_discounts
                                            value_type: discount.value_type,
                                            chargeId: charge.id
                                        });
                                    });
                                }
                                
                                totalTax += parseFloat(charge.total_tax || 0);
                                
                                // Calculate shipping from shipping_lines array
                                if (charge.shipping_lines && Array.isArray(charge.shipping_lines)) {
                                    charge.shipping_lines.forEach(shippingLine => {
                                        totalShipping += parseFloat(shippingLine.price || 0);
                                    });
                                }
                            });
                            
                            // Calculate order total: subtotal - discounts + shipping + tax
                            totalChargePrice = subtotalBeforeDiscounts - totalDiscounts + totalShipping + totalTax;
                            
                            enhancedPricing = {
                                totalPrice: totalChargePrice,
                                totalDiscounts: totalDiscounts,
                                totalTax: totalTax,
                                totalShipping: totalShipping,
                                subtotalBeforeDiscounts: subtotalBeforeDiscounts,
                                appliedDiscounts: appliedDiscounts,
                                addressId: chargeAddressId || deliveryAddressId, // Include address_id in the pricing object
                                hasDetailedPricing: true,
                                originalScheduledAt: originalScheduledAt, // Include original_scheduled_at from error charges
                                hasErrorCharge: hasErrorCharge // Flag indicating if this is an error charge
                            };
                            
                            console.log('Enhanced pricing from charges:', enhancedPricing);
                            
                            // Use the calculated total price
                            totalPrice = totalChargePrice;
                        }
                    } catch (err) {
                        console.error('Failed to fetch charge details:', err);
                        // Continue with delivery schedule pricing as fallback
                    }
                }
                
                // Format the delivery data to match our template structure
                const finalDate = enhancedPricing?.hasErrorCharge && enhancedPricing?.originalScheduledAt 
                                  ? enhancedPricing.originalScheduledAt 
                                  : nextDelivery.date;
                
                console.log('📅 Setting delivery date for address', addressId);
                console.log('  - nextDelivery.date (from delivery schedule):', nextDelivery.date);
                console.log('  - enhancedPricing?.hasErrorCharge:', enhancedPricing?.hasErrorCharge);
                console.log('  - enhancedPricing?.originalScheduledAt:', enhancedPricing?.originalScheduledAt);
                console.log('  - Final date selected:', finalDate);
                
                const deliveryGroup = {
                    id: nextDelivery.deliveryId,
                    date: finalDate,
                    totalPrice: totalPrice,
                    currencyCode: 'USD',
                    frequency: nextDelivery.orders[0]?.order_interval_frequency || nextDelivery.orders[0]?.interval_frequency,
                    address: nextDelivery.shippingAddress,
                    lineItems: this.formatRechargeLineItems(allLineItems),
                    subscriptionId: nextDelivery.orders[0]?.subscription_id,
                    addressId: deliveryAddressId,
                    // Enhanced pricing details from charges (if available)
                    ...(enhancedPricing || {}),
                    chargeIds: chargeIds
                };
                
                deliveryGroups.push(deliveryGroup);
                console.log('✅ Added delivery group for address', addressId, deliveryGroup);
            }
            
            // Set the upcomingDeliveries array and upcomingDelivery (first one for backwards compatibility)
            this.upcomingDeliveries = deliveryGroups;
            this.upcomingDelivery = deliveryGroups.length > 0 ? deliveryGroups[0] : null;
            
            console.log('✅ Final upcomingDeliveries array:', this.upcomingDeliveries);
            console.log('✅ Final upcomingDelivery (first group):', this.upcomingDelivery);
        }
        }
    } catch (err) {
        console.error('Failed to load upcoming delivery:', err);
        // Don't show error to user for subscription data - it's optional
        // But log more details for debugging
        console.error('Customer ID:', this.customerId);
        console.error('Customer Email:', this.customerEmail);
        console.error('Recharge Session:', this.rechargeSession);
    } finally {
        this.upcomingDeliveryLoading = false;
    }
    },
    
    formatRechargeLineItems(items) {
    console.log('=== FORMATTING RECHARGE LINE ITEMS START ===');
    console.log('Input items:', items); // Debug log
    console.log('Available products count:', this.products ? this.products.length : 0);
    console.log('Products data exists:', !!this.products);
    console.log('Products is array:', Array.isArray(this.products));
    
    if (this.products && this.products.length > 0) {
        console.log('Sample product structure:', this.products[0]);
        console.log('First 3 products for reference:', this.products.slice(0, 3).map(p => ({
            id: p.id,
            external_product_id: p.external_product_id,
            title: p.title,
            variants_count: p.variants ? p.variants.length : 0,
            first_variant_id: p.variants && p.variants[0] ? p.variants[0].id : null,
            first_variant_external_id: p.variants && p.variants[0] ? p.variants[0].external_variant_id : null
        })));
    } else {
        console.warn('⚠️ NO SHOPIFY PRODUCTS AVAILABLE - All images will use Recharge fallback');
        console.log('this.products value:', this.products);
    }
    
    if (!items || !Array.isArray(items)) {
        console.log('No items or items is not an array:', items);
        return [];
    }
    
    const formattedItems = items.map((item, index) => {
        console.log(`=== FORMATTING ITEM ${index} ===`);
        console.log(`Item ${index} full data:`, item);
        
        // Extract IDs from various possible structures
        const getProductId = (item) => {
            return item.external_product_id?.ecommerce || 
                   item.external_product_id || 
                   item.shopify_product_id ||
                   item.product_id;
        };
        
        const getVariantId = (item) => {
            return item.external_variant_id?.ecommerce || 
                   item.external_variant_id || 
                   item.shopify_variant_id ||
                   item.variant_id;
        };
        
        const productId = getProductId(item);
        const variantId = getVariantId(item);
        
        console.log(`Item ${index}: product_title="${item.product_title}", product_id=${productId}, variant_id=${variantId}`);
        
        // FIRST: Try to get image from Shopify products feed (most reliable and current)
        let imageUrl = this.getImageFromProducts(item);
        if (imageUrl) {
            console.log(`✓ Item ${index}: Using image from Shopify products feed`);
        }
        
        // SECOND: If no Shopify image, try Recharge images object
        if (!imageUrl && item.images && typeof item.images === 'object') {
            console.log(`→ Item ${index}: Trying Recharge images object`);
            imageUrl = this.extractImageUrl(item.images);
            if (imageUrl) {
                console.log(`✓ Item ${index}: Using Recharge image`);
            }
        }
        
        // THIRD: If still no image, try other Recharge fallback properties
        if (!imageUrl) {
            const fallbackImageUrl = item.image || 
                                    item.featured_image || 
                                    item.product_image || 
                                    item.variant_image ||
                                    (item.product && item.product.image) ||
                                    (item.variant && item.variant.image);
            
            if (fallbackImageUrl) {
                console.log(`→ Item ${index}: Trying Recharge fallback property`);
                imageUrl = this.extractImageUrl(fallbackImageUrl);
                if (imageUrl) {
                    console.log(`✓ Item ${index}: Using Recharge fallback image`);
                }
            }
        }
        
        // Final validation and result
        if (imageUrl && !(imageUrl.startsWith('http://') || imageUrl.startsWith('https://'))) {
            console.warn(`✗ Item ${index}: Invalid image URL (not HTTP/HTTPS): ${imageUrl}`);
            imageUrl = null;
        }
        
        console.log(`→ Item ${index} FINAL RESULT: "${item.product_title}" = ${imageUrl ? '✓ IMAGE FOUND' : '✗ NO IMAGE'}`);
        if (imageUrl) console.log(`  Image: ${imageUrl}`);
        
        const formattedItem = {
            id: item.subscription_id || item.id || `item-${index}`,
            title: item.product_title || item.title || item.name || 'Unknown Product',
            productTitle: item.product_title || item.title || item.name || 'Unknown Product',
            variantTitle: item.variant_title !== null ? item.variant_title : 'Default Title',
            quantity: parseInt(item.quantity) || 1,
            imageUrl: imageUrl,
            imageAltText: item.product_title || item.title || item.name || 'Product Image',
            price: parseFloat(item.unit_price || item.price || item.subtotal_price || 0),
            subtotalPrice: parseFloat(item.subtotal_price || item.total_price || item.price || 0),
            originalPrice: parseFloat(item.original_price || item.unit_price || 0),
            currency: item.currency || 'USD',
            subscriptionId: item.subscription_id,
            externalProductId: productId,
            externalVariantId: variantId,
            planType: item.plan_type,
            isSkippable: item.is_skippable,
            isSkipped: item.is_skipped,
            productId: productId,
            variantId: variantId
        };
        
        console.log(`Item ${index} formatted item object:`, formattedItem);
        return formattedItem;
    });
    
    // Sort items: subscription items first, onetime items last
    const sortedItems = formattedItems.sort((a, b) => {
        // If plan types are different, sort by plan type
        if (a.planType !== b.planType) {
        // onetime items go to the end (return 1 when a is onetime, -1 when b is onetime)
        if (a.planType === 'onetime') return 1;
        if (b.planType === 'onetime') return -1;
        }
        
        // If plan types are the same, maintain original order (stable sort)
        return 0;
    });
    
    console.log('=== FORMATTED LINE ITEMS SUMMARY ===');
    console.log('Total items formatted:', sortedItems.length);
    sortedItems.forEach((item, index) => {
        console.log(`Item ${index}: ${item.title}`, {
            imageUrl: item.imageUrl,
            imageUrl_valid: !!(item.imageUrl && (item.imageUrl.startsWith('http://') || item.imageUrl.startsWith('https://'))),
            externalProductId: item.externalProductId,
            externalVariantId: item.externalVariantId,
            planType: item.planType
        });
    });
    console.log('=== END FORMATTED LINE ITEMS SUMMARY ===');
    
    return sortedItems;
    },
    
    formatFrequency(frequency) {
    if (!frequency) return '';
    
    const frequencyMap = {
        '1': 'Weekly',
        '2': 'Every 2 weeks',
        '3': 'Every 3 weeks',
        '4': 'Monthly',
        '8': 'Every 2 months',
        '12': 'Every 3 months',
        '16': 'Every 4 months',
        '24': 'Every 6 months'
    };
    
    return frequencyMap[frequency.toString()] || `Every ${frequency} weeks`;
    },
    
    debugUpcomingDelivery() {
    console.log('=== DEBUGGING UPCOMING DELIVERY ===');
    console.log('Full upcoming delivery object:', this.upcomingDelivery);
    
    if (this.upcomingDelivery && this.upcomingDelivery.lineItems) {
        console.log('Line items array:', this.upcomingDelivery.lineItems);
        console.log('Line items count:', this.upcomingDelivery.lineItems.length);
        this.upcomingDelivery.lineItems.forEach((item, index) => {
            console.log(`=== LINE ITEM ${index} DEBUG ===`);
            console.log(`Title: ${item.title || item.productTitle}`);
            console.log(`Plan Type: ${item.planType}`);
            console.log(`Image URL: ${item.imageUrl}`);
            console.log(`Image Valid: ${!!(item.imageUrl && (item.imageUrl.startsWith('http://') || item.imageUrl.startsWith('https://')))}`)
            console.log(`External Product ID: ${item.externalProductId}`);
            console.log(`External Variant ID: ${item.externalVariantId}`);
            console.log(`Full item object:`, item);
        });
    } else {
        console.log('No line items found in upcoming delivery');
    }
    
    console.log('=== PRODUCTS AVAILABLE FOR MATCHING ===');
    console.log('Products count:', this.products ? this.products.length : 0);
    if (this.products && this.products.length > 0) {
        console.log('First 5 products:', this.products.slice(0, 5).map(p => ({
            id: p.id,
            external_product_id: p.external_product_id,
            title: p.title,
            variants_count: p.variants ? p.variants.length : 0,
            sample_variant_ids: p.variants ? p.variants.slice(0, 3).map(v => v.id) : []
        })));
    }
    
    // Also trigger a fresh fetch
    this.fetchUpcomingDelivery();
    },
    
    async manageSubscription() {
    console.log('=== manageSubscription() called ===');
    console.log('Current subscription groups:', this.subscriptionGroups);
    console.log('Subscription groups length:', this.subscriptionGroups ? this.subscriptionGroups.length : 0);
    
    // If we don't have subscription groups loaded yet, load them first
    if (!this.subscriptionGroups || this.subscriptionGroups.length === 0) {
        console.log('Subscription groups not loaded, loading now...');
        try {
        await this.loadAllSubscriptions();
        console.log('Subscriptions loaded, count:', this.subscriptionGroups ? this.subscriptionGroups.length : 0);
        // Also load payment methods if not already loaded
        if (!this.addressesWithPaymentMethods || this.addressesWithPaymentMethods.length === 0) {
            console.log('Loading payment methods...');
            await this.loadAddressesWithPaymentMethods();
            console.log('Payment methods loaded');
        }
        } catch (error) {
        console.error('Failed to load subscription data:', error);
        // Fallback: Navigate to subscriptions section
        window.location.href = '/pages/dashboard?view=dashboard&section=manage-subscriptions';
        return;
        }
    }
    
    // Now check if we have subscription groups
    if (this.subscriptionGroups && this.subscriptionGroups.length > 0) {
        // Find the first active (non-cancelled) group, or fall back to the first group
        const activeGroup = this.subscriptionGroups.find(group => 
        group.status !== 'CANCELLED' && group.status !== 'cancelled'
        ) || this.subscriptionGroups[0];
        
        if (activeGroup) {
        console.log('Opening payment modal for group:', activeGroup);
        this.updatePayment(activeGroup);
        return;
        }
    }
    
    // Fallback: Navigate to subscriptions section if still no groups after loading
    console.log('No subscription groups found, navigating to manage subscriptions');
    window.location.href = '/pages/dashboard?view=dashboard&section=manage-subscriptions';
    },
    
    async skipNextDelivery() {
    if (this.loadingStates.skippingDelivery || !this.upcomingDelivery) return;
    
    if (!confirm('Are you sure you want to skip your next delivery?')) return;
    
    this.loadingStates.skippingDelivery = true;
    
    try {
        await this.callRechargeAPI(async (session) => {
        if (!window.recharge || !session) {
            throw new Error('Recharge SDK not loaded or session not available');
        }
        
        // Skip the delivery using Recharge API with correct parameter structure
        return await recharge.subscription.skip(session, {
            subscription_id: this.upcomingDelivery.subscriptionId,
            date: this.upcomingDelivery.date
        });
        });
        
        // Refresh the delivery data
        await this.fetchUpcomingDelivery();
        
        // Show success message
        this.successMessages.delivery = 'Your next delivery has been skipped successfully!';
        setTimeout(() => {
        this.successMessages.delivery = '';
        }, 3000);
        
    } catch (err) {
        console.error('Failed to skip delivery:', err);
        this.errors.delivery = 'Failed to skip delivery. Please try again or contact support.';
    } finally {
        this.loadingStates.skippingDelivery = false;
    }
    },
    
    editDeliveryDate() {
    // For now, redirect to subscription management
    // In the future, this could open a date picker modal
    this.manageSubscription();
    },
    
    async fetchOrderHistory(cursor = null, replace = true, page = 1) {
    // Check cache first for better performance
    const cacheKey = `page-${page}`;
    const now = new Date().getTime();
    const cacheExpiry = 5 * 60 * 1000; // 5 minutes
    
    if (this.orderCache[cacheKey] && this.lastCacheTime && (now - this.lastCacheTime) < cacheExpiry) {
        const cached = this.orderCache[cacheKey];
        if (replace) {
        this.orderHistory = cached.orders;
        this.orderPagination.totalCount = cached.totalCount;
        } else {
        this.orderHistory = [...this.orderHistory, ...cached.orders];
        // Don't update totalCount from cache when appending
        }
        this.orderPagination.totalPages = Math.ceil(this.orderPagination.totalCount / this.orderPagination.pageSize);
        this.orderPagination.currentPage = page;
        return;
    }

    this.orderPagination.isLoading = true;
    try {
        const res = await fetch(this.apiUrl('/order-history'), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            cursor: cursor,
            limit: this.orderPagination.pageSize,
            page: page
        })
        });
        const json = await res.json();
        console.log('Order history API response:', json); // Debug log
        if (json && json.success) {
        if (replace) {
            this.orderHistory = json.orders || [];
        } else {
            this.orderHistory = [...this.orderHistory, ...(json.orders || [])];
        }
        
        // Update pagination info
        this.orderPagination.hasNextPage = json.pageInfo?.hasNextPage || false;
        this.orderPagination.endCursor = json.pageInfo?.endCursor;
        
        // Only update totalCount if we don't already have it, or if this is a fresh load (replace = true)
        if (replace || this.orderPagination.totalCount === 0) {
            this.orderPagination.totalCount = json.totalCount || 0;
        }
        
        this.orderPagination.totalPages = Math.ceil(this.orderPagination.totalCount / this.orderPagination.pageSize);
        this.orderPagination.currentPage = page;

        console.log('Updated pagination:', this.orderPagination); // Debug log

        // Cache the results
        this.orderCache[cacheKey] = {
            orders: json.orders || [],
            totalCount: json.totalCount || 0
        };
        this.lastCacheTime = now;
        }
    } catch (err) {
        console.error('Failed to load order history:', err);
    } finally {
        this.orderPagination.isLoading = false;
        
        // After order history loads, check if there's a hash in the URL and scroll to it
        if (replace && window.location.hash) {
            this.$nextTick(() => {
                this.scrollToHashAnchor();
            });
        }
    }
    },
    scrollToHashAnchor() {
        const hash = window.location.hash;
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                // Get the element's position
                const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                // Offset for navigation bar (adjust this value as needed - typically 80-120px)
                const offset = 100;
                const offsetPosition = elementPosition - offset;
                
                // Scroll to the adjusted position
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }
    },
    async loadNextPage() {
    if (this.orderPagination.hasNextPage && !this.orderPagination.isLoading) {
        await this.fetchOrderHistory(this.orderPagination.endCursor, false, this.orderPagination.currentPage + 1);
    }
    },
    formatDate(dateStr) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    
    // Handle date-only strings (YYYY-MM-DD) to avoid timezone issues
    if (typeof dateStr === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        // Parse as local date to avoid timezone conversion
        const [year, month, day] = dateStr.split('-').map(Number);
        const localDate = new Date(year, month - 1, day); // month is 0-indexed
        return localDate.toLocaleDateString(undefined, options);
    }
    
    // For other date formats (with time), use normal parsing
    return new Date(dateStr).toLocaleDateString(undefined, options);
    },
    formatRelativeDate(dateStr) {
    // Handle date-only strings (YYYY-MM-DD) to avoid timezone issues
    let date;
    if (typeof dateStr === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        // Parse as local date to avoid timezone conversion
        const [year, month, day] = dateStr.split('-').map(Number);
        date = new Date(year, month - 1, day); // month is 0-indexed
    } else {
        // For other date formats (with time), use normal parsing
        date = new Date(dateStr);
    }
    
    const now = new Date();
    const diffInSeconds = Math.floor((date - now) / 1000); // Note: switched order for future dates
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);
    const diffInWeeks = Math.floor(diffInDays / 7);
    const diffInMonths = Math.floor(diffInDays / 30);
    
    // Handle future dates (for upcoming deliveries)
    if (diffInSeconds > 0) {
        // For very soon dates
        if (diffInMinutes < 60) {
        return diffInMinutes <= 1 ? 'Very soon' : `In ${diffInMinutes} minutes`;
        }
        
        if (diffInHours < 24) {
        return diffInHours === 1 ? 'In 1 hour' : `In ${diffInHours} hours`;
        }
        
        // Future dates (0-7 days)
        if (diffInDays === 0) return 'Today';
        if (diffInDays === 1) return 'Tomorrow';
        if (diffInDays <= 7) return `In ${diffInDays} days`;
        
        // Medium term (1-4 weeks)
        if (diffInWeeks <= 4) {
        return diffInWeeks === 1 ? 'In 1 week' : `In ${diffInWeeks} weeks`;
        }
        
        // Longer term (1-6 months)
        if (diffInMonths <= 6) {
        return diffInMonths === 1 ? 'In 1 month' : `In ${diffInMonths} months`;
        }
    } else {
        // Handle past dates (for order history)
        const pastDiffInSeconds = Math.abs(diffInSeconds);
        const pastDiffInMinutes = Math.floor(pastDiffInSeconds / 60);
        const pastDiffInHours = Math.floor(pastDiffInMinutes / 60);
        const pastDiffInDays = Math.floor(pastDiffInHours / 24);
        const pastDiffInWeeks = Math.floor(pastDiffInDays / 7);
        const pastDiffInMonths = Math.floor(pastDiffInDays / 30);
        
        // For very recent orders
        if (pastDiffInMinutes < 60) {
        return pastDiffInMinutes <= 1 ? 'Just now' : `${pastDiffInMinutes} minutes ago`;
        }
        
        if (pastDiffInHours < 24) {
        return pastDiffInHours === 1 ? '1 hour ago' : `${pastDiffInHours} hours ago`;
        }
        
        // Recent orders (0-7 days)
        if (pastDiffInDays === 0) return 'Today';
        if (pastDiffInDays === 1) return 'Yesterday';
        if (pastDiffInDays <= 7) return `${pastDiffInDays} days ago`;
        
        // Medium term (1-4 weeks)
        if (pastDiffInWeeks <= 4) {
        return pastDiffInWeeks === 1 ? '1 week ago' : `${pastDiffInWeeks} weeks ago`;
        }
        
        // Longer term (1-6 months)
        if (pastDiffInMonths <= 6) {
        return pastDiffInMonths === 1 ? '1 month ago' : `${pastDiffInMonths} months ago`;
        }
    }
    
    // Very old/far orders - show full date
    return this.formatDate(dateStr);
    },
    formatFullDateTime(dateStr) {
    const date = new Date(dateStr);
    const options = { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    };
    return date.toLocaleDateString(undefined, options);
    },
    formatCurrency(amount, currencyCode = 'USD') {
    const value = parseFloat(amount) || 0;
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode
    }).format(value);
    },
    
    formatPercentage(value) {
        const num = parseFloat(value) || 0;
        // If the number is a whole number (ends in .0), show without decimal
        if (num % 1 === 0) {
            return num.toString();
        }
        // Otherwise show with 1 decimal place
        return num.toFixed(1);
    },
    
    formatErrorMessage(errorText) {
        if (!errorText) return '';
        // Remove "None\r\n " and variations (None followed by any whitespace/newlines)
        let cleaned = errorText.replace(/None(\\r\\n|\r\n|\\n|\n)\s*/gi, '');
        // Also remove just "None " with trailing space
        cleaned = cleaned.replace(/^None\s+/gi, '');
        // Replace \r\n and \n with actual line breaks for display
        return cleaned.replace(/\\r\\n|\\n|\r\n|\n/g, '\n');
    },
    
    removeDiscountFromUpcomingOrder(chargeId, discountId) {
        if (!chargeId || !discountId) {
            console.error('Missing chargeId or discountId for discount removal');
            return Promise.reject(new Error('Missing chargeId or discountId'));
        }
        
        this.loadingStates.removingDiscount = true;
        
        return this.removeDiscountFromCharge(chargeId, discountId)
            .then(response => {
                console.log('✅ Discount removal response:', response);
                
                // Reload charges data to get updated pricing
                console.log('🔄 Reloading charges data...');
                return this.loadCharges().then(() => {
                    // Then refresh the upcoming delivery data to reflect the changes
                    console.log('🔄 Refreshing upcoming delivery...');
                    return this.fetchUpcomingDelivery();
                }).then(() => {
                    this.showSuccessMessage('Discount removed successfully');
                });
            })
            .catch(error => {
                console.error('Error removing discount:', error);
                this.showErrorMessage('Failed to remove discount: ' + (error.message || 'Unknown error'));
                throw error;
            })
            .finally(() => {
                this.loadingStates.removingDiscount = false;
            });
    },
    
    async removeDiscountFromCharge(chargeId, discountId) {
        try {
            console.log('🔥 Removing discount from charge:', chargeId);
            
            // First, get the charge to find the address_id
            const charge = await this.callRechargeAPI(async (session) => {
                if (recharge.charge && typeof recharge.charge.getCharge === 'function') {
                    return await recharge.charge.getCharge(session, chargeId);
                }
                throw new Error('getCharge method not available');
            });
            
            console.log('📦 Charge data:', charge);
            
            if (!charge || !charge.address_id) {
                throw new Error('Could not find address_id for charge');
            }
            
            // Step 1: Remove discounts from the charge first
            const chargeResult = await this.callRechargeAPI(async (session) => {
                console.log('🔄 Removing discounts from charge:', chargeId);
                
                if (recharge.charge && typeof recharge.charge.removeDiscountsFromCharge === 'function') {
                    const apiResult = await recharge.charge.removeDiscountsFromCharge(session, chargeId);
                    console.log('📦 Charge discount removal result:', apiResult);
                    return apiResult;
                } else {
                    console.warn('⚠️ No removeDiscountsFromCharge method found. Available charge methods:');
                    if (recharge.charge) {
                        console.log('recharge.charge methods:', Object.keys(recharge.charge));
                    }
                    // Continue to address removal even if charge removal fails
                    return null;
                }
            });
            
            if (chargeResult) {
                console.log('✨ Discount removed from charge successfully');
            }
            
            // Step 2: Remove discounts from the address
            const addressResult = await this.callRechargeAPI(async (session) => {
                console.log('🔄 Removing discounts from address:', charge.address_id);
                
                if (recharge.address && typeof recharge.address.removeDiscountsFromAddress === 'function') {
                    const apiResult = await recharge.address.removeDiscountsFromAddress(session, charge.address_id);
                    console.log('📦 Address discount removal result:', apiResult);
                    return apiResult;
                } else {
                    console.warn('⚠️ No removeDiscountsFromAddress method found. Available address methods:');
                    if (recharge.address) {
                        console.log('recharge.address methods:', Object.keys(recharge.address));
                    }
                    throw new Error('removeDiscountsFromAddress method not available');
                }
            });
            
            console.log('✨ Final result from removeDiscountFromCharge:', addressResult);
            return addressResult;
        } catch (error) {
            console.error('❌ Error in removeDiscountFromCharge:', error);
            throw error;
        }
    },
    
    showSuccessMessage(message) {
        console.log('✅ Success:', message);
        // You can implement toast notifications or other UI feedback here
        // For now, we'll just log the message
    },
    
    showErrorMessage(message) {
        console.error('❌ Error:', message);
        // You can implement toast notifications or other UI feedback here
        // For now, we'll just log the error
    },
    
    openAddDiscountModal() {
        this.showAddDiscountModal = true;
        this.discountCodeInput = '';
        this.discountCodeError = '';
        this.currentDiscountGroup = null; // For upcoming delivery
    },
    
    openAddDiscountModalForGroup(group) {
        this.showAddDiscountModal = true;
        this.discountCodeInput = '';
        this.discountCodeError = '';
        this.currentDiscountGroup = group; // Store which group we're adding discount to
    },
    
    closeAddDiscountModal() {
        this.showAddDiscountModal = false;
        this.discountCodeInput = '';
        this.discountCodeError = '';
        this.currentDiscountGroup = null;
    },
    
    async removeDiscountFromSubscriptionGroup(chargeId, discountId) {
        console.log(`🗑️ Removing discount ${discountId} from charge ${chargeId}`);
        
        if (!chargeId) {
            console.error('❌ No charge ID provided');
            return;
        }
        
        this.loadingStates.removingDiscount = true;
        
        try {
            await this.removeDiscountFromUpcomingOrder(chargeId, discountId);
            
            // Reload subscriptions to refresh pricing
            await this.loadAllSubscriptions();
            
            this.showSuccessMessage('Discount removed successfully');
        } catch (error) {
            console.error('❌ Error removing discount from charge:', error);
            this.showErrorMessage('Failed to remove discount. Please try again.');
        } finally {
            this.loadingStates.removingDiscount = false;
        }
    },
    
    async applyDiscountCode() {
        const code = this.discountCodeInput.trim();
        
        if (!code) {
            this.discountCodeError = 'Please enter a discount code';
            return;
        }
        
        this.loadingStates.applyingDiscount = true;
        this.discountCodeError = '';
        
        try {
            let addressId, chargeIds;
            
            // Check if we're applying to a subscription group or upcoming delivery
            if (this.currentDiscountGroup) {
                // Applying to a subscription group
                console.log('🎫 Applying discount to subscription group:', this.currentDiscountGroup);
                
                if (!this.currentDiscountGroup.address_id) {
                    this.discountCodeError = 'No address found for this subscription';
                    return;
                }
                
                addressId = this.currentDiscountGroup.address_id;
                chargeIds = this.currentDiscountGroup.matchingCharge ? [this.currentDiscountGroup.matchingCharge.id] : [];
                
            } else {
                // Applying to upcoming delivery (Dashboard Home)
                if (!this.upcomingDelivery || !this.upcomingDelivery.addressId) {
                    this.discountCodeError = 'No address found for upcoming delivery';
                    return;
                }
                
                addressId = this.upcomingDelivery.addressId;
                chargeIds = this.upcomingDelivery.chargeIds || [];
            }
            
            // Step 1: Apply discount to each charge first
            let chargeAppliedSuccessfully = false;
            
            if (chargeIds.length > 0) {
                for (const chargeId of chargeIds) {
                    try {
                        const chargeResult = await this.callRechargeAPI(async (session) => {
                            console.log('🎫 Applying discount to charge:', chargeId, code);
                            
                            if (recharge.charge && typeof recharge.charge.applyDiscountToCharge === 'function') {
                                const apiResult = await recharge.charge.applyDiscountToCharge(session, chargeId, code);
                                console.log('📦 Charge discount application result:', apiResult);
                                return apiResult;
                            } else {
                                console.warn('⚠️ No applyDiscountToCharge method found. Available charge methods:');
                                if (recharge.charge) {
                                    console.log('recharge.charge methods:', Object.keys(recharge.charge));
                                }
                                // Don't throw error here, continue with address discount
                                return null;
                            }
                        });
                        
                        if (chargeResult) {
                            console.log('✨ Discount applied to charge successfully:', chargeResult);
                            chargeAppliedSuccessfully = true;
                        }
                    } catch (chargeError) {
                        console.warn('⚠️ Failed to apply discount to charge:', chargeId, chargeError.message);
                        // Continue even if charge discount fails
                    }
                }
            } else {
                console.log('ℹ️ No charge IDs found, skipping charge discount');
            }
            
            // Step 2: Apply discount to the address
            try {
                const addressResult = await this.callRechargeAPI(async (session) => {
                    console.log('🎫 Applying discount to address:', addressId, code);
                    
                    if (recharge.address && typeof recharge.address.applyDiscountToAddress === 'function') {
                        const apiResult = await recharge.address.applyDiscountToAddress(session, addressId, code);
                        console.log('📦 Address discount application result:', apiResult);
                        return apiResult;
                    } else {
                        console.warn('⚠️ No applyDiscountToAddress method found. Available address methods:');
                        if (recharge.address) {
                            console.log('recharge.address methods:', Object.keys(recharge.address));
                        }
                        throw new Error('applyDiscountToAddress method not available');
                    }
                });
                
                console.log('✨ Discount applied to address successfully:', addressResult);
            } catch (addressError) {
                console.error('❌ Error applying discount to address:', addressError);
                
                // Check if this is a usage limit error AND we successfully applied to charge
                const isUsageLimitError = 
                    addressError.message && 
                    (addressError.message.includes('usage limit') || 
                     addressError.message.includes('already reached') ||
                     (addressError.response && addressError.response.status === 422));
                
                if (chargeAppliedSuccessfully && isUsageLimitError) {
                    console.log('✅ Discount was applied to charge successfully, treating as success despite address error (single-use discount)');
                    // Continue to success - don't throw error
                } else {
                    // Re-throw if it's not a usage limit error or if charge application failed
                    throw addressError;
                }
            }
            
            // Reload data to show the new discount
            if (this.currentDiscountGroup) {
                // Reload subscriptions to refresh group pricing
                await this.loadAllSubscriptions();
            } else {
                // Reload upcoming delivery
                await this.loadCharges();
                await this.fetchUpcomingDelivery();
            }
            
            // Close modal and show success
            this.closeAddDiscountModal();
            this.showSuccessMessage('Discount code applied successfully');
            
        } catch (error) {
            console.error('❌ Error applying discount:', error);
            this.discountCodeError = error.message || 'Failed to apply discount code. Please check the code and try again.';
        } finally {
            this.loadingStates.applyingDiscount = false;
        }
    },
    
    // New charge matching functions for pricing information
    getMatchingChargeLineItem(subscription, group) {
        if (!this.charges || !Array.isArray(this.charges)) {
            console.log('🔍 Regular Debug: No charges available');
            return null;
        }

        console.log('🔍 Regular Debug: Looking for charge match');
        console.log('  - Group address_id:', group.address_id);
        console.log('  - Group next_charge_scheduled_at:', group.next_charge_scheduled_at);
        console.log('  - Subscription id:', subscription.id);
        console.log('  - Subscription external_product_id:', subscription.external_product_id);
        console.log('  - Subscription external_variant_id:', subscription.external_variant_id);

        // Find charge that matches the group's address_id and next_charge_scheduled_at
        const matchingCharge = this.charges.find(charge => {
            const addressMatch = charge.address_id === group.address_id;
            const dateMatch = charge.original_scheduled_at === group.next_charge_scheduled_at;
            
            console.log(`  - Checking charge ${charge.id}: address_match=${addressMatch}, date_match=${dateMatch}`);
            console.log(`    charge.address_id=${charge.address_id}, charge.original_scheduled_at=${charge.original_scheduled_at}`);
            
            return addressMatch && dateMatch;
        });
        
        if (!matchingCharge || !matchingCharge.line_items) {
            console.log('🔍 Regular Debug: No matching charge found or no line items');
            return null;
        }

        console.log('🔍 Regular Debug: Found matching charge with', matchingCharge.line_items.length, 'line items');
        
        // For regular subscriptions, match by purchase_item_id first
        let matchingLineItem = matchingCharge.line_items.find(lineItem => {
            const match = lineItem.purchase_item_id === subscription.id;
            console.log(`  - Checking line item purchase_item_id ${lineItem.purchase_item_id} vs subscription.id ${subscription.id}: match=${match}`);
            return match;
        });
        
        // If no purchase_item_id match, try external_variant_id or external_product_id
        if (!matchingLineItem) {
            console.log('  - No purchase_item_id match, trying external IDs');
            
            if (subscription.external_variant_id && subscription.external_variant_id.ecommerce) {
                matchingLineItem = matchingCharge.line_items.find(lineItem => {
                    const match = lineItem.external_variant_id && 
                                  lineItem.external_variant_id.ecommerce === subscription.external_variant_id.ecommerce;
                    console.log(`    - Variant ID match: ${match} (${lineItem.external_variant_id?.ecommerce} vs ${subscription.external_variant_id.ecommerce})`);
                    return match;
                });
            }
            
            if (!matchingLineItem && subscription.external_product_id && subscription.external_product_id.ecommerce) {
                matchingLineItem = matchingCharge.line_items.find(lineItem => {
                    const match = lineItem.external_product_id && 
                                  lineItem.external_product_id.ecommerce === subscription.external_product_id.ecommerce;
                    console.log(`    - Product ID match: ${match} (${lineItem.external_product_id?.ecommerce} vs ${subscription.external_product_id.ecommerce})`);
                    return match;
                });
            }
        }

        if (matchingLineItem) {
            console.log('🎉 Regular Debug: Found matching line item!', matchingLineItem);
        } else {
            console.log('❌ Regular Debug: No matching line item found');
        }
        
        return matchingLineItem;
    },
    
    getMatchingChargeLineItemForBundle(bundleItem, group) {
        if (!this.charges || !Array.isArray(this.charges)) {
            console.log('🔍 Bundle Debug: No charges available');
            return null;
        }

        console.log('🔍 Bundle Debug: Looking for charge match');
        console.log('  - Group address_id:', group.address_id);
        console.log('  - Group next_charge_scheduled_at:', group.next_charge_scheduled_at);
        console.log('  - Bundle item:', bundleItem);
        console.log('  - Available charges:', this.charges.length);

        // Find charge that matches address_id and original_scheduled_at
        const matchingCharge = this.charges.find(charge => {
            const addressMatch = charge.address_id === group.address_id;
            const dateMatch = charge.original_scheduled_at === group.next_charge_scheduled_at;
            
            console.log(`  - Checking charge ${charge.id}: address_match=${addressMatch}, date_match=${dateMatch}`);
            console.log(`    charge.address_id=${charge.address_id}, charge.original_scheduled_at=${charge.original_scheduled_at}`);
            
            return addressMatch && dateMatch;
        });

        if (!matchingCharge || !matchingCharge.line_items) {
            console.log('🔍 Bundle Debug: No matching charge found or no line items');
            return null;
        }

        console.log('🔍 Bundle Debug: Found matching charge with', matchingCharge.line_items.length, 'line items');

        // For bundles, we need to:
        // 1. Find charge line item where purchase_item_id matches one of the subscription IDs in the group
        // 2. Match the bundleItem's external_product_id or external_variant_id with the charge line item
        const matchingLineItem = matchingCharge.line_items.find(lineItem => {
            console.log(`  - Checking line item: purchase_item_id=${lineItem.purchase_item_id}`);
            console.log(`    external_product_id=${lineItem.external_product_id?.ecommerce}, external_variant_id=${lineItem.external_variant_id?.ecommerce}`);
            
            // First check: line item purchase_item_id must match one of the subscription IDs in the group
            const hasMatchingSubscription = group.subscriptions.some(subscription => {
                const match = lineItem.purchase_item_id === subscription.id;
                console.log(`    checking subscription ${subscription.id}: match=${match}`);
                return match;
            });
            
            if (!hasMatchingSubscription) {
                console.log('    ❌ No matching subscription found');
                return false;
            }
            
            console.log('    ✅ Found matching subscription');
            
            // Second check: match external_product_id or external_variant_id
            if (lineItem.external_product_id && lineItem.external_variant_id) {
                // Match external_product_id
                const productMatch = bundleItem.external_product_id === lineItem.external_product_id.ecommerce;
                // Match external_variant_id  
                const variantMatch = bundleItem.external_variant_id === lineItem.external_variant_id.ecommerce;
                
                console.log(`    product_match=${productMatch}, variant_match=${variantMatch}`);
                console.log(`    bundleItem.external_product_id=${bundleItem.external_product_id}, bundleItem.external_variant_id=${bundleItem.external_variant_id}`);
                
                return productMatch || variantMatch;
            }
            
            console.log('    ❌ No external IDs to match');
            return false;
        });

        if (matchingLineItem) {
            console.log('🎉 Bundle Debug: Found matching line item!', matchingLineItem);
        } else {
            console.log('❌ Bundle Debug: No matching line item found');
        }

        return matchingLineItem;
    },
    
    truncateText(text, maxLength = 100) {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
    },
    async updateCustomer() {
    if (this.loadingStates.updatingCustomer) return;
    
    this.loadingStates.updatingCustomer = true;
    this.errors.customer = '';
    this.successMessages.customer = '';
    
    try {
        const response = await fetch(this.apiUrl('/update-customer'), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            email: this.form.email,
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            acceptsMarketing: this.form.acceptsMarketing
        })
        });
    
        const json = await response.json();
    
        const errors = json?.errors || json?.customerUserErrors || json?.data?.customerUpdate?.customerUserErrors;
    
        if (errors && errors.length > 0) {
        this.errors.customer = errors[0].message || 'Update failed.';
        } else {
        this.successMessages.customer = 'Profile updated successfully!';
        // Clear success message after 3 seconds
        setTimeout(() => {
            this.successMessages.customer = '';
        }, 3000);
        }
    } catch (err) {
        console.error('Error updating customer:', err);
        this.errors.customer = 'Something went wrong. Please try again.';
    } finally {
        this.loadingStates.updatingCustomer = false;
    }
    },
    togglePasswordForm() {
    this.showPasswordForm = true;
    this.view = '';             // hide other views
    this.editingAddress = null; // reset address edit mode if open
    },
    async loadAddresses(options = {}) {
    try {
        const res = await fetch(this.apiUrl('/get-addresses'));
        if (!res.ok) {
        throw new Error(`HTTP ${res.status}: ${res.statusText}`);
        }
        this.addresses = await res.json();
        if (!options.silent) {
            this.view = 'addresses';
            this.showPasswordForm = false; // hide password section
        }
    } catch (err) {
        console.error('Error loading addresses:', err);
        if (!options.silent) {
            this.errors.address = 'Failed to load addresses. Please try again.';
        }
    }
    },
    editAddress(addr) {
    this.editingAddress = { 
        ...addr,
        company: addr.company || '',
        address2: addr.address2 || ''
    };
    // Scroll to the edit form after Vue renders it
    this.$nextTick(() => {
        const el = document.getElementById('edit-address-form');
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });
    },
    addNewAddress() {
    this.editingAddress = {
        firstName: '',
        lastName: '',
        company: '',
        address1: '',
        address2: '',
        city: '',
        province: '',
        zip: '',
        country: 'United States',
        phone: '',
        isDefault: false
    };
    },
    cancelEdit() {
    this.editingAddress = null;
    },
    async removeAddress(addr) {
    // Use address-specific loading state
    if (this.loadingStates.removingAddress === addr.id) return;
    
    if (confirm('Are you sure you want to remove this address?')) {
        this.loadingStates.removingAddress = addr.id;
        this.errors.address = '';
        
        try {
        const res = await fetch(this.apiUrl('/delete-address'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: addr.id })
        });
        const json = await res.json();
        if (json.success) {
            this.successMessages.address = 'Address removed successfully!';
            await this.loadAddresses();
            setTimeout(() => {
            this.successMessages.address = '';
            }, 3000);
        } else {
            this.errors.address = json.error || 'Failed to remove address';
        }
        } catch (err) {
        console.error('Error removing address:', err);
        this.errors.address = 'Failed to remove address. Please try again.';
        } finally {
        this.loadingStates.removingAddress = false;
        }
    }
    },
    async setDefaultAddress(addr) {
    // Use address-specific loading state
    if (this.loadingStates.settingDefault === addr.id) return;
    
    this.loadingStates.settingDefault = addr.id;
    this.errors.address = '';
    
    try {
        const res = await fetch(this.apiUrl('/set-default-address'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: addr.id })
        });
        const json = await res.json();
        if (json.success) {
        await this.loadAddresses();
        
        // Show success modal
        this.successModalTitle = 'Default Address Updated';
        this.successModalMessage = 'Your default shipping address has been updated successfully.';
        
        // Add subscription warning if user has subscriptions
        if (this.hasAnySubscriptions) {
            this.successModalDetails = `<div class="text-sm" style="color: #92400E;">
            <p class="font-bold mb-2">⚠️ Important Notice for Subscribers:</p>
            <p class="mb-2">Updating an address here does <strong>not</strong> change or update your subscription delivery addresses.</p>
            <p>To update a subscription's address, go to <a href="/pages/dashboard?section=manage-subscriptions" class="font-bold underline" style="color: #D97706;">Manage Subscriptions</a> and click "Address."</p>
            </div>`;
        } else {
            this.successModalDetails = null;
        }
        
        this.showSuccessModal = true;
        } else {
        // Show error modal
        this.errorModalTitle = 'Failed to Set Default Address';
        this.errorModalMessage = json.error || 'An error occurred while setting the default address.';
        this.errorModalDetails = null;
        this.showErrorModal = true;
        }
    } catch (err) {
        console.error('Error setting default address:', err);
        // Show error modal
        this.errorModalTitle = 'Failed to Set Default Address';
        this.errorModalMessage = 'Failed to set default address. Please try again.';
        this.errorModalDetails = null;
        this.showErrorModal = true;
    } finally {
        this.loadingStates.settingDefault = false;
    }
    },
    async saveAddress() {
    if (this.loadingStates.savingAddress) return;
    
    this.loadingStates.savingAddress = true;
    this.errors.address = '';
    
    // Determine if this is a new address (no id) or update (has id) - moved outside try block
    const isNewAddress = !this.editingAddress.id;
    
    try {
        // Validate required fields
        if (!this.editingAddress.firstName || !this.editingAddress.lastName || 
            !this.editingAddress.address1 || !this.editingAddress.city || 
            !this.editingAddress.zip) {
        this.errors.address = 'Please fill in all required fields.';
        return;
        }
        
        const endpoint = isNewAddress ? '/create-address' : '/update-address';
        
        const res = await fetch(this.apiUrl(endpoint), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(this.editingAddress)
        });
        
        const json = await res.json();
        
        if (res.ok && json.success) {
        this.editingAddress = null;
        await this.loadAddresses();
        
        // Show success modal with appropriate message for subscribers
        this.successModalTitle = `Address ${isNewAddress ? 'Created' : 'Updated'} Successfully`;
        this.successModalMessage = `Your address has been ${isNewAddress ? 'added' : 'updated'} successfully.`;
        
        // Add subscription warning if user has subscriptions
        if (this.hasAnySubscriptions) {
            this.successModalDetails = `<div class="text-sm" style="color: #92400E;">
            <p class="font-bold mb-2">⚠️ Important Notice for Subscribers:</p>
            <p class="mb-2">Updating an address here does <strong>not</strong> change or update your subscription delivery addresses.</p>
            <p>To update a subscription's address, go to <a href="/pages/dashboard?section=manage-subscriptions" class="font-bold underline" style="color: #D97706;">Manage Subscriptions</a> and click "Address."</p>
            </div>`;
        } else {
            this.successModalDetails = null;
        }
        
        this.showSuccessModal = true;
        } else {
        // Show error modal with server error message
        this.errorModalTitle = `Failed to ${isNewAddress ? 'Create' : 'Update'} Address`;
        this.errorModalMessage = json.error || `An error occurred while ${isNewAddress ? 'creating' : 'updating'} the address.`;
        this.errorModalDetails = null;
        this.showErrorModal = true;
        }
    } catch (err) {
        console.error('Error saving address:', err);
        // Show error modal
        this.errorModalTitle = `Failed to ${isNewAddress ? 'Create' : 'Update'} Address`;
        this.errorModalMessage = 'Failed to save address. Please try again.';
        this.errorModalDetails = null;
        this.showErrorModal = true;
    } finally {
        this.loadingStates.savingAddress = false;
    }
    },
    async updatePassword() {
    if (this.loadingStates.changingPassword) return;
    
    this.passwordError = '';
    this.passwordSuccess = false;
    this.errors.password = '';
    this.successMessages.password = '';
    
    if (!this.password.new || !this.password.confirm) {
        this.errors.password = 'Both fields are required.';
        return;
    }
    
    if (this.password.new.length < 8) {
        this.errors.password = 'Password must be at least 8 characters long.';
        return;
    }
    
    if (this.password.new !== this.password.confirm) {
        this.errors.password = 'Passwords do not match.';
        return;
    }
    
    this.loadingStates.changingPassword = true;
    
    try {
        const response = await fetch(this.apiUrl('/change-password'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            password: this.password.new,
            passwordConfirmation: this.password.confirm
        })
        });
    
        const result = await response.json();
        if (result.success) {
        this.successMessages.password = 'Password updated successfully!';
        this.password.new = '';
        this.password.confirm = '';
        setTimeout(() => {
            this.successMessages.password = '';
        }, 3000);
        } else {
        this.errors.password = result.error || 'Failed to update password.';
        }
    } catch (err) {
        console.error('Password update error:', err);
        this.errors.password = 'Something went wrong. Please try again.';
    } finally {
        this.loadingStates.changingPassword = false;
    }
    },

    // Reorder functionality
    startReorder(order) {
    this.reorderData.isReordering = true;
    this.reorderData.originalOrder = order;
    this.reorderData.items = order.lineItems.map(item => ({
        id: item.id,
        title: item.title,
        imageUrl: item.imageUrl,
        imageAltText: item.imageAltText,
        originalQuantity: item.quantity,
        quantity: item.quantity, // Start with original quantity
        variantId: this.extractVariantId(item.variantId), // Extract numeric ID from GraphQL variant ID
        variantTitle: item.variantTitle,
        variantDisplayName: item.variantDisplayName,
        variantPrice: item.variantPrice,
        variantCompareAtPrice: item.variantCompareAtPrice,
        unitPrice: item.unitPrice,
        unitPriceCurrency: item.unitPriceCurrency,
        productId: item.productId,
        productTitle: item.productTitle,
        productDescription: item.productDescription
    }));
    
    // Hide other views
    this.view = '';
    this.showPasswordForm = false;
    this.editingAddress = null;
    
    // Scroll to top of page
    window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    
    extractVariantId(variantGraphQLId) {
    // Extract numeric ID from GraphQL ID like "gid://shopify/ProductVariant/123"
    if (!variantGraphQLId) return null;
    const match = variantGraphQLId.match(/ProductVariant\/(\d+)/);
    return match ? match[1] : null;
    },
    
    cancelReorder() {
    this.reorderData.isReordering = false;
    this.reorderData.originalOrder = null;
    this.reorderData.items = [];
    // Return to previous view (could be latest or history)
    this.view = (section === 'dashboard-home' || section === 'my-latest') ? 'latest' : (section === 'order-history' ? 'history' : (section === 'manage-subscriptions' ? 'subscriptions' : 'latest'));
    },
    
    increaseQuantity(index) {
    this.reorderData.items[index].quantity++;
    },
    
    decreaseQuantity(index) {
    if (this.reorderData.items[index].quantity > 0) {
        this.reorderData.items[index].quantity--;
    }
    },
    
    validateQuantity(index) {
    const item = this.reorderData.items[index];
    if (item.quantity < 0) item.quantity = 0;
    if (!Number.isInteger(item.quantity)) item.quantity = Math.floor(item.quantity);
    },
    
    removeItem(index) {
    this.reorderData.items[index].quantity = 0;
    },
    
    async addToCart() {
    if (this.loadingStates.addingToCart) return;
    
    const itemsToAdd = this.reorderData.items.filter(item => item.quantity > 0);
    
    if (itemsToAdd.length === 0) {
        this.errors.cart = 'Please select at least one item to add to cart.';
        return;
    }

    this.loadingStates.addingToCart = true;
    this.errors.cart = '';

    try {
        // Add items one by one to handle partial failures
        const successfulItems = [];
        const failedItems = [];

        for (const item of itemsToAdd) {
        try {
            const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                items: [{
                id: item.variantId,
                quantity: item.quantity
                }]
            })
            });

            if (response.ok) {
            successfulItems.push(item);
            } else {
            const errorData = await response.json();
            failedItems.push({
                item: item,
                error: errorData.message || errorData.description || 'Out of stock'
            });
            }
        } catch (err) {
            failedItems.push({
            item: item,
            error: 'Failed to add item'
            });
        }
        }

        // Show results
        if (successfulItems.length > 0) {
        const totalQuantity = successfulItems.reduce((sum, item) => sum + item.quantity, 0);
        
        let message = `Successfully added ${totalQuantity} ${totalQuantity === 1 ? 'item' : 'items'} to your cart.`;
        let details = null;
        
        // Add failed items info if any
        if (failedItems.length > 0) {
            details = `<div class="space-y-2">
            <p class="font-semibold text-orange-800">⚠️ Unable to add ${failedItems.length} ${failedItems.length === 1 ? 'item' : 'items'}:</p>
            <ul class="list-none space-y-1">`;
            
            failedItems.forEach(failed => {
            const itemName = failed.item.title || failed.item.productTitle || 'Unknown item';
            details += `<li class="text-sm"><strong>•</strong> ${itemName}: <span class="text-gray-600">${failed.error}</span></li>`;
            });
            
            details += `</ul></div>`;
        }
        
        this.showSuccess(
            failedItems.length > 0 ? '🛒 Partially Added to Cart' : '🛒 Items Added to Cart!',
            message,
            details
        );
        
        // Set flag to redirect after modal closes (only if all items were added)
        if (failedItems.length === 0) {
            this.redirectToCartAfterModal = true;
            this.cancelReorder();
        }
        } else {
        // All items failed
        let errorMessage = 'Unable to add any items to cart:\n';
        failedItems.forEach(failed => {
            const itemName = failed.item.title || failed.item.productTitle || 'Unknown item';
            errorMessage += `\n• ${itemName}: ${failed.error}`;
        });
        this.errors.cart = errorMessage;
        }
    } catch (error) {
        console.error('Error adding to cart:', error);
        this.errors.cart = error.message || 'There was an error adding items to your cart. Please try again.';
    } finally {
        this.loadingStates.addingToCart = false;
    }
    },

    // Order details toggle functionality
    toggleOrderDetails(orderId) {
    if (this.orderDetailsExpanded[orderId]) {
        delete this.orderDetailsExpanded[orderId];
    } else {
        this.orderDetailsExpanded[orderId] = true;
    }
    },

    // Tracking functionality
    toggleTracking(orderId) {
    // In Vue 3, we can directly assign to reactive objects
    if (this.trackingData.showTracking[orderId]) {
        delete this.trackingData.showTracking[orderId];
    } else {
        this.trackingData.showTracking[orderId] = true;
    }
    },

    toggleTrackingEvents(orderId, trackingNumber) {
    const key = `${orderId}-${trackingNumber}`;
    
    if (this.trackingData.showEvents[key]) {
        // Create a new object to trigger reactivity
        const newShowEvents = { ...this.trackingData.showEvents };
        delete newShowEvents[key];
        this.trackingData.showEvents = newShowEvents;
    } else {
        // Create a new object to trigger reactivity
        this.trackingData.showEvents = {
        ...this.trackingData.showEvents,
        [key]: true
        };
    }
    },

    closeTrackingEvents(key) {
    const newShowEvents = { ...this.trackingData.showEvents };
    delete newShowEvents[key];
    this.trackingData.showEvents = newShowEvents;
    },

    getTrackingEvents(key) {
    console.log('🔍 getTrackingEvents called with key:', key);
    
    // Special handling for 'last-order' keys
    let orderId, trackingNumber;
    if (key.startsWith('last-order-')) {
        orderId = 'last-order';
        trackingNumber = key.substring('last-order-'.length);
    } else {
        const parts = key.split('-');
        orderId = parts[0];
        trackingNumber = parts.slice(1).join('-');
    }
    console.log('📋 Parsed key:', { orderId, trackingNumber });

    // Find the tracking info based on the key
    let orders = [];
    if (orderId === 'last-order') {
        // Handle 'last-order' case
        orders = this.lastOrder ? [this.lastOrder] : [];
        console.log('📦 Using lastOrder, found:', !!this.lastOrder);
    } else {
        // Handle order history case - find order by name
        const targetOrder = this.orderHistory.find(order => order.name === orderId);
        orders = targetOrder ? [targetOrder] : [];
        console.log('📦 Searching order history for:', orderId, 'found:', !!targetOrder);
    }
    
    console.log('🔍 Searching through orders:', orders.length);
    for (const order of orders) {
        console.log('📦 Checking order:', order.name, 'trackingInfo count:', order.trackingInfo?.length || 0);
        if (order.trackingInfo) {
        for (const tracking of order.trackingInfo) {
            console.log('🔍 Checking tracking:', tracking.number, 'vs target:', trackingNumber);
            if (tracking.number === trackingNumber) {
            console.log('✅ Found matching tracking info:', {
                number: tracking.number,
                company: tracking.company,
                eventsCount: tracking.events?.length || 0,
                events: tracking.events
            });
            // Sort events in descending order (newest first) and return the tracking object
            const sortedTracking = { ...tracking };
            if (sortedTracking.events && sortedTracking.events.length > 0) {
                sortedTracking.events = [...sortedTracking.events].sort((a, b) => {
                const dateA = new Date(a.happenedAt || 0);
                const dateB = new Date(b.happenedAt || 0);
                return dateB - dateA; // Descending order (newest first)
                });
            }
            return sortedTracking;
            }
        }
        }
    }
    
    console.log('❌ No matching tracking found for key:', key);
    return null;
    },

    // Status color functions
    getFulfillmentStatusClass(status) {
    switch(status?.toUpperCase()) {
        case 'FULFILLED':
        return 'text-white';
        case 'PARTIALLY_FULFILLED':
        return 'bg-yellow-100 text-yellow-800';
        case 'UNFULFILLED':
        return 'bg-gray-100 text-gray-800';
        case 'PENDING':
        return 'bg-blue-100 text-blue-800';
        case 'IN_PROGRESS':
        return 'bg-orange-100 text-orange-800';
        default:
        return 'bg-gray-100 text-gray-800';
    }
    },

    getFinancialStatusClass(status) {
    switch(status?.toUpperCase()) {
        case 'PAID':
        return 'text-white';
        case 'PENDING':
        return 'bg-yellow-100 text-yellow-800';
        case 'PARTIALLY_PAID':
        return 'bg-orange-100 text-orange-800';
        case 'REFUNDED':
        return 'text-refunded';
        case 'VOIDED':
        return 'bg-red-100 text-red-800';
        case 'AUTHORIZED':
        return 'bg-blue-100 text-blue-800';
        case 'PARTIALLY_REFUNDED':
        return 'bg-pink-100 text-pink-800';
        default:
        return 'bg-gray-100 text-gray-800';
    }
    },

    // Shipment status styling and formatting
    getShipmentStatusClass(status) {
    switch(status?.toUpperCase()) {
        case 'DELIVERED':
        return 'text-white';
        case 'OUT_FOR_DELIVERY':
        return 'bg-blue-100 text-blue-800';
        case 'IN_TRANSIT':
        return 'bg-yellow-100 text-yellow-800';
        case 'READY_FOR_PICKUP':
        return 'bg-purple-100 text-purple-800';
        case 'PICKED_UP':
        return 'bg-indigo-100 text-indigo-800';
        case 'LABEL_PRINTED':
        return 'bg-gray-100 text-gray-800';
        case 'ATTEMPTED_DELIVERY':
        return 'bg-orange-100 text-orange-800';
        case 'ERROR':
        return 'bg-red-100 text-red-800';
        case 'FAILURE':
        return 'bg-red-100 text-red-800';
        default:
        return 'bg-gray-100 text-gray-800';
    }
    },

    formatShipmentStatus(status) {
    if (!status) return '';
    
    const statusMap = {
        'DELIVERED': 'Delivered',
        'OUT_FOR_DELIVERY': 'Out for Delivery',
        'IN_TRANSIT': 'In Transit',
        'READY_FOR_PICKUP': 'Ready for Pickup',
        'PICKED_UP': 'Picked Up',
        'LABEL_PRINTED': 'Label Printed',
        'ATTEMPTED_DELIVERY': 'Delivery Attempted',
        'ERROR': 'Error',
        'FAILURE': 'Delivery Failed'
    };
    
    return statusMap[status.toUpperCase()] || status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    },

    // Helper function to check if package is delivered
    isDelivered(status) {
    return status?.toUpperCase() === 'DELIVERED';
    },

    // Check if order is actually delivered based on tracking info
    isOrderActuallyDelivered(order) {
      if (!order) {
        return false;
      }
      
      // First check: Look for "delivered" tag (for older orders without tracking events)
      if (order.tags) {
        const tags = Array.isArray(order.tags) ? order.tags : [order.tags];
        const hasDeliveredTag = tags.some(tag => {
          const tagStr = String(tag).toLowerCase();
          return tagStr === 'delivered' || tagStr.includes('delivered');
        });
        
        if (hasDeliveredTag) {
          return true;
        }
      }
      
      // Second check: Look at tracking info if available
      if (!order.trackingInfo || order.trackingInfo.length === 0) {
        return false;
      }
      
      // Check if any tracking info shows delivered status
      return order.trackingInfo.some(tracking => {
        // Check shipmentStatus
        if (tracking.shipmentStatus && tracking.shipmentStatus.toUpperCase() === 'DELIVERED') {
          return true;
        }
        
        // Check events for delivery confirmation
        if (tracking.events && tracking.events.length > 0) {
          return tracking.events.some(event => {
            const eventText = (event.status || event.message || '').toUpperCase();
            return eventText.includes('DELIVERED');
          });
        }
        
        return false;
      });
    },

    // Get display message for tracking event with fallback to custom messages
    getEventDisplayMessage(event) {
      // If event has a message, use it
      if (event.message && event.message.trim() !== '') {
        return event.message;
      }
      
      // If no message but has status, provide custom message based on status
      if (event.status) {
        const status = event.status.toUpperCase().trim();
        
        // Map status codes to user-friendly messages
        const statusMessages = {
          //'IN_TRANSIT': 'Package is in transit',
          'OUT_FOR_DELIVERY': 'Out for Delivery',
          'DELIVERED': 'Delivered',
          //'PICKED_UP': 'Package picked up by carrier',
          //'LABEL_PRINTED': 'Shipping label printed',
          //'ATTEMPTED_DELIVERY': 'Delivery was attempted',
          //'AVAILABLE_FOR_PICKUP': 'Package is available for pickup',
          //'CONFIRMED': 'Shipment confirmed',
          //'FAILURE': 'Delivery issue occurred',
          //'DEPARTED': 'Package departed facility',
          //'ARRIVED': 'Package arrived at facility',
          //'ORIGIN_SCAN': 'Package scanned at origin',
        };
        
        // Return custom message if we have one for this status
        if (statusMessages[status]) {
          return statusMessages[status];
        }
        
        // Otherwise, format the status nicely (replace underscores with spaces, title case)
        return status
          .replace(/_/g, ' ')
          .toLowerCase()
          .replace(/\b\w/g, char => char.toUpperCase());
      }
      
      // Final fallback if neither message nor status exists
      return 'Status update';
    },

    // Get timeline dot color based on event status and position
    getEventDotClass(event, index) {
    // Most recent event (index 0) gets special highlighting
    if (index === 0) {
        const eventText = (event.message || event.status || '').toUpperCase();
        if (eventText.includes('DELIVERED') || eventText.includes('DELIVERY')) {
            return 'bg-tracking-delivered'; // Delivered - green #6E7A4E
        }
        return 'bg-tracking-transit'; // Current/latest status - teal #3E7485
    }
    
    // Color based on event status/message
    const eventText = (event.message || event.status || '').toUpperCase();
    
    if (eventText.includes('DELIVERED') || eventText.includes('DELIVERY')) {
        return 'bg-tracking-delivered'; // Delivered - green #6E7A4E
    } else if (eventText.includes('OUT FOR DELIVERY') || eventText.includes('OUT_FOR_DELIVERY')) {
        return 'bg-tracking-transit'; // Out for delivery - teal #3E7485
    } else if (eventText.includes('IN TRANSIT') || eventText.includes('IN_TRANSIT')) {
        return 'bg-yellow-500';
    } else if (eventText.includes('DEPARTED') || eventText.includes('ARRIVED')) {
        return 'bg-purple-400';
    } else if (eventText.includes('PICKED UP') || eventText.includes('ORIGIN SCAN')) {
        return 'bg-indigo-400';
    }
    
    // Default for older events
    return 'bg-gray-300';
    },

    // Date and time formatting for Amazon-style timeline
    formatTime(dateString) {
    if (!dateString) return '';
    try {
        const date = new Date(dateString);
        return date.toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        minute: '2-digit',
        hour12: true
        });
    } catch (e) {
        console.log('Time parsing error:', e);
        return '';
    }
    },

    formatDateHeader(dateString) {
    if (!dateString) return 'Unknown date';
    try {
        const date = new Date(dateString);
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        
        if (date.toDateString() === today.toDateString()) {
        return 'Today';
        } else if (date.toDateString() === yesterday.toDateString()) {
        return 'Yesterday';
        } else {
        return date.toLocaleDateString('en-US', { 
            weekday: 'long',
            month: 'long', 
            day: 'numeric', 
            year: 'numeric' 
        });
        }
    } catch (e) {
        console.log('Date header parsing error:', e);
        return dateString;
    }
    },

    // Group tracking events by date for Amazon-style timeline
    getGroupedEventsByDate(trackingKey) {
    const trackingData = this.getTrackingEvents(trackingKey);
    if (!trackingData || !trackingData.events) {
        return {};
    }

    const grouped = {};
    trackingData.events.forEach(event => {
        if (event.happenedAt) {
        try {
            const date = new Date(event.happenedAt);
            const dateKey = date.toDateString();
            
            if (!grouped[dateKey]) {
            grouped[dateKey] = [];
            }
            grouped[dateKey].push(event);
        } catch (e) {
            console.log('Event date parsing error:', e);
        }
        }
    });

    // Sort events within each date by time (newest first)
    Object.keys(grouped).forEach(dateKey => {
        grouped[dateKey].sort((a, b) => new Date(b.happenedAt) - new Date(a.happenedAt));
    });

    // Return grouped events sorted by date (newest first)
    const sortedGrouped = {};
    const sortedDates = Object.keys(grouped).sort((a, b) => new Date(b) - new Date(a));
    
    sortedDates.forEach(date => {
        sortedGrouped[date] = grouped[date];
    });

    return sortedGrouped;
    },

    // Get global event index for proper color coding across date groups
    getEventGlobalIndex(trackingKey, date, localIndex) {
    const trackingData = this.getTrackingEvents(trackingKey);
    if (!trackingData || !trackingData.events) {
        return localIndex;
    }

    // Find the global index by counting all events before this date + local index
    let globalIndex = 0;
    const sortedDates = Object.keys(this.getGroupedEventsByDate(trackingKey))
        .sort((a, b) => new Date(b) - new Date(a));
    
    for (const sortedDate of sortedDates) {
        if (sortedDate === date) {
        return globalIndex + localIndex;
        }
        globalIndex += this.getGroupedEventsByDate(trackingKey)[sortedDate].length;
    }
    
    return localIndex;
    },

    // Amazon-style progress bar methods
    getProgressStepClass(tracking, step, order = null) {
    const currentStep = this.getCurrentProgressStep(tracking, order);
    
    if (step <= currentStep) {
        return 'bg-green-500'; // Completed steps
    } else if (step === currentStep + 1) {
        return 'bg-blue-500'; // Current step
    } else {
        return 'bg-gray-300'; // Future steps
    }
    },

    getProgressLineClass(tracking, step, order = null) {
    const currentStep = this.getCurrentProgressStep(tracking, order);
    
    if (step < currentStep) {
        return 'bg-green-500'; // Completed connections
    } else if (step === currentStep) {
        return 'bg-blue-500'; // Current connection
    } else {
        return 'bg-gray-300'; // Future connections
    }
    },

    getCurrentProgressStep(tracking, order = null) {
    // First, check if order has a "delivered" tag (for older orders without tracking events)
    if (order && order.tags) {
        const tags = Array.isArray(order.tags) ? order.tags : [order.tags];
        const hasDeliveredTag = tags.some(tag => {
          const tagStr = String(tag).toLowerCase();
          return tagStr === 'delivered' || tagStr.includes('delivered');
        });
        
        if (hasDeliveredTag) {
          return 4; // Delivered
        }
    }
    
    // Check tracking status if available
    if (!tracking || !tracking.shipmentStatus) {
        return 1; // Default to "Order Placed"
    }

    const status = tracking.shipmentStatus.toUpperCase();
    
    // Step 4: Delivered
    if (status.includes('DELIVERED')) {
        return 4;
    }
    
    // Step 3: Out for Delivery
    if (status.includes('OUT_FOR_DELIVERY') || status.includes('OUT FOR DELIVERY')) {
        return 3;
    }
    
    // Step 2: Shipped/In Transit
    if (status.includes('IN_TRANSIT') || status.includes('SHIPPED') || 
        status.includes('PICKED_UP') || status.includes('LABEL_PRINTED')) {
        return 2;
    }
    
    // Step 1: Order Placed (default)
    return 1;
    },

    // Amazon-style status header above progress bar
    getProgressStatusHeader(tracking, order = null) {
    // First, check if order has a "delivered" tag (for older orders without tracking events)
    if (order && order.tags) {
        const tags = Array.isArray(order.tags) ? order.tags : [order.tags];
        const hasDeliveredTag = tags.some(tag => {
          const tagStr = String(tag).toLowerCase();
          return tagStr === 'delivered' || tagStr.includes('delivered');
        });
        
        if (hasDeliveredTag) {
          return 'Package Delivered';
        }
    }
    
    // Check tracking status if available
    if (!tracking || !tracking.shipmentStatus) {
        return 'Ordered';
    }

    const status = tracking.shipmentStatus.toUpperCase();
    
    // Step 4: Delivered
    if (status.includes('DELIVERED')) {
        return 'Package Delivered';
    }
    
    // Step 3: Out for Delivery
    if (status.includes('OUT_FOR_DELIVERY') || status.includes('OUT FOR DELIVERY')) {
        return 'Out for Delivery';
    }
    
    // Step 2: Shipped/In Transit
    if (status.includes('IN_TRANSIT')) {
        return 'Package in Transit';
    }
    
    if (status.includes('SHIPPED') || status.includes('PICKED_UP')) {
        return 'Package Shipped';
    }
    
    if (status.includes('LABEL_PRINTED')) {
        return 'Shipping Label Created';
    }
    
    // Step 1: Order Placed (default)
    return 'Ordered';
    },

    /**
     * Check if a subscription group is cancelled (all subscriptions in group are cancelled)
     */
    isGroupCancelled(group) {
        if (!group || !group.subscriptions || group.subscriptions.length === 0) {
            return false;
        }
        
        // Check if ALL subscriptions in the group have CANCELLED or cancelled status
        return group.subscriptions.every(subscription => 
            subscription.status === 'CANCELLED' || subscription.status === 'cancelled'
        );
    },

    /**
     * Get the effective status for a group (prioritizes cancelled status)
     */
    getGroupEffectiveStatus(group) {
        const isCancelled = this.isGroupCancelled(group);
        const effectiveStatus = isCancelled ? 'CANCELLED' : (group.status || 'ACTIVE');
        
        // Debug logging
        if (this.isDeveloper) {
            console.log('Group status debug:', {
                groupKey: group.key,
                originalStatus: group.status,
                isCancelled: isCancelled,
                effectiveStatus: effectiveStatus,
                subscriptions: group.subscriptions?.map(s => ({ id: s.id, status: s.status }))
            });
        }
        
        return effectiveStatus;
    },

    /**
     * Update subscription button visibility based on loaded data
     */
    updateSubscriptionButtonVisibility() {
        const serverButton = document.getElementById('manage-subscriptions-tab-server');
        const dynamicButton = document.getElementById('manage-subscriptions-tab-dynamic');
        const groupsButton = document.getElementById('manage-subscriptions-tab-groups');
        
        // Check if we're currently on manage-subscriptions page
        const currentSection = new URLSearchParams(window.location.search).get("section");
        const isActiveTab = currentSection === "manage-subscriptions";
        
        // Hide server-side button once data is loaded
        if (serverButton) {
            serverButton.style.display = 'none';
            // Remove active class from server button
            serverButton.classList.remove("active");
        }
        
        // Show appropriate button based on data
        if (this.subscriptions.length > 0) {
            if (dynamicButton) {
                dynamicButton.style.display = 'block';
                if (isActiveTab) dynamicButton.classList.add("active");
            }
            // Hide other buttons
            if (groupsButton) {
                groupsButton.style.display = 'none';
                groupsButton.classList.remove("active");
            }
            console.log('Showing subscription button: subscriptions found:', this.subscriptions.length);
        } else if (this.subscriptionGaroups.length > 0) {
            if (groupsButton) {
                groupsButton.style.display = 'block';
                if (isActiveTab) groupsButton.classList.add("active");
            }
            // Hide other buttons
            if (dynamicButton) {
                dynamicButton.style.display = 'none';
                dynasvmicButton.classList.remove("active");
            }
            console.log('Showing subscription button: subscription groups found:', this.subscriptionGroups.length);
        } else {
            console.log('No subscriptions found, keeping server-side button if present');
            // Show server button again if no data found
            if (serverButton) {
                serverButton.style.display = 'block';
                if (isActiveTab) serverButton.classList.add("active");
            }
            // Hide other buttons
            if (dynamicButton) {
                dynamicButton.style.display = 'none';
                dynamicButton.classList.remove("active");
            }
            if (groupsButton) {
                groupsButton.style.display = 'none';
                groupsButton.classList.remove("active");
            }
        }
    }

}
});

// Mount the app and expose it globally for debugging
const vueApp = app.mount('#app');
window.vueApp = vueApp;